const Library_mobile_ru = {
  "processor": [
    {
      "contentType": "OTHER_PROCESSORS",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "На базе процессора [cpuDisplay]"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHER_PROCESSORS_A",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "На базе процессора [cpuDisplay]"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "FALLBACK_PROCESSOR",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "Подобно тому, как мозг контролирует процессы в организме человека, процессор контролирует все операции ПК. Это значит, что все действия начинаются с процессора — просмотр видео, игры или доступ в Интернет.",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Процессор — это «мозг» вашего ПК"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHER_OLD_PROCESSORS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_title": "Производительность по доступной цене.",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "titleArray": [
                  {
                    "tr_title": "",
                    "tr_pretitle": "Процессор Intel® Pentium® Silver",
                    "tr_subtitle": "Сохраняйте лидерство в цифровом мире благодаря производительности, достаточной для доступа к файлам через Интернет. Работайте в режиме многозадачности и легко переключайтесь между программами, чтобы успевать больше за меньшее время.",
                    "tr_gen_core_title": "Процессор Intel® Pentium® Silver"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "Процессор Intel® Pentium® Gold",
                    "tr_subtitle": "Улучшенная продуктивность&nbsp;— повышенная производительность для выполнения самых ресурсоемких задач. Ускоренный просмотр веб-страниц — быстрая загрузка мультимедийных веб-страниц, чтобы больше исследовать и меньше ждать.",
                    "tr_gen_core_title": "Процессор Intel® Pentium® Gold"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "Процессор Intel® Celeron®",
                    "tr_subtitle": "Производительность для эффективной поддержки вашей работы и развлечений. Потрясающая детализация фильмов и онлайн-видео. Успевайте сделать больше, не&nbsp;теряя время на ожидание.",
                    "tr_gen_core_title": "Процессор Intel® Celeron®"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "Процессор Intel® Pentium®",
                    "tr_subtitle": "Создан для отличных развлечений, трансляции видео и продуктивной работы. Потрясающая детализация фильмов и онлайн-видео. Успевайте сделать больше, не&nbsp;теряя время на ожидание.",
                    "tr_gen_core_title": "Процессор Intel® Pentium®"
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_1.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_1.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CELERON_2.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_2.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_INSIDE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/intel_inside/intel_inside_processor_badge.svg",
                "tileBG": "assets/images/intel_inside/intel_inside_home_tile.svg",
                "detailBGUrl": "assets/images/intel_inside/panel1_bg.svg",
                "tr_subtitle": "Необходимая вам производительность. Желаемая доступность.",
                "tr_title": "Процессор Intel®",
                "panelType1": "header-IconTop",
                "panelType2": "intel-inside-image-panel",
                "titleArray": [
                  {
                    "tr_title": "",
                    "tr_pretitle": "Несравнимая цена",
                    "tr_subtitle": "Процессор Intel® может справиться практически с любой задачей по доступной цене. Легко переходите от одного программного обеспечения к другому. Или наслаждайтесь высококачественной графикой со стабильной производительностью.",
                    "imageUrl": "assets/images/intel_inside/panel2_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "Качественное подключение",
                    "tr_subtitle": "Яркое изображение и высокое качество видео, насыщенный звук и почти в 3 раза более быстрое подключение к Интернету делают работу еще более удобной <sup>26</sup>.",
                    "imageUrl": "assets/images/intel_inside/panel3_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "С утра до ночи",
                    "tr_subtitle": "Утром — просмотр фильмов, вечером — последние штрихи перед сдачей файлов на работе… Благодаря процессору Intel® вам не придется прерываться на подзарядку: он продлевает время автономной работы вашего устройства, чем бы вы ни занимались в течение дня.",
                    "imageUrl": "assets/images/intel_inside/panel4_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "imageUrl": "assets/images/intel_inside/panel5_bg.svg",
                    "tr_pretitle": "Знания повсюду",
                    "tr_subtitle": "Легко пользуйтесь различными инструментами для онлайн-обучения везде, где вам удобно."
                  },
                  {
                    "tr_title": "",
                    "imageUrl": "assets/images/intel_inside/panel5_bg.svg",
                    "tr_pretitle": "Свобода в обучении",
                    "tr_subtitle": "Работайте с несколькими инструментами для обучения сразу, даже если вы не в классе."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CELERON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CELERON_3.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Получите возможности для развлечений и продуктивной работы, соответствующие вашему бюджету и образу жизни.",
                "tr_title": "Производительность Intel для любого бюджета.",
                "tr_gen_core_title": "Процессор Intel® Celeron®",
                "processorCompare": {
                  "tr_title": "ВЫБЕРИТЕ ПОДХОДЯЩИЙ УРОВЕНЬ ПРОИЗВОДИТЕЛЬНОСТИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CELERON_3.svg",
                      "tr_imgCaption": "Процессор Intel® Celeron®"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "Процессор Intel® Pentium® Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Просмотр видео и прослушивание музыки онлайн",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Переключение между программами",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Простые игры",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляции в 4K-разрешении",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Простое редактирование фотографий и видео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Интеллектуальное увеличение производительности",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "7GEN_BELOW_PROCESSOR",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/[cup_badge].svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "genType": "7Gen",
                    "tr_title": "На базе процессора Intel® Core™ [cpu_fam] 7-го поколения"
                  },
                  {
                    "genType": "6Gen",
                    "tr_title": "На базе процессора Intel® Core™ [cpu_fam] 6-го поколения"
                  },
                  {
                    "genType": "5Gen",
                    "tr_title": "На базе процессора Intel® Core™ [cpu_fam] 5-го поколения"
                  },
                  {
                    "genType": "4Gen",
                    "tr_title": "На базе процессора Intel® Core™ [cpu_fam] 4-го поколения"
                  },
                  {
                    "genType": "3Gen",
                    "tr_title": "На базе процессора Intel® Core™ [cpu_fam] 3-го поколения"
                  },
                  {
                    "genType": "2Gen",
                    "tr_title": "На базе процессора Intel® Core™ [cpu_fam] 2-го поколения"
                  },
                  {
                    "genType": "1Gen",
                    "tr_title": "На базе процессора Intel® Core™ [cpu_fam] 1-го поколения"
                  }
                ],
                "processorCompare": {
                  "tr_title": "",
                  "background": "",
                  "tr_tableHead": [
                    "Рекомендовано для:",
                    "<span><img src=></span>",
                    "<span><img src=></span>"
                  ],
                  "tabletr": [
                    {
                      "tr_row": "",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_6.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "На базе процессора Intel® Core™ i3 8-го поколения",
                "tr_gen_core_title": "Процессор Intel® Core™ i3 8-го&nbsp;поколения"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процессоры Intel® Core™ 9-го поколения созданы, чтобы соответствовать возможностям цифрового мира. Обладая&nbsp;высокой производительностью, вы&nbsp;сможете сделать все, что пожелаете, без компромиссов.",
                "tr_title": "На базе процессора Intel®&nbsp;Core™&nbsp;i3 9&#8209;го&nbsp;поколения",
                "tr_gen_core_title": "Процессор Intel® Core™ i3 9-го&nbsp;поколения"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Универсальная производительность и длительное время автономной работы позволят вам работать непрерывно.",
                "tr_title": "Заряд на весь день",
                "tr_gen_core_title": "Процессор Intel® Core™ i3 10&#8209;го поколения",
                "processorCompare": {
                  "tr_title": "ВЫБЕРИТЕ ПОДХОДЯЩИЙ УРОВЕНЬ ПРОИЗВОДИТЕЛЬНОСТИ 10&#8209;ГО&nbsp;ПОКОЛЕНИЯ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i3"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Потоковая трансляция фильмов в разрешении 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Быстрое и надежное подключение",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Наложение масок на фото и фильтров на видео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Игры с разрешением 1080p и высокой частотой кадров",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Работа с большими файлами и программами для творчества",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Легко переключайтесь между просмотром фильмов и созданием презентаций благодаря высокой производительности.",
                "tr_title": "Заряд на весь день",
                "tr_gen_core_title": "Процессор Intel® Core™ i3 10&#8209;го поколения"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбук, созданный специально для тех, кто всегда в движении.",
                "tr_title": "Встречайте ноутбуки нового класса",
                "tr_gen_core_title": "Процессор Intel® Core™ i3 10&#8209;го поколения"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Созданный специально для портативных ПК, процессор Intel® Core™ i3 11-го поколения позволяет успевать больше, где бы вы ни находились.",
                "tr_title": "Ваш ноутбук способен на большее",
                "tr_gen_core_title": "Процессор Intel® Core™ i3 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i3 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "Если все члены вашей семьи используют один настольный ПК для решения своих задач, используйте процессор Intel® Core™ i3 11-го поколения с высокой производительностью и широкими возможностями.",
                "tr_title": "Решайте любые задачи благодаря революционной производительности.",
                "tr_gen_core_title": "Процессор Intel® Core™ i3 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i3 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_6.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "На базе процессора Intel® Core™ i5 8-го поколения",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 8-го&nbsp;поколения"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процессоры Intel® Core™ 9-го поколения созданы, чтобы соответствовать возможностям цифрового мира. Обладая&nbsp;высокой производительностью, вы&nbsp;сможете сделать все, что пожелаете, без компромиссов.",
                "tr_title": "На базе процессора Intel® Core™ i5 9-го&nbsp;поколения",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 9-го&nbsp;поколения"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ПЛАВНЫЙ ИГРОВОЙ ПРОЦЕСС И ВИРТУАЛЬНАЯ РЕАЛЬНОСТЬ В САМЫХ РЕСУРСОЕМКИХ ИГРАХ",
                "tr_title": "Здесь начинаются серьезные игры",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 9-го&nbsp;поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Игры ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Играйте, транслируйте и записывайте без компромиссов",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Лучший процессор Intel® Core™ 9-го поколения для игр",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоков: 8</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Легко переключайтесь между программами и будьте готовы ко&nbsp;всему, где бы вы ни оказались.",
                "tr_title": "Мобильная многозадачность",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 10&#8209;го поколения",
                "processorCompare": {
                  "tr_title": "ВЫБЕРИТЕ ПОДХОДЯЩИЙ УРОВЕНЬ ПРОИЗВОДИТЕЛЬНОСТИ 10&#8209;ГО&nbsp;ПОКОЛЕНИЯ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i3"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Потоковая трансляция фильмов в разрешении 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Быстрое и надежное подключение",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Наложение масок на фото и фильтров на видео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Игры с разрешением 1080p и высокой частотой кадров",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Работа с большими файлами и программами для творчества",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Выведите производительность на новый уровень, будь то развлечения, работа в офисных приложениях или создание контента.",
                "tr_title": "Переходите на более мощный ПК",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 10&#8209;го поколения"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбук, созданный специально для тех, кто всегда в движении.",
                "tr_title": "Встречайте ноутбуки нового класса",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 10&#8209;го поколения"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Создан для стабильной трансляции и игр AAA-класса",
                "tr_title": "Игры по вашим правилам",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 10&#8209;го поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ 10-ГО ПОКОЛЕНИЯ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Стабильный гейминг в играх ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Потоковая трансляция",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляция и запись",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Новый уровень создания контента",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Максимальная производительность в играх",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "Разблокированный множитель и возможность оверклокинга<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Создан для стабильной трансляции и игр AAA-класса",
                "tr_title": "Игры по вашим правилам",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 10&#8209;го поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ 10-ГО ПОКОЛЕНИЯ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Стабильный гейминг в играх ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Потоковая трансляция",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляция и запись",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Новый уровень создания контента",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Максимальная производительность в играх",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "Разблокированный множитель и возможность оверклокинга<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,8&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 10<br/>Потоков: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Легко переключайтесь между программами и будьте готовы ко&nbsp;всему, где бы вы ни оказались.",
                "tr_title": "Мобильная многозадачность",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 10&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 10-ГО ПОКОЛЕНИЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Процессор Intel® Core™ i5 11-го&nbsp;поколения обеспечивает потрясающее качество изображения и широкий диапазон производительности на тонких и легких ПК.",
                "tr_title": "Впечатляющая мощность ноутбука",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/i5_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "Если все члены вашей семьи используют один настольный ПК для решения своих задач, используйте процессор Intel® Core™ i5 11-го поколения с высокой производительностью и широкими возможностями.",
                "tr_title": "Решайте любые задачи благодаря революционной производительности.",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/i5_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процессор Intel® Core™ i5 11&#8209;го&nbsp;поколения&nbsp;обеспечивает потрясающее качество изображения и широкий диапазон производительности на тонких и легких ноутбуках.",
                "tr_title": "Впечатляющая мощность ноутбука",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 11-ГО ПОКОЛЕНИЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_6.svg",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "tr_title": "Процессор Intel® Core™ i7 8-го поколения",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 8-го&nbsp;поколения"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "Процессоры Intel® Core™ 9-го поколения созданы, чтобы соответствовать возможностям цифрового мира. Обладая&nbsp;высокой производительностью, вы&nbsp;сможете сделать все, что пожелаете, без компромиссов.",
                "tr_title": "На базе процессора Intel® Core™ i7 9-го&nbsp;поколения",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 9-го&nbsp;поколения"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ДО 32% ВЫШЕ частота кадров во время игр, трансляции и записи по сравнению с 3-ЛЕТНИМ ПК<sup>3</sup>",
                "tr_title": "Возможность делиться величайшими игровыми моментами",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 9-го&nbsp;поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_7.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Игры ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Играйте, транслируйте и записывайте без компромиссов",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Лучший процессор Intel® Core™ 9-го поколения для игр",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоков: 8</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Этот стильный ноутбук создан для стримов и эффективной работы с целью преумножить ваши творческие возможности.",
                "tr_title": "Высокая производитель&shy;ность, где бы вы ни находились",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 10&#8209;го поколения",
                "processorCompare": {
                  "tr_title": "ВЫБЕРИТЕ ПОДХОДЯЩИЙ УРОВЕНЬ ПРОИЗВОДИТЕЛЬНОСТИ 10&#8209;ГО&nbsp;ПОКОЛЕНИЯ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i3"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Потоковая трансляция фильмов в разрешении 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Быстрое и надежное подключение",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Наложение масок на фото и фильтров на видео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Игры с разрешением 1080p и высокой частотой кадров",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Работа с большими файлами и программами для творчества",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Высокая производительность для оптимизации ваших задач.",
                "tr_title": "Мощность для любых задач",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 10&#8209;го поколения"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбук, созданный специально для тех, кто всегда в движении.",
                "tr_title": "Встречайте ноутбуки нового класса",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 10&#8209;го поколения"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Получите конкурентное преимущество в играх, трансляции и записи",
                "tr_title": "Погрузитесь в мир гейминга",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 10&#8209;го поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ 10-ГО ПОКОЛЕНИЯ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Стабильный гейминг в играх ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Потоковая трансляция",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляция и запись",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Новый уровень создания контента",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Максимальная производительность в играх",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "Разблокированный множитель и возможность оверклокинга<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Получите конкурентное преимущество в играх, трансляции и записи",
                "tr_title": "Погрузитесь в мир гейминга",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 10&#8209;го поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ 10-ГО ПОКОЛЕНИЯ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Стабильный гейминг в играх ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Потоковая трансляция",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляция и запись",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Новый уровень создания контента",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Максимальная производительность в играх",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "Разблокированный множитель и возможность оверклокинга<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,8&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 10<br/>Потоков: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Этот стильный ноутбук создан для стримов и эффективной работы с целью преумножить ваши творческие возможности.",
                "tr_title": "Высокая производительность в любых условиях",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 10&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 10-ГО ПОКОЛЕНИЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Процессор Intel® Core™ i7 11&#8209;го&nbsp;поколения обеспечивает расширенные возможности для игр, развлечений и создания контента на ультрапортативных ПК.",
                "tr_title": "Революционная производитель&shy;ность ноутбука",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/i7_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "Сделайте свой настольный ПК идеальным инструментом для&nbsp;дома&nbsp;благодаря революционной производительности процессора Intel® Core™ i7 11&#8209;го&nbsp;поколения.",
                "tr_title": "Работа. Учеба. Развлечения. Без границ.",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/i7_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процессор Intel® Core™ i7 11&#8209;го&nbsp;поколения&nbsp;обеспечивает расширенные возможности для игр, развлечений и&nbsp;создания&nbsp;контента на&nbsp;тонких и&nbsp;легких ноутбуках.",
                "tr_title": "Революционная производитель&shy;ность ноутбука",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 11-ГО ПОКОЛЕНИЯ"
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Сделайте свой настольный ПК идеальным инструментом для&nbsp;дома&nbsp;благодаря революционной производительности процессора Intel® Core™ i7 11&#8209;го&nbsp;поколения.",
                "tr_title": "Безграничный простор для творчества",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 11-ГО ПОКОЛЕНИЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_1195G7",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Этот процессор Intel® Core™ i7 11-го поколения стал еще лучше благодаря расширенным возможностям для игр, развлечений и создания контента на тонких и легких ноутбуках.",
                "tr_title": "Революционная производитель&shy;ность ноутбука",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 11-ГО ПОКОЛЕНИЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "На базе процессора Intel® Core™ i9 8-го поколения",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 8-го&nbsp;поколения"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процессоры Intel® Core™ 9-го поколения созданы, чтобы соответствовать возможностям цифрового мира. Обладая&nbsp;высокой производительностью, вы&nbsp;сможете сделать все, что пожелаете, без компромиссов.",
                "tr_title": "На базе процессора Intel® Core™ i9 9-го&nbsp;поколения",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 9-го&nbsp;поколения"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ДО 41% ВЫШЕ ЧАСТОТА КАДРОВ во время игр, трансляции и записи по сравнению с 3-ЛЕТНИМ ПК<sup>4</sup>",
                "tr_title": "Геймеры требуют, Intel® Core™ i9 обеспечивает",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 9-го&nbsp;поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Игры ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Играйте, транслируйте и записывайте без компромиссов",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Лучший процессор Intel® Core™ 9-го поколения для игр",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоков: 8</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_8",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Раскройте свой потенциал благодаря максимальным игровым возможностям",
                "tr_title": "Соревнуйтесь на высшем уровне",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 10&#8209;го поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ 10-ГО ПОКОЛЕНИЯ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Стабильный гейминг в играх ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Потоковая трансляция",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляция и запись",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Новый уровень создания контента",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Максимальная производительность в играх",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "Разблокированный множитель и возможность оверклокинга<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Раскройте свой потенциал благодаря максимальным игровым возможностям",
                "tr_title": "Соревнуйтесь на высшем уровне",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 10&#8209;го поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ 10-ГО ПОКОЛЕНИЯ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Стабильный гейминг в играх ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Потоковая трансляция",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляция и запись",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Новый уровень создания контента",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Максимальная производительность в играх",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "Разблокированный множитель и возможность оверклокинга<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,8&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 10<br/>Потоков: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Раскройте свой потенциал благодаря широчайшим возможностям для творчества",
                "tr_title": "Создавайте контент на высшем уровне",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 10&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 10-ГО ПОКОЛЕНИЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/EVO_I5_5.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбуки Intel® Evo™ с процессором Intel® Core™ i5 11-го поколения и графикой Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> обеспечивают невероятную скорость и производительность в тонком и легком корпусе.",
                "tr_title": "Расширенные возможности современного ноутбука",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/evo/11gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/EVO_I7.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i7-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбуки Intel® Evo™ с процессором Intel® Core™ i7 11-го поколения и графикой Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> обеспечивают быстродействие и производительность премиум-класса в мобильных ПК.",
                "tr_title": "Впечатляющие возможности современного ноутбука",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/evo/11gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "PENTIUM_SILVER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Оцените прекрасное сочетание производительности, сетевых возможностей и мультимедиа по потрясающей цене.",
                "tr_title": "Производительность и сетевые возможности по потрясающей цене.",
                "tr_gen_core_title": "Процессор Intel® Pentium® Silver",
                "processorCompare": {
                  "tr_title": "ВЫБЕРИТЕ ПОДХОДЯЩИЙ УРОВЕНЬ ПРОИЗВОДИТЕЛЬНОСТИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                      "tr_imgCaption": "Процессор Intel® Pentium® Silver"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "Процессор Intel® Pentium® Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Просмотр видео и прослушивание музыки онлайн",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Переключение между программами",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Простые игры",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляции в 4K-разрешении",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Простое редактирование фотографий и видео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Интеллектуальное увеличение производительности",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "PENTIUM_GOLD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Оцените безупречную многозадачность, простое редактирование фото и видео, просмотр видео в 4K и реалистичную графику по невероятной цене.",
                "tr_title": "Невероятная производительность для работы и развлечений.",
                "tr_gen_core_title": "Процессор Intel® Pentium® Gold",
                "processorCompare": {
                  "tr_title": "ВЫБЕРИТЕ ПОДХОДЯЩИЙ УРОВЕНЬ ПРОИЗВОДИТЕЛЬНОСТИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                      "tr_imgCaption": "Процессор Intel® Pentium® Silver"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "Процессор Intel® Pentium® Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Просмотр видео и прослушивание музыки онлайн",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Переключение между программами",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Простые игры",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляции в 4K-разрешении",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Простое редактирование фотографий и видео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Интеллектуальное увеличение производительности",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Игры AAA-класса и длительное время автономной работы в ультрапортативном ПК. Не нужно идти на компромисс в играх.",
                "tr_title": "Не нужно идти на компромисс.",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": true
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i9",
                      "tr_badgeSubTitle": "",
                      "active": false
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "ВЫБЕРИТЕ ПРОЦЕССОР INTEL® CORE™ ДЛЯ ИГР НА НОУТБУКЕ.",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "Intel® Core™ i5&#8209;11300H 11&#8209;го поколения"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "Intel® Core™ i7&#8209;11370H 11&#8209;го поколения"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i7&#8209;11375H Special&nbsp;Edition 11&#8209;го поколения"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "Максималь&shy;ная тактовая частота до <span class='style_badge'>4,4&nbsp;ГГц</span>",
                      "tr_td2_title": "Максималь&shy;ная тактовая частота до <span class='style_badge'>4,8&nbsp;ГГц</span>",
                      "tr_td3_title": "Максималь&shy;ная тактовая частота до <span class='style_badge'>5,0&nbsp;ГГц</span>"
                    },
                    {
                      "tr_td1_title": "4 ядра/ 8&nbsp;потоков",
                      "tr_td2_title": "4 ядра/ 8&nbsp;потоков",
                      "tr_td3_title": "4 ядра/ 8&nbsp;потоков"
                    },
                    {
                      "tr_td1_title": "Технология Intel® Turbo Boost",
                      "tr_td2_title": "Технология Intel® Turbo Boost",
                      "tr_td3_title": "Технология Intel® Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "8 МБ интеллек&shy;туальной кэш-памяти Intel®",
                      "tr_td2_title": "12 МБ интеллек&shy;туальной кэш-памяти Intel®",
                      "tr_td3_title": "12 МБ интеллек&shy;туальной кэш-памяти Intel®"
                    },
                    {
                      "tr_td1_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td2_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td3_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Игры ААА-класса с разрешением 1080p и высокой частотой кадров на высоких настройках и превосходная производительность ноутбука даже в режиме работы от батареи.",
                "tr_title": "Всё и сразу.",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": true
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i9",
                      "tr_badgeSubTitle": "",
                      "active": false
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "ВЫБЕРИТЕ ПРОЦЕССОР INTEL® CORE™ ДЛЯ ИГР НА НОУТБУКЕ.",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "Intel® Core™ i5&#8209;11300H 11&#8209;го поколения"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "Intel® Core™ i7&#8209;11370H 11&#8209;го поколения"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i7&#8209;11375H Special&nbsp;Edition 11&#8209;го поколения"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "Максималь&shy;ная тактовая частота до <span class='style_badge'>4,4&nbsp;ГГц</span>",
                      "tr_td2_title": "Максималь&shy;ная тактовая частота до <span class='style_badge'>4,8&nbsp;ГГц</span>",
                      "tr_td3_title": "Максималь&shy;ная тактовая частота до <span class='style_badge'>5,0&nbsp;ГГц</span>"
                    },
                    {
                      "tr_td1_title": "4 ядра/ 8&nbsp;потоков",
                      "tr_td2_title": "4 ядра/ 8&nbsp;потоков",
                      "tr_td3_title": "4 ядра/ 8&nbsp;потоков"
                    },
                    {
                      "tr_td1_title": "Технология Intel® Turbo Boost",
                      "tr_td2_title": "Технология Intel® Turbo Boost",
                      "tr_td3_title": "Технология Intel® Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "8 МБ интеллек&shy;туальной кэш-памяти Intel®",
                      "tr_td2_title": "12 МБ интеллек&shy;туальной кэш-памяти Intel®",
                      "tr_td3_title": "12 МБ интеллек&shy;туальной кэш-памяти Intel®"
                    },
                    {
                      "tr_td1_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td2_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td3_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_SPECIAL_EDITION_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Тактовая частота до 5,0&nbsp;ГГц обеспечивает расширенные игровые возможности ноутбука в любых условиях.",
                "tr_title": "Всё и сразу",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 Special Edition 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_spcl_edition_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i7 Special Edition",
                      "tr_badgeSubTitle": "",
                      "active": true
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "ВЫБЕРИТЕ ПРОЦЕССОР INTEL® CORE™ ДЛЯ ИГР НА НОУТБУКЕ.",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "Intel® Core™ i5&#8209;11300H 11&#8209;го поколения"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "Intel® Core™ i7&#8209;11370H 11&#8209;го поколения"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i7&#8209;11375H Special&nbsp;Edition 11&#8209;го поколения"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "Максималь&shy;ная тактовая частота до <span class='style_badge'>4,4&nbsp;ГГц</span>",
                      "tr_td2_title": "Максималь&shy;ная тактовая частота до <span class='style_badge'>4,8&nbsp;ГГц</span>",
                      "tr_td3_title": "Максималь&shy;ная тактовая частота до <span class='style_badge'>5,0&nbsp;ГГц</span>"
                    },
                    {
                      "tr_td1_title": "4 ядра/ 8&nbsp;потоков",
                      "tr_td2_title": "4 ядра/ 8&nbsp;потоков",
                      "tr_td3_title": "4 ядра/ 8&nbsp;потоков"
                    },
                    {
                      "tr_td1_title": "Технология Intel® Turbo Boost",
                      "tr_td2_title": "Технология Intel® Turbo Boost",
                      "tr_td3_title": "Технология Intel® Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "8 МБ интеллек&shy;туальной кэш-памяти Intel®",
                      "tr_td2_title": "12 МБ интеллек&shy;туальной кэш-памяти Intel®",
                      "tr_td3_title": "12 МБ интеллек&shy;туальной кэш-памяти Intel®"
                    },
                    {
                      "tr_td1_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td2_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td3_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процессор Intel® Core™ i7 Special Edition 11-го поколения обеспечивает новый уровень создания контента, игр и развлечений в ультрапортативных ПК.",
                "tr_title": "Революционная производитель&shy;ность ноутбука",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 Special Edition 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 SPECIAL EDITION* 11-ГО ПОКОЛЕНИЯ"
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Процессор Intel® Core™ i7 Special Edition 11-го поколения обеспечивает новый уровень создания контента, игр и развлечений в ультрапортативных ПК.",
                "tr_title": "Революционная производитель&shy;ность ноутбука",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 Special Edition 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 SPECIAL EDITION* 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_spcl_edition_gaming_tile.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i7 Special Edition",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты и большого количества ядер для получения преимущества в соревновательных играх и создании сложного контента.",
                "tr_title": "Оптимизированная мощность.",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i9",
                      "tr_badgeSubTitle": "",
                      "active": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "Правильный баланс тактовой частоты и производительности ядер позволяет раскрыть весь потенциал игр, будь то соревновательные игры с высокой частотой кадров или игры AAA-класса с эффектом погружения.",
                "tr_title": "Мощность для ваших игр.",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Играйте в ресурсоемкие игры, записывайте и транслируйте их с высокой частотой кадров, а также с легкостью переключайтесь на сложные рабочие нагрузки в режиме многозадачности.",
                "tr_title": "Расширьте границы возможного.",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты и большого количества ядер для получения преимущества в соревновательных играх и создании сложного контента.",
                "tr_title": "Оптимизированная мощность.",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_HYBRID",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Легко переключайтесь между просмотром фильмов и созданием презентаций благодаря высокой производительности.",
                "tr_title": "Заряд на весь день",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i3 с&nbsp;технологией Intel® Hybrid",
                "tr_subTitle2": "Процессор Intel®&nbsp;Core™&nbsp;i3 с&nbsp;технологией Intel® Hybrid"
              }
            },
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Универсальная производительность и длительное время автономной работы позволят вам работать непрерывно.",
                "tr_title": "Заряд на весь день",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i3 с&nbsp;технологией Intel® Hybrid",
                "tr_subTitle2": "Процессор Intel®&nbsp;Core™&nbsp;i3 с&nbsp;технологией Intel® Hybrid"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_HYBRID",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Легко переключайтесь между программами и будьте готовы ко&nbsp;всему, где бы вы ни оказались.",
                "tr_title": "Мобильная многозадачность",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 с&nbsp;технологией Intel® Hybrid",
                "tr_subTitle2": "Процессор Intel®&nbsp;Core™&nbsp;i5 с&nbsp;технологией Intel® Hybrid"
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Выведите производительность на новый уровень, будь то развлечения, работа в офисных приложениях или создание контента.",
                "tr_title": "Переходите на более мощный ПК",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 с&nbsp;технологией Intel® Hybrid",
                "tr_subTitle2": "Процессор Intel®&nbsp;Core™&nbsp;i5 с&nbsp;технологией Intel® Hybrid"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_H45",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Производительность на уровне настольных ПК в сочетании с мобильностью для любых игр, будь то соревновательные игры с высокой частотой кадров или игры AAA-класса с эффектом полного погружения.",
                "tr_title": "Мощность для ваших игр.",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Производительность на уровне настольных ПК в сочетании с мобильностью для любых игр, будь то соревновательные игры с высокой частотой кадров или игры AAA-класса с эффектом полного погружения.",
                "tr_title": "Мощность для ваших игр.",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_H45",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Ноутбук, который может записывать и транслировать во время игры с высокой частотой кадров, а также с легкостью переключаться на ресурсоемкие приложения в режиме многозадачности.",
                "tr_title": "Расширьте границы возможного.",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Ноутбук, который может записывать и транслировать во время игры с высокой частотой кадров, а также с легкостью переключаться на ресурсоемкие приложения в режиме многозадачности.",
                "tr_title": "Расширьте границы возможного.",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H45_PERFORMANCE",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты и количества ядер для получения преимущества в соревновательных играх и создании сложного контента в любых условиях.",
                "tr_title": "Оптимизированная мощность.",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты и количества ядер для получения преимущества в соревновательных играх и создании сложного контента в любых условиях.",
                "tr_title": "Оптимизированная мощность.",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H45_ENTHUSIAST",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты, количества ядер и возможностей разблокированного множителя для получения преимущества в соревновательных играх и создании сложного контента в любых условиях.",
                "tr_title": "Производительность под вашим контролем",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты, количества ядер и возможностей разблокированного множителя для получения преимущества в соревновательных играх и создании сложного контента в любых условиях.",
                "tr_title": "Производительность под вашим контролем",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_11",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты и большого количества ядер для получения преимущества в соревновательных играх и создании сложного контента.",
                "tr_title": "Оптимизированная мощность.",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge_laptop_11gen.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты и большого количества ядер ускоряет создание сложного контента в любых условиях.",
                "tr_title": "Оптимизированная мощность.",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 11-ГО ПОКОЛЕНИЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты и большого количества ядер ускоряет создание сложного контента.",
                "tr_title": "Оптимизированная мощность.",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 11-ГО ПОКОЛЕНИЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_10",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Раскройте свой потенциал благодаря максимальным игровым возможностям",
                "tr_title": "Соревнуйтесь на высшем уровне",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 10&#8209;го поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock_blue.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ 10-ГО ПОКОЛЕНИЯ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Стабильный гейминг в играх ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Потоковая трансляция",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляция и запись",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Новый уровень создания контента",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Максимальная производительность в играх",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "Разблокированный множитель и возможность оверклокинга<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Раскройте свой потенциал благодаря максимальным игровым возможностям",
                "tr_title": "Соревнуйтесь на высшем уровне",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 10&#8209;го поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock_blue.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ 10-ГО ПОКОЛЕНИЯ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Стабильный гейминг в играх ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Потоковая трансляция",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляция и запись",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Новый уровень создания контента",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Максимальная производительность в играх",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "Разблокированный множитель и возможность оверклокинга<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,8&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 10<br/>Потоков: 20</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбук, созданный специально для тех, кто всегда в движении.",
                "tr_title": "Встречайте ноутбуки нового класса",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 10&#8209;го поколения"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_11_UNLOCKED",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты и большого количества ядер для получения преимущества в соревновательных играх и создании сложного контента.",
                "tr_title": "Производительность под вашим контролем",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 11-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge_laptop_11gen.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты, большого количества ядер и возможностей разблокированного множителя ускоряет создание сложного контента в любых условиях.",
                "tr_title": "Производительность под вашим контролем",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 11-ГО ПОКОЛЕНИЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Оптимальное сочетание высокой тактовой частоты и большого количества ядер ускоряет создание сложного контента.",
                "tr_title": "Производительность под вашим контролем",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 11&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 11-ГО ПОКОЛЕНИЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>интеллекту&shy;альной кэш-памяти Intel®</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Плавный игровой процесс и виртуальная реальность в самых ресурсоемких играх",
                "tr_title": "Здесь начинаются серьезные игры",
                "tr_gen_core_title": "Процессор Intel® Core™ i5 9-го&nbsp;поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Игры ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Играйте, транслируйте и записывайте без компромиссов",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Лучший процессор Intel® Core™ 9-го поколения для игр",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоков: 8</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 6</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,9&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 8</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ДО 32% ВЫШЕ ЧАСТОТА КАДРОВ <br/><span class='tr_subtitle_font'>во время игр, трансляции и записи по сравнению с 3-летним ПК<sup>3</sup></span>",
                "tr_title": "Возможность делиться величайшими игровыми моментами",
                "tr_gen_core_title": "Процессор Intel® Core™ i7 9-го&nbsp;поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Игры ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Играйте, транслируйте и записывайте без компромиссов",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Лучший процессор Intel® Core™ 9-го поколения для игр",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоков: 8</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 6</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,9&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 8</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ДО 41% ВЫШЕ ЧАСТОТА КАДРОВ <br/><span class='tr_subtitle_font'>во время игр, трансляции и записи по сравнению с 3-летним ПК<sup>4</sup></span>",
                "tr_title": "Геймеры требуют, Intel® Core™ i9 обеспечивает",
                "tr_gen_core_title": "Процессор Intel® Core™ i9 9-го&nbsp;поколения",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество потоков:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Количество ядер:</span><span class='badgetitle_font'><br/>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кэш-памяти</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "С разблокиро&shy;ванным множителем",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "НАЙДИТЕ ПОДХОДЯЩИЙ ПРОЦЕССОР INTEL® CORE™ ДЛЯ СВОЕГО СТИЛЯ ИГРЫ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "Процессор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "Процессор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Игры ААА-класса",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Киберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Играйте, транслируйте и записывайте без компромиссов",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Лучший процессор Intel® Core™ 9-го поколения для игр",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоков: 8</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 12</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоков: 6</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;4,9&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 8</span>"
                    },
                    {
                      "tr_title": "Успевайте больше<span class='small_font'>Тактовая частота<sup>2</sup>: до&nbsp;5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоков: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_K_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Созданы для нового поколения игр",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge.png",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го поколения",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 12-ГО ПОКОЛЕНИЯ"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го поколения",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 12-ГО ПОКОЛЕНИЯ"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i9 12&#8209;го поколения",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 12-ГО ПОКОЛЕНИЯ"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество потоков: </span>[XX]</span>",
                    "tr_badgePreTitle": "На ядрах Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "На ядрах Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_HX_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "«Боевая» и рабочая станция в одном корпусе",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge.png",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го поколения",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 12-ГО ПОКОЛЕНИЯ"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i9 12&#8209;го поколения",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 12-ГО ПОКОЛЕНИЯ"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество потоков: </span>[XX]</span>",
                    "tr_badgePreTitle": "На ядрах Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "На ядрах Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Стабильная производительность в самый нужный момент",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i3 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i3 12-ГО ПОКОЛЕНИЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Увеличение производительности там, где это необходимо",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 12-ГО ПОКОЛЕНИЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Увеличение производительности там, где это необходимо",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 12-ГО ПОКОЛЕНИЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Невероятная производительность там, где это необходимо",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 12-ГО ПОКОЛЕНИЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Невероятная производительность там, где это необходимо",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 12-ГО ПОКОЛЕНИЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/EVO_I5_12GEN.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Благодаря ноутбукам Intel® Evo™ вы получаете производительность, встроенные интеллектуальные возможности для уверенного общения в видеочатах, более быстрый Интернет, продолжительное время автономной работы и многое другое.",
                "tr_title": "Повышение производительности там, где это нужно больше всего.",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 12-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/EVO_I7_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/evo_processor_i7_gen12.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Благодаря ноутбукам Intel® Evo™ вы получаете производительность, встроенные интеллектуальные возможности для уверенного общения в видеочатах, более быстрый Интернет, продолжительное время автономной работы и многое другое.",
                "tr_title": "Невероятная производительность там, где это необходимо",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 12-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I9_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/EVO_I9_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/evo_processor_i9_gen12.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Благодаря ноутбукам Intel® Evo™ вы получаете производительность, встроенные интеллектуальные возможности для уверенного общения в видеочатах, более быстрый Интернет, продолжительное время автономной работы и многое другое.",
                "tr_title": "Экстремальная производительность в ноутбуке премиум-класса",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i9 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 12-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i9-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "До [max_turbo_frequency]&nbsp;ГГц с технологией Intel® Turbo Boost 2.0",
                "tr_title": "Создан для бизнеса",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 12-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Подавление шума и размытие фона",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматическая настройка производительности с приоритизацией главных задач",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Совершение интернет-звонков со стабильной связью высокого качества",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Получение готового решения в области безопасности на базе аппаратных средств",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Обеспечение возможностей удаленного управления устройствами",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматическая оптимизация производительности Wi-Fi<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Работа с приложениями, использующими большие объемы данных",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Максимально эффективная работа благодаря повышенной производительности",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "До [max_turbo_frequency]&nbsp;ГГц с технологией Intel® Turbo Boost 2.0",
                "tr_title": "Эффективно работает, чтобы вы могли сосредоточиться на бизнесе.",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 12-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Подавление шума и размытие фона",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматическая настройка производительности с приоритизацией главных задач",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Совершение интернет-звонков со стабильной связью высокого качества",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Получение готового решения в области безопасности на базе аппаратных средств",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Обеспечение возможностей удаленного управления устройствами",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматическая оптимизация производительности Wi-Fi<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Работа с приложениями, использующими большие объемы данных",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Максимально эффективная работа благодаря повышенной производительности",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "До [max_turbo_frequency]&nbsp;ГГц с технологией Intel®&nbsp;Turbo&nbsp;Boost&nbsp;2.0",
                "tr_title": "Ускорьте развитие бизнеса",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i9 12&#8209;го&nbsp;поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 12-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/VPRO12_i9.svg",
                "processorCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Подавление шума и размытие фона",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматическая настройка производительности с приоритизацией главных задач",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Совершение интернет-звонков со стабильной связью высокого качества",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Получение готового решения в области безопасности на базе аппаратных средств",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Обеспечение возможностей удаленного управления устройствами",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматическая оптимизация производительности Wi-Fi<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Работа с приложениями, использующими большие объемы данных",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Максимально эффективная работа благодаря повышенной производительности",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Стабильная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i3 13&#8209;го поколения",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/13th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Реальная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 13-ГО ПОКОЛЕНИЯ",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Реальная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 13-ГО ПОКОЛЕНИЯ",
                "bannerImgUrl": "assets/images/creator/13thgeni5processor.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Мощная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 13-ГО ПОКОЛЕНИЯ",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Мощная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 13-ГО ПОКОЛЕНИЯ",
                "bannerImgUrl": "assets/images/creator/13thgeni7processor.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Не только производительность",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i9 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 13-ГО ПОКОЛЕНИЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество потоков: </span>[XX]</span>",
                    "tr_badgePreTitle": "На ядрах Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "На ядрах Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/EVO_I5_12GEN.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Простое подключение к телефону <sup>24</sup>, интеллектуальный выбор лучшей сети Wi-Fi и долговечная батарея с быстрой зарядкой.",
                "tr_title": "Не только производительность: успевайте больше где угодно",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 13-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/EVO_I7_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Простое подключение к телефону <sup>24</sup>, интеллектуальный выбор лучшей сети Wi-Fi и долговечная батарея с быстрой зарядкой.",
                "tr_title": "Не только производительность: позвольте своему ПК делать еще больше сразу",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 13-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I9_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/EVO_I9_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Простое подключение к телефону <sup>24</sup>, интеллектуальный выбор лучшей сети Wi-Fi и долговечная батарея с быстрой зарядкой.",
                "tr_title": "Не только производительность: ускорьте выполнение самых сложных задач",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i9 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 13-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i9-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_13TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Не только производительность",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го поколения",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 13-ГО ПОКОЛЕНИЯ",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го поколения",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 13-ГО ПОКОЛЕНИЯ",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i9 13&#8209;го поколения",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 13-ГО ПОКОЛЕНИЯ",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество потоков: </span>[XX]</span>",
                    "tr_badgePreTitle": "На ядрах Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "На ядрах Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_ABOVE13TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Не только производительность",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "Процессор Intel® Core™ i5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процессор Intel® Core™ i7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процессор Intel® Core™ i9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество потоков: </span>[XX]</span>",
                    "tr_badgePreTitle": "На ядрах Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "На ядрах Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Стабильная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "Процессор Intel® Core™ i3",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/13th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Реальная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процессор Intel® Core™ i5",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Мощная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процессор Intel® Core™ i7",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_14TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Не только производительность",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "Процессор Intel® Core™ i5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процессор Intel® Core™ i7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процессор Intel® Core™ i9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество потоков: </span>[XX]</span>",
                    "tr_badgePreTitle": "На ядрах Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "На ядрах Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Стабильная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                "tr_gen_core_title": "Процессор Intel® Core™ 3",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/14th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Реальная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                "tr_gen_core_title": "Процессор Intel® Core™ 5",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ 5",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Мощная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                "tr_gen_core_title": "Процессор Intel® Core™ 7",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ 7",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Мощная производительность, чтобы делать больше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_14_1.svg",
                "tr_gen_core_title": "Процессор Intel® Core™ 9",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/intel_core_9_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_14_1.svg",
                      "tr_badgeIconTile": "Процессор Intel® Core™ 9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_1ST_GEN_ULTRA_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Игры без компромиссов",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_5_h_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_7_h_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_9_h_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]",
                    "tr_badgeSubTitle1": "LPE-ядер: [l_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество потоков: </span>[XX]</span>",
                    "tr_badgePreTitle": "На ядрах Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "На ядрах Efficient-core: [e_thread]",
                    "tr_badgeSubTitle1": "На LPE-ядрах: [l_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                      "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tr_title": "Игры без компромиссов",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tr_title": "Игры без компромиссов",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tr_title": "Игры без компромиссов",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tr_title": "Игры без компромиссов",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tr_title": "Игры без компромиссов",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tr_title": "Игры без компромиссов",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "Малый бизнес заслуживает пользоваться решениями для крупного бизнеса",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i5 13-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Подавление шума и размытие фона",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Автоматическая настройка производительности с приоритизацией главных задач",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Совершение интернет-звонков со стабильной связью высокого качества",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Готовое решение в области защиты на базе аппаратных средств",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "Защита устройств и данных от физического взлома",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "Малый бизнес заслуживает пользоваться решениями для крупного бизнеса",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i7 13-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Подавление шума и размытие фона",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Автоматическая настройка производительности с приоритизацией главных задач",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Совершение интернет-звонков со стабильной связью высокого качества",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Готовое решение в области защиты на базе аппаратных средств",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "Защита устройств и данных от физического взлома",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "Малый бизнес заслуживает пользоваться решениями для крупного бизнеса",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i9 13&#8209;го поколения",
                "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ i9 13-ГО ПОКОЛЕНИЯ",
                "processorTileBadgeUrl": "assets/images/standard/VPRO12_i9.svg",
                "processorCompare": {
                  "tr_title": "ЭТОТ ПРОЦЕССОР В СРАВНЕНИИ С ДРУГИМИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Текущее устройство",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Подавление шума и размытие фона",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Автоматическая настройка производительности с приоритизацией главных задач",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Совершение интернет-звонков со стабильной связью высокого качества",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Готовое решение в области защиты на базе аппаратных средств",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "Защита устройств и данных от физического взлома",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_RPL_MTL_vPro",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/vPro_ultra_badge.png",
                "tileBG": "",
                "bannerImgUrl": "assets/images/INTEL_VPRO_ULTRA.png",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "Оцените новые возможности ИИ для&nbsp;бизнеса",
                "tr_title": "Подготовьтесь к будущему с&nbsp;процессорами Intel®&nbsp;Core™&nbsp;Ultra&nbsp;[XX] и&nbsp;Intel&nbsp;vPro®",
                "tr_gen_core_title": "Процессор Intel® Core™ Ultra [XX]",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_1.png",
                    "tr_badgeTitle": "НОВЫЙ ИМПУЛЬС ДЛЯ БИЗНЕСА БЛАГОДАРЯ ПК С ИИ ОТ INTEL",
                    "tr_badgeSubTitle": "Мощные ПК, предоставляющие потрясающие возможности, — основа эффективности бизнеса. Intel&nbsp;vPro® повышает эффективность и&nbsp;производительность сотрудников во всех сценариях работы и приложениях благодаря новой архитектуре, которая обеспечивает превосходную энергоэффективность для различных сложных рабочих нагрузок бизнеса, правильно&nbsp;распределяя задачи в нужное время.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_2.png",
                    "tr_badgeTitle": "ИНТЕГРИРОВАННЫЕ ФУНКЦИИ МНОГОУРОВНЕВОЙ ЗАЩИТЫ",
                    "tr_badgeSubTitle": "Новые и только формирующиеся угрозы требуют комплексного подхода к обеспечению безопасности. Intel&nbsp;vPro® обеспечивает безопасность на аппаратном уровне и&nbsp;во&nbsp;всем стеке, чтобы лучше защитить ваш бизнес. Уникальные интегрированные меры безопасности, включая&nbsp;возможности обнаружения угроз на&nbsp;базе&nbsp;ИИ, помогут защитить пользователей, ваши данные и&nbsp;бизнес.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_3.png",
                    "tr_badgeTitle": "ВСТРОЕННЫЕ&nbsp;СРЕДСТВА ДЛЯ&nbsp;ПОДДЕРЖКИ ЭФФЕКТИВНОЙ&nbsp;РАБОТЫ ПОЛЬЗОВАТЕЛЕЙ ГДЕ&nbsp;УГОДНО",
                    "tr_badgeSubTitle": "Офисы повсюду, как и ПК. Intel vPro® предоставляет современные возможности управления на базе аппаратных средств, чтобы помочь компаниям облегчить управление парком ПК, упростить поддержку и улучшить возможности конечных пользователей, а также обеспечить экологичные вычисления.",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_5.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК с ИИ — больше чем просто отличный ПК",
                "tr_subtitle1": "НА БАЗЕ ПРОЦЕССОРОВ INTEL®&nbsp;CORE™ ULTRA (СЕРИЯ&nbsp;2)",
                "tr_subtitle2": "Это возможно на вашем ПК с ИИ от Intel",
                "tr_subtitle": "Самый эффективный, безопасный и высокопроизводительный процессор Intel® для мобильных ПК<sup>39</sup> ",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5 (Серия&nbsp;2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>Больше возможностей для творчества</span> благодаря средствам ИИ для более быстрого создания контента"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Более высокая производительность</span> благодаря поддержке ИИ для экономии времени"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Более высокий уровень безопасности</span> благодаря встроенной защите данных"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_7.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК с ИИ — больше чем просто отличный ПК",
                "tr_subtitle1": "НА БАЗЕ ПРОЦЕССОРОВ INTEL®&nbsp;CORE™ ULTRA (СЕРИЯ&nbsp;2)",
                "tr_subtitle2": "Это возможно на вашем ПК с ИИ от Intel",
                "tr_subtitle": "Самый эффективный, безопасный и высокопроизводительный процессор Intel® для мобильных ПК<sup>39</sup> ",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серия&nbsp;2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>Больше возможностей для творчества</span> благодаря средствам ИИ для более быстрого создания контента"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Более высокая производительность</span> благодаря поддержке ИИ для экономии времени"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Более высокий уровень безопасности</span> благодаря встроенной защите данных"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_9.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК с ИИ — больше чем просто отличный ПК",
                "tr_subtitle1": "НА БАЗЕ ПРОЦЕССОРОВ INTEL®&nbsp;CORE™ ULTRA (СЕРИЯ&nbsp;2)",
                "tr_subtitle2": "Это возможно на вашем ПК с ИИ от Intel",
                "tr_subtitle": "Самый эффективный, безопасный и высокопроизводительный процессор Intel® для мобильных ПК<sup>39</sup> ",
                "tr_gen_core_title": "Процессор Intel® Core™ Ultra 9 (Серия 2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>Больше возможностей для творчества</span> благодаря средствам ИИ для более быстрого создания контента"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Более высокая производительность</span> благодаря поддержке ИИ для экономии времени"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Более высокий уровень безопасности</span> благодаря встроенной защите данных"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_5.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК с ИИ — больше чем просто отличный ПК",
                "tr_subtitle1": "НА БАЗЕ ПРОЦЕССОРОВ INTEL®&nbsp;CORE™ ULTRA (СЕРИЯ&nbsp;2)",
                "tr_subtitle2": "Это возможно на вашем ПК с ИИ от Intel",
                "tr_subtitle": "Самый эффективный, безопасный и высокопроизводительный процессор Intel® для мобильных ПК<sup>39</sup> ",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5 (Серия&nbsp;2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_7.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК с ИИ — больше чем просто отличный ПК",
                "tr_subtitle1": "НА БАЗЕ ПРОЦЕССОРОВ INTEL®&nbsp;CORE™ ULTRA (СЕРИЯ&nbsp;2)",
                "tr_subtitle2": "Это возможно на вашем ПК с ИИ от Intel",
                "tr_subtitle": "Самый эффективный, безопасный и высокопроизводительный процессор Intel® для мобильных ПК<sup>39</sup> ",
                "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серия&nbsp;2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_9.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК с ИИ — больше чем просто отличный ПК",
                "tr_subtitle1": "НА БАЗЕ ПРОЦЕССОРОВ INTEL®&nbsp;CORE™ ULTRA (СЕРИЯ&nbsp;2)",
                "tr_subtitle2": "Это возможно на вашем ПК с ИИ от Intel",
                "tr_subtitle": "Самый эффективный, безопасный и высокопроизводительный процессор Intel® для мобильных ПК<sup>39</sup> ",
                "tr_gen_core_title": "Процессор Intel® Core™ Ultra 9 (Серия 2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_2ND_GEN_ARL_LAKE",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Создан для игр. Готов&nbsp;ко&nbsp;всему.",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_5_tile_badge.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_7_tile_badge.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_9_tile_badge.svg"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]",
                    "tr_badgeSubTitle1": "LPE-ядер: [l_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество потоков: </span>[XX]</span>",
                    "tr_badgePreTitle": "На ядрах Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "На ядрах Efficient-core: [e_thread]",
                    "tr_badgeSubTitle1": "На LPE-ядрах: [l_thread]"
                  }
                ],
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/processor/arl_panel1.png",
                    "tr_title": "ОЦЕНИТЕ&nbsp;НЕВЕРОЯТНУЮ ПРОИЗВОДИТЕЛЬНОСТЬ В&nbsp;ИГРАХ",
                    "tr_subtitle": "Оцените легендарную производительность в играх благодаря новым ядрам, которые обеспечивают сверхплавный игровой процесс и быстродействие. <br/><br/> Получите частоту до <span class ='expandable_highlight'>[XX] ГГц</span> благодаря технологии Intel® Thermal Velocity Boost.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel2.png",
                    "tr_title": "ПОВЫСЬТЕ ЭФФЕКТИВНОСТЬ И&nbsp;ПРОИЗВОДИТЕЛЬНОСТЬ ДО МАКСИМУМА",
                    "tr_subtitle": "Сверхэффективные процессоры Intel® Core™ Ultra для настольных ПК повышают производительность и эффективность, благодаря чему ваш ПК сможет работать без нагрева, тихо и быстро. <br><br/> <span class ='expandable_highlight'>На 10%</span> эффективнее многопоточная производительность <br><br/>До <span class ='expandable_highlight'>30%</span> ниже энергопотребление",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel3.png",
                    "tr_title": "БУДЬТЕ ГОТОВЫ К&nbsp;БУДУЩЕМУ, ПЕРЕРАСПРЕДЕЛЯЯ ЗАДАЧИ ИГР И&nbsp;СТРИМИНГА",
                    "tr_subtitle": "Повысьте производительность во время стриминга и в играх благодаря ПК с ИИ на базе процессоров Intel®&nbsp;Core™&nbsp;Ultra.<br><br/><strong>Передайте задачи ИИ нейронному процессору:</strong><br><br/><span class ='expandable_highlight'>Удаление фона</span><br><br/><span class ='expandable_highlight'>Оптимизация звука</span><br><br/><span class ='expandable_highlight'>Автоматическое кадрирование</span><br><br/><strong>Три ускорителя ИИ: ЦП, ГП и нейронный процессор</strong> Благодаря встроенным ускорителям ИИ (центральный, графический и нейронный процессоры) процессоры Intel®&nbsp;Core™&nbsp;Ultra могут быстро справляться с рабочими нагрузками ИИ.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4.png",
                    "tr_title": "ОПТИМИЗИРУЙТЕ ВОЗМОЖНОСТИ ПОДКЛЮЧЕНИЯ",
                    "tr_subtitle": "Благодаря большему количеству линий PCIe 5.0, а также технологии Thunderbolt™ 5.0 и Wi-Fi 7 в процессорах Intel® Core™ Ultra для настольных ПК передавать данные еще никогда не было так просто. <br><br/><strong>Поддержка технологии Thunderbolt™ 5 </strong> <br><br/>Передача данных со скоростью до <span class ='expandable_highlight'>120 Гбит/с</span> для записи, редактирования или обмена файлами <br><br/><span class ='expandable_highlight'>В 2 раза</span> выше пропускная способность данных, чем у Thunderbolt™",
                    "align": "right"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Больше творчества.<br>Больше продуктивности.<br>Больше безопасности.",
                "tr_subtitle": "Больше времени для того, что вы любите.",
                "bannerImgUrl": "assets/images/processor/arl_std_banner_desktop.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5 (Серия&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕССОР INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (СЕРИЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серия&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕССОР INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (СЕРИЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "Процессор Intel® Core™ Ultra 9 (Серия 2)",
                    "tr_badgeSubTitle1": "ПРОЦЕССОР INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (СЕРИЯ&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1_desktop.png",
                    "tr_title": "ВЫПОЛНЯЙТЕ ЗАДАЧИ, КОТОРЫЕ ОТНИМАЮТ МНОГО ВРЕМЕНИ. БЫСТРО.",
                    "tr_subtitle": "Сэкономьте больше времени с помощью ИИ&#8209;помощника. Заполняйте календарь, планируйте поездки, мгновенно получайте резюме встреч, легко создавайте презентации и многое другое.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2_desktop.png",
                    "tr_title": "ИГРАЙТЕ В СВОИ ЛЮБИМЫЕ ИГРЫ. БЕЗ СТРЕССА.",
                    "tr_subtitle": "Забудьте о проблемах совместимости или производительности во время игры. Популярные AAA-игры работают без замедлений, поэтому вы сможете уверенно играть и стримить.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3_desktop.png",
                    "tr_title": "СОЗДАВАЙТЕ ТО, ЧТО ЛЮБИТЕ. ЛЕГКО.",
                    "tr_subtitle": "Что бы вы ни делали, делайте это быстрее и проще с&nbsp;помощью инструментов для творчества с&nbsp;ускорением ИИ.<br><br>Мгновенно обрезайте фотографии, меняйте фоны и добавляйте эффекты. Улучшайте видео за несколько щелчков мыши. Создавайте собственные произведения искусства с&nbsp;помощью нескольких слов.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel4_desktop.png",
                    "tr_title": "НАСЛАЖДАЙТЕСЬ СПОКОЙСТВИЕМ. ВСЕГДА.",
                    "tr_subtitle": "Чувствуйте себя уверенно, зная о встроенных средствах защиты, которые помогут сохранить ваши данные в целости и сохранности.<br><br>Кроме того, приложения для безопасности с поддержкой ИИ позволяют мгновенно обнаруживать поддельные аудиодорожки в видео и защищать конфиденциальные данные, хранящиеся на ПК.",
                    "align": "left"
                  }
                ]
              }
            },
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Больше творчества.<br>Больше продуктивности.<br>Больше безопасности.",
                "tr_subtitle": "Больше времени для того, что вы любите.",
                "bannerImgUrl": "assets/images/processor/arl_std_banner.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5 (Серия&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕССОР INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (СЕРИЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серия&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕССОР INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (СЕРИЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "Процессор Intel® Core™ Ultra 9 (Серия 2)",
                    "tr_badgeSubTitle1": "ПРОЦЕССОР INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (СЕРИЯ&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1.png",
                    "tr_title": "ВЫПОЛНЯЙТЕ ЗАДАЧИ, КОТОРЫЕ ОТНИМАЮТ МНОГО ВРЕМЕНИ. БЫСТРО.",
                    "tr_subtitle": "Сэкономьте больше времени с помощью ИИ&#8209;помощника. Заполняйте календарь, планируйте поездки, мгновенно получайте резюме встреч, легко создавайте презентации и многое другое.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2.png",
                    "tr_title": "СОЗДАВАЙТЕ ТО, ЧТО ЛЮБИТЕ. ЛЕГКО.",
                    "tr_subtitle": "Что бы вы ни делали, делайте это быстрее и проще с&nbsp;помощью инструментов для творчества с&nbsp;ускорением ИИ.<br><br>Мгновенно обрезайте фотографии, меняйте фоны и добавляйте эффекты. Улучшайте видео за несколько щелчков мыши. Создавайте собственные произведения искусства с&nbsp;помощью нескольких слов.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3.png",
                    "tr_title": "ИГРАЙТЕ В СВОИ ЛЮБИМЫЕ ИГРЫ. БЕЗ СТРЕССА.",
                    "tr_subtitle": "Забудьте о проблемах совместимости или производительности во время игры. Популярные AAA-игры работают без замедлений, поэтому вы сможете уверенно играть и стримить.<br><br>Благодаря встроенной графике Intel® Arc™ игровой процесс в дороге будет более плавным, а время игры без подключения к сети — более длительным<sup>57</sup>.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel4.png",
                    "tr_title": "Забудьте о зарядном устройстве на весь день<sup>55</sup>.",
                    "tr_subtitle": "Берите с собой все, что любите, благодаря <strong>времени автономной работы до 20 часов</strong><sup>55,56</sup>.",
                    "align": "centre"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel5.png",
                    "tr_title": "НАСЛАЖДАЙТЕСЬ СПОКОЙСТВИЕМ. ВСЕГДА.",
                    "tr_subtitle": "Чувствуйте себя уверенно, зная о встроенных средствах защиты, которые помогут сохранить ваши данные в целости и сохранности.<br><br>Кроме того, приложения для безопасности с поддержкой ИИ позволяют мгновенно обнаруживать поддельные аудиодорожки в видео и защищать конфиденциальные данные, хранящиеся на ПК.",
                    "align": "left"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "EVO",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Больше творчества.<br>Больше продуктивности.<br>Больше безопасности.",
                "tr_subtitle": "Больше времени для того, что вы любите.",
                "bannerImgUrl": "assets/images/processor/arl_std_banner.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "panelType2": "evo-content-tile-panel",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5 (Серия&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕССОР INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (СЕРИЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серия&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕССОР INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (СЕРИЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "Процессор Intel® Core™ Ultra 9 (Серия 2)",
                    "tr_badgeSubTitle1": "ПРОЦЕССОР INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (СЕРИЯ&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1.png",
                    "tr_title": "ВЫПОЛНЯЙТЕ ЗАДАЧИ, КОТОРЫЕ ОТНИМАЮТ МНОГО ВРЕМЕНИ. БЫСТРО.",
                    "tr_subtitle": "Сэкономьте больше времени с помощью ИИ&#8209;помощника. Заполняйте календарь, планируйте поездки, мгновенно получайте резюме встреч, легко создавайте презентации и многое другое.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2.png",
                    "tr_title": "СОЗДАВАЙТЕ ТО, ЧТО ЛЮБИТЕ. ЛЕГКО.",
                    "tr_subtitle": "Что бы вы ни делали, делайте это быстрее и проще с&nbsp;помощью инструментов для творчества с&nbsp;ускорением ИИ.<br><br>Мгновенно обрезайте фотографии, меняйте фоны и добавляйте эффекты. Улучшайте видео за несколько щелчков мыши. Создавайте собственные произведения искусства с&nbsp;помощью нескольких слов.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3.png",
                    "tr_title": "ИГРАЙТЕ В СВОИ ЛЮБИМЫЕ ИГРЫ. БЕЗ СТРЕССА.",
                    "tr_subtitle": "Забудьте о проблемах совместимости или производительности во время игры. Популярные AAA-игры работают без замедлений, поэтому вы сможете уверенно играть и стримить.<br><br>Благодаря встроенной графике Intel® Arc™ игровой процесс в дороге будет более плавным, а время игры без подключения к сети — более длительным<sup>57</sup>.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel5.png",
                    "tr_title": "НАСЛАЖДАЙТЕСЬ СПОКОЙСТВИЕМ. ВСЕГДА.",
                    "tr_subtitle": "Чувствуйте себя уверенно, зная о встроенных средствах защиты, которые помогут сохранить ваши данные в целости и сохранности.<br><br>Кроме того, приложения для безопасности с поддержкой ИИ позволяют мгновенно обнаруживать поддельные аудиодорожки в видео и защищать конфиденциальные данные, хранящиеся на ПК.",
                    "align": "left"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "ПК Intel® Evo™ с ИИ",
                    "tr_subtitle": "Получите лучшее от процессоров Intel®&nbsp;Core™&nbsp;Ultra"
                  },
                  {
                    "tr_title": "Создан для существующих и новых возможностей ИИ",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "На выбор доступны модели с сенсорным экраном и 2 в 1 различных цветов и размеров",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Специальный модуль ИИ, ускоряющий все действия пользователя",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Быстрое включение в работу благодаря уже знакомым аппаратным средствам и программному обеспечению",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Автономная работа без шума и нагрева в течение всего дня",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Встроенные средства защиты, обеспечивающие безопасность данных",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Синхронизация с любым телефоном или планшетом<sup>54</sup>",
                    "tr_subtitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_2ND_GEN_ARL_LAKE_LAPTOP",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процессор",
                "tr_title": "Для нового поколения игр",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_5_tile_badge_laptop.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_7_tile_badge_laptop.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕССОР INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_9_tile_badge_laptop.svg"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]",
                    "tr_badgeSubTitle1": "LPE-ядер: [l_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Количество потоков: </span>[XX]</span>",
                    "tr_badgePreTitle": "На ядрах Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "На ядрах Efficient-core: [e_thread]",
                    "tr_badgeSubTitle1": "На LPE-ядрах: [l_thread]"
                  }
                ],
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/processor/arl_panel1_laptop.png",
                    "tr_title": "ОЦЕНИТЕ&nbsp;НЕВЕРОЯТНУЮ ПРОИЗВОДИТЕЛЬНОСТЬ В&nbsp;ИГРАХ",
                    "tr_subtitle": "Оцените легендарную производительность в играх благодаря новым ядрам, которые обеспечивают сверхплавный игровой процесс и быстродействие. <br/><br/> Всего один щелчок мыши отделяет вас от повышенной производительности в классических играх, которая достигается за счет постоянных обновлений для Intel® Application Optimization<sup>48</sup>.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4.png",
                    "tr_title": "РАБОТАЙТЕ С&nbsp;МАКСИМАЛЬНОЙ ЭНЕРГОЭФФЕКТИВНОСТЬЮ",
                    "tr_subtitle": "Делайте больше при меньших затратах и получайте улучшенную производительность в играх при более длительном времени автономной работы. <br><br/>Сверхэффективные процессоры Intel®&nbsp;Core™&nbsp;Ultra повышают производительность и эффективность, благодаря чему ваш ноутбук сможет работать без нагрева, тихо и быстро.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel3.png",
                    "tr_title": "ПРИГОТОВЬТЕСЬ К БУДУЩЕМУ С ИИ",
                    "tr_subtitle": "Ускорьте задачи ИИ, выполняемые на устройстве, с помощью ПК на базе процессоров <span class ='expandable_highlight'>Intel® Core™ Ultra</span> с ИИ. От разгрузки игровых и стриминговых задач до создания изображений и аудио — получите максимум от ПК с ИИ. Три ускорителя ИИ, встроенные в процессор, помогают сохранить ваши данные в целости и сохранности<sup>41</sup>.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4_laptop.png",
                    "tr_title": "МНОГОПОТОЧНОСТЬ ДЛЯ МЕГАЗАДАЧНОСТИ",
                    "tr_subtitle": "Добивайтесь новых высот производительности с помощью модернизированных ядер, которые специально предназначены для того, чтобы вывести игры, стриминг и создание контента на новый уровень. <br><br/>Более высокая многопоточная производительность позволяет работать в многозадачном, или даже в мегазадачном режиме с минимальными перерывами.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel5_laptop.png",
                    "tr_title": "ОПТИМИЗИРУЙТЕ ВОЗМОЖНОСТИ ПОДКЛЮЧЕНИЯ",
                    "tr_subtitle": "Вам не придется больше расстраиваться из&#8209;за задержек благодаря доступной технологии Intel®&nbsp;Wi&#8209;Fi&nbsp;7 и встроенной технологии Intel®&nbsp;Wi&#8209;Fi&nbsp;6E<sup>49</sup>. <br><br/>Упростите кабельную разводку с помощью технологии Thunderbolt™ последнего поколения, самого быстрого порта<sup>50</sup> для ноутбука для подключения всех периферийных устройств, включая камеры, мониторы и диски для хранения данных<sup>51</sup>.",
                    "align": "left"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_PTL",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "Станьте быстрее и&nbsp;эффективнее.",
                  "tr_pretitle": "Intel® Core™ Ultra [XX] Серии 3",
                  "tr_subtitle": "Вся мощь Intel Inside®.",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel1.png",
                  "badgeUrl": "assets/images/badges/intel_core_ultra_series3.svg",
                  "badgeUrl1": "assets/images/badges/copilot_plus_ptl.svg"
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "Не просто еще один ПК.<br/>Ваш ПК.",
                  "tr_subtitle": "Весь ваш мир в одном ноутбуке. Вот почему ноутбуки на базе <span class='processor_bold'>процессоров Intel® Core™ Ultra (Серия 3) </span> имеют все необходимое для выполнения любых задач:",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel2.png",
                  "titleArray": [
                    {
                      "tr_title": "Работайте и играйте до&nbsp;победного – без подзарядки"
                    },
                    {
                      "tr_title": "Производительность, которая так же мобильна, как и вы"
                    },
                    {
                      "tr_title": "Запускайте любимые игры и приложения без проблем"
                    }
                  ],
                  "badgeIcons": [
                    {
                      "tr_badgeTitle": "Работайте и играйте до&nbsp;победного – без подзарядки.",
                      "imgUrl": "assets/images/proc_ptl_battery.svg"
                    },
                    {
                      "tr_badgeTitle": "Производительность, которая&nbsp;вам&nbsp;нужна.",
                      "imgUrl": "assets/images/proc_ptl_performance.svg"
                    },
                    {
                      "tr_badgeTitle": "Реалистичные&nbsp;игры. Максимальная производительность.",
                      "imgUrl": "assets/images/proc_ptl_gaming.svg"
                    },
                    {
                      "tr_badgeTitle": "ИИ, созданный<br/>специально для вас.",
                      "imgUrl": "assets/images/proc_ptl_aiExperience.svg"
                    },
                    {
                      "tr_badgeTitle": "Графика, воплощающая ваши идеи в&nbsp;жизнь.",
                      "imgUrl": "assets/images/proc_ptl_graphics.svg"
                    },
                    {
                      "tr_badgeTitle": "Запуск игр и приложений, недоступных другим.",
                      "imgUrl": "assets/images/proc_ptl_compatibility.svg"
                    },
                    {
                      "tr_badgeTitle": "Дизайн, который&nbsp;отражает ваш стиль.",
                      "imgUrl": "assets/images/proc_ptl_design.svg"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "Лучшие возможности<br/>при работе с ноутбуком<sup>1</sup>.",
                  "tr_subtitle": "Каждый тонкий и легкий ноутбук Intel® Evo™ Edition сертифицирован и готов к любым вызовам.",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel3.svg",
                  "badgeUrl": "assets/images/badges/evo_ultra_ptl.svg",
                  "titleArray": [
                    {
                      "tr_title": "Мобильная производительность."
                    },
                    {
                      "tr_title": "Длительная автономная работа в реальных условиях."
                    },
                    {
                      "tr_title": "Быстрая зарядка."
                    },
                    {
                      "tr_title": "Мгновенный выход из спящего режима."
                    },
                    {
                      "tr_title": "И многое другое…"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel4.svg",
                  "tr_subtitle": "Результаты отдельных систем могут значительно отличаться в зависимости от конфигурации, сценария использования и других факторов. Подробнее: www.Intel.com/PerformanceIndex.<br/><br/>Функции ИИ могут требовать приобретения, подписки или активации ПО поставщиком программного обеспечения или платформы или могут иметь определенные требования к конфигурации или совместимости. Преимущества, связанные с задержкой, стоимостью и конфиденциальностью данных, обеспечиваются необлачными приложениями на базе ИИ. Подробнее: intel.com/AIPC.<br/><br/>Ни один продукт или компонент не может быть полностью защищен.<br/><br/>Ваши расходы и результаты могут отличаться.<br/><br/>Для работы технологий Intel может потребоваться соответствующее оборудование, программное обеспечение или активация сервисов.<br/><br/>© Корпорация Intel. Intel, логотип Intel и другие торговые марки Intel являются товарными знаками корпорации Intel или ее подразделений. Другие наименования и товарные знаки являются собственностью своих законных владельцев."
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_PTL_12XE",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_pretitle": "<span class='processor_bold'>Процессор Intel® Core™ Ultra [XX]</span> со встроенной <span class='processor_bold'>графикой Intel® Arc™</span>",
                  "tr_title": "Для больших идей больше не нужны большие ПК.",
                  "tr_subtitle": "",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel1.png",
                  "badgeUrl": "assets/images/badges/intel_core_ultra_[XX].svg",
                  "badgeUrl1": "assets/images/arc-badge.svg",
                  "titleArray": [
                    {
                      "tr_title": "Графика студийного уровня в сверхэлегантном корпусе"
                    },
                    {
                      "tr_title": "Скорость, тишина и готовность в момент вдохновения"
                    },
                    {
                      "tr_title": "Аккумулятор, достойный ваших идей"
                    }
                  ],
                  "tr_subtitle2": "Результаты отдельных систем могут значительно отличаться в зависимости от конфигурации, сценария использования и других факторов. Подробнее: www.Intel.com/PerformanceIndex. © Корпорация Intel"
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "Не просто еще один ПК.<br/>Ваш ПК.",
                  "tr_subtitle": "Весь ваш мир в одном ноутбуке. Вот почему ноутбуки на базе <span class='processor_bold'>процессоров Intel® Core™ Ultra (Серия 3) </span> имеют все необходимое для выполнения любых задач:",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel2.png",
                  "titleArray": [
                    {
                      "tr_title": "Работайте и играйте до&nbsp;победного – без подзарядки"
                    },
                    {
                      "tr_title": "Производительность, которая так же мобильна, как и вы"
                    },
                    {
                      "tr_title": "Запускайте любимые игры и приложения без проблем"
                    }
                  ],
                  "badgeIcons": [
                    {
                      "tr_badgeTitle": "Работайте и играйте до&nbsp;победного – без подзарядки.",
                      "imgUrl": "assets/images/proc_ptl_battery.svg"
                    },
                    {
                      "tr_badgeTitle": "Аккумулятор, который не мешает вам творить.",
                      "imgUrl": "assets/images/proc_ptl_performance.svg"
                    },
                    {
                      "tr_badgeTitle": "Творите днем,<br/>играйте ночью.",
                      "imgUrl": "assets/images/proc_ptl_gaming.svg"
                    },
                    {
                      "tr_badgeTitle": "ИИ, созданный<br/>специально для вас.",
                      "imgUrl": "assets/images/proc_ptl_aiExperience.svg"
                    },
                    {
                      "tr_badgeTitle": "Встроенная&nbsp;графика, превосходящая ожидания.",
                      "imgUrl": "assets/images/proc_ptl_graphics.svg"
                    },
                    {
                      "tr_badgeTitle": "Запуск игр и приложений, недоступных другим.",
                      "imgUrl": "assets/images/proc_ptl_compatibility.svg"
                    },
                    {
                      "tr_badgeTitle": "Дизайн, который&nbsp;отражает ваш стиль.",
                      "imgUrl": "assets/images/proc_ptl_design.svg"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel4.svg",
                  "tr_subtitle": "Результаты отдельных систем могут значительно отличаться в зависимости от конфигурации, сценария использования и других факторов. Подробнее: www.Intel.com/PerformanceIndex.<br/><br/> Функции ИИ могут требовать приобретения, подписки или активации ПО поставщиком программного обеспечения или платформы или могут иметь определенные требования к конфигурации или совместимости. Преимущества, связанные с задержкой, стоимостью и конфиденциальностью данных, обеспечиваются необлачными приложениями на базе ИИ. Подробнее: intel.com/aipc.<br/><br/> Ни один продукт или компонент не может быть полностью защищен.<br/><br/> Ваши расходы и результаты могут отличаться.<br/><br/> Для работы технологий Intel могут потребоваться соответствующее оборудование, программное обеспечение или активация сервисов.<br/><br/> © Корпорация Intel. Intel, логотип Intel и другие торговые марки Intel являются товарными знаками корпорации Intel или ее подразделений. Другие наименования и товарные знаки являются собственностью своих законных владельцев."
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "graphics": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_tileTitle1": "Выделенная графика",
                "tr_title": "ЧТО ТАКОЕ ГРАФИЧЕСКИЙ ПРОЦЕССОР?",
                "tr_pretitle": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "Графический процессор создает изображения, которые вы видите на экране.",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/graphic-integrated-GPU-badge.png",
                    "tr_badgeTitle": "Встроенный ГП",
                    "tr_badgeSubTitle": "Интегрированная графика использует оперативную память компьютера, что гораздо энергоэффективнее.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics-discrete-GPU-badge.svg",
                    "tr_badgeTitle": "Дискретный ГП",
                    "tr_badgeSubTitle": "Это самый мощный класс графических процессоров, поскольку у него есть собственная оперативная память и другие ресурсы, предназначенные для создания потрясающей графики.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphic-hybrid-GPU-badge.png",
                    "tr_badgeTitle": "Гибридный ГП",
                    "tr_badgeSubTitle": "Это самый мощный класс графических процессоров, поскольку у него есть собственная оперативная память и другие ресурсы, предназначенные для создания потрясающей графики.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/video-editing.png",
                    "tr_badgeTitle": "Быстрая обработка видео и фотографий",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/binge-4k.svg",
                    "tr_badgeTitle": "Просмотр видео в разрешении 4K",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/games.svg",
                    "tr_badgeTitle": "Игры с высокой детализацией",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics_dual_gpus.svg",
                    "tr_badgeTitle": "Два ГП",
                    "tr_badgeSubTitle": "Некоторые системы, например те, что оснащены графикой Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>, могут использовать как встроенный, так и дискретный графический процессор для распределения графической рабочей нагрузки.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphic-integrated-GPU-badge.png",
                    "tr_badgeTitle": "Встроенный ГП",
                    "tr_badgeSubTitle": "Встроенный графический процессор интегрирован в ту же микросхему, что и центральный. Этот тип графического процессора использует ту же оперативную память и другие ресурсы, что и остальные компоненты компьютера. Это повышает энергоэффективность и позволяет уменьшить вес и толщину устройства.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics-discrete-GPU-badge.svg",
                    "tr_badgeTitle": "Выделенный ГП",
                    "tr_badgeSubTitle": "Это самый мощный класс графических процессоров, поскольку у него есть собственная оперативная память и другие ресурсы, предназначенные для создания потрясающей графики.",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "",
                "tr_pretitle": "",
                "tr_subtitle": "",
                "panelType1": "",
                "panelType2": "gaming-graphics",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Стандарт&shy;ный",
                    "tr_badgeSubTitle": "До 4 ГБ видео&shy;памяти",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Киберспор-тивная",
                    "tr_badgeSubTitle": "До 8 ГБ видео&shy;памяти",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Ультра",
                    "tr_badgeSubTitle": "Более 8 ГБ видео&shy;памяти",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "Поразительная мощность графики",
                "tr_pretitle": "[graphic_display]",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Для самой требовательной графики требуется видеокарта, которая может использоваться исключительно для создания красивых, четких изображений и плавной анимации.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_PLUS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "Живое и яркое изображение благодаря встроенной графике",
                "tr_pretitle": "Графика Intel® Iris® Plus",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Графика Intel® Iris® Plus обеспечивает полное погружение в видео формата 4K HDR и игры с разрешением Full HD без дополнительной видеокарты.",
                "badgeUrl": "assets/images/badges/intel-IRIS-plus.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_GRAPHICS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "Потрясающие визуальные эффекты, производительность без труда",
                "tr_pretitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Графика Intel® обеспечивает революционную производительность интегрированной графики для&nbsp;поддержки бесперебойного создания контента, а&nbsp;также&nbsp;богатый игровой опыт.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_PRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "Графика Intel® Iris® Pro",
                "tr_pretitle": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "UHD_FEATURING_IRIS_XE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "UHD-графика Intel® на базе архитектуры X<sup class='small_text_sup_xe'>e</sup>",
                "tr_pretitle": "Графика с эффектом полного погружения",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "",
                "tr_text1": "Оцените быстрое редактирование фотографий и видео, просмотр контента в разрешении 4K и популярные игры с впечатляющей детализацией.",
                "tr_photo_text": "Быстрая обработка видео и фотографий",
                "tr_video_text": "Просмотр видео в разрешении 4K",
                "tr_game_text": "Игры с высокой детализацией",
                "badgeUrl": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "НАМНОГО БОЛЬШЕ, ЧЕМ КРАСИВОЕ ИЗОБРАЖЕНИЕ",
                "tr_subtitle": "Работая в тесном взаимодействии с процессором, видеокарта отвечает за запуск игр и качество изображения. По объему видеопамяти, предназначенной исключительно для прорисовки изображения, можно предположить к какому типу относится ваш ГП.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВИДЕО&shy;ПАМЯТИ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_UHD_630",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ДЛЯ НАСЫЩЕННОЙ ИГРОВОЙ ГРАФИКИ",
                "tr_subtitle": "Для самой требовательной графики нужна внешняя видеокарта, которая может использоваться исключительно для создания красивых, четких изображений и плавной анимации.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВИДЕО&shy;ПАМЯТИ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "Intel_UHD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ДЛЯ НАСЫЩЕННОЙ ИГРОВОЙ ГРАФИКИ",
                "tr_subtitle": "Для самой требовательной графики нужна внешняя видеокарта, которая может использоваться исключительно для создания красивых, четких изображений и плавной анимации.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВИДЕО&shy;ПАМЯТИ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "НАМНОГО БОЛЬШЕ, ЧЕМ КРАСИВОЕ ИЗОБРАЖЕНИЕ",
                "tr_subtitle": "Работая в тесном взаимодействии с процессором, видеокарта отвечает за запуск игр и качество изображения. По объему видеопамяти, предназначенной исключительно для прорисовки изображения, можно предположить к какому типу относится ваш ГП.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВИДЕО&shy;ПАМЯТИ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHERS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "Поразительная мощность графики",
                "tr_pretitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Для самой требовательной графики требуется видеокарта, которая может использоваться исключительно для создания красивых, четких изображений и плавной анимации.",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "[graphic_display]",
                "tr_pretitle": "ДЛЯ НАСЫЩЕННОЙ ИГРОВОЙ ГРАФИКИ",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_subtitle": "Для самой требовательной графики требуется видеокарта, которая может использоваться исключительно для создания красивых, четких изображений и плавной анимации.",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВИДЕО&shy;ПАМЯТИ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ],
                "titleArray": [
                  {
                    "detailPageName": "LESS_THAN_0",
                    "tr_subtitle": "Для самой требовательной графики нужна внешняя видеокарта, которая может использоваться исключительно для создания красивых, четких изображений и плавной анимации.",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "0_TO_4",
                    "tr_subtitle": "Обеспечивает достаточную графическую мощность для удовлетворения минимальных требований игры.",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "4_TO_8",
                    "tr_subtitle": "Для профессиональных геймеров, которым нужны победы на турнирах",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "GREATER_THAN_8",
                    "tr_subtitle": "Для продвинутых геймеров, которые также используют компьютер для создания сложного контента",
                    "tr_title": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_HD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Красочные видео и захватывающие игры",
                "tr_pretitle": "[graphic_display]",
                "tr_subtitle": "Используйте по максимуму свой экран высокого разрешения благодаря HD-графике Intel® и наслаждайтесь широкими мультимедийными возможностями и встроенными средствами обработки графики.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_UHD_620",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Красочные видео и&nbsp;изображения",
                "tr_pretitle": "[graphic_display]",
                "tr_subtitle": "Сделайте ваши стримы, видеоролики и фотографии более четкими и яркими.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_XE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "Невероятные возможности для игр и творчества",
                "tr_pretitle": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> обеспечивает революционное качество изображения на тонких и легких ПК независимо от выполняемой задачи — от профессионального создания контента и захватывающих развлечений до популярных игр.",
                "badgeUrl": "assets/images/badges/intel-iris-xe.svg"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_pretitle": "ДЛЯ НАСЫЩЕННОЙ ИГРОВОЙ ГРАФИКИ",
                "tr_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/intel-iris-xe.svg",
                "tr_subtitle": "Для самой требовательной графики нужна внешняя видеокарта, которая может использоваться исключительно для создания красивых, четких изображений и плавной анимации.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[x] ГБ<br/></span><span class='subtitle-value'>ВИДЕОПАМЯТИ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_XE_MAX",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "Раскрой свой творческий потенциал",
                "tr_pretitle": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> MAX",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Легко реализуйте творческие проекты и погрузитесь в разнообразие игр благодаря объединенной мощности встроенной графики и первого дискретного графического движка Intel®.",
                "badgeUrl": "assets/images/badges/intel-iris-xe-max.svg"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "tr_title": "Графика Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> MAX",
                "tr_pretitle": "ДЛЯ НАСЫЩЕННОЙ ИГРОВОЙ ГРАФИКИ",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/intel-iris-xe-max.svg",
                "tr_subtitle": "Для самой требовательной графики нужна внешняя видеокарта, которая может использоваться исключительно для создания красивых, четких изображений и плавной анимации.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[x] ГБ<br/></span><span class='subtitle-value'>ВИДЕОПАМЯТИ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_tileTitle": "Графика",
                "tr_title": "Впечатляющие графические возможности",
                "tr_subtitle": "Наслаждайтесь играми, фильмами и видео, имеющими впечатляющую детализацию и четкость.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "ARC_GRAPHICS",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графика",
                "badgeUrl": "assets/images/arc-badge.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/arc_graphics/fallback_arc_graphics.svg",
                "tr_subtitle": "",
                "panelType1": "header-BadgeIconTop-arc",
                "panelType2": "",
                "tr_title": ""
              }
            }
          ],
          "factTagTypes": [
            {
              "factTagType": "Arc_Graphics_Panel_Content",
              "navText": [
                {
                  "specName": "Arc_Graphics_Badge_Icon",
                  "specDetails": {
                    "targetURL": "badgeIconUrl",
                    "tr_specTitle": "",
                    "tr_specText": ""
                  }
                },
                {
                  "specName": "Graphics_Boost_Workflow",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графика",
                    "tr_specText": "Ускорьте рабочие процессы"
                  }
                },
                {
                  "specName": "Graphics_Supercharge_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графика",
                    "tr_specText": "Добейтесь впечатляющих игровых возможностей"
                  }
                },
                {
                  "specName": "Graphics_Supercharge_Gaming_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графика",
                    "tr_specText": "Добейтесь впечатляющих игровых возможностей"
                  }
                },
                {
                  "specName": "Graphics_Level_Up_Your_Game",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графика",
                    "tr_specText": "Повышайте уровень игры"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel2.png",
                    "tr_specTitle": "РАСКРОЙ СВОЙ ТВОРЧЕСКИЙ ПОТЕНЦИАЛ",
                    "tr_specText": "Повысьте производительность, где бы вы ни находились, благодаря самым широким возможностям мультимедиа, например <strong>ведущему в отрасли аппаратному кодированию AV1</strong> и созданию контента с ускорением ИИ.<sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A380_panel2.png",
                    "tr_specTitle": "РАСКРОЙ СВОЙ ТВОРЧЕСКИЙ ПОТЕНЦИАЛ",
                    "tr_specText": "Повысьте производительность благодаря самым широким возможностям мультимедиа, например <strong>ведущему в отрасли аппаратному кодированию AV1</strong> и созданию контента с ускорением ИИ.<sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A730M_panel3.png",
                    "tr_specTitle": "РАСКРОЙ СВОЙ ТВОРЧЕСКИЙ ПОТЕНЦИАЛ",
                    "tr_specText": "Воспользуйтесь новейшими возможностями создания контента с ускорением ИИ благодаря <strong>ведущему в отрасли аппаратному кодированию AV1</strong> и передовому <strong>медиадвижку X<sup>e</sup>.</strong><sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel3.png",
                    "tr_specTitle": "РАСКРОЙ СВОЙ ТВОРЧЕСКИЙ ПОТЕНЦИАЛ",
                    "tr_specText": "Воспользуйтесь новейшими возможностями создания контента с ускорением ИИ благодаря <strong>ведущему в отрасли аппаратному кодированию AV1</strong> и передовому <strong>медиадвижку X<sup>e</sup>.</strong><sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine_12",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel3.png",
                    "tr_specTitle": "РАСКРОЙ СВОЙ ТВОРЧЕСКИЙ ПОТЕНЦИАЛ",
                    "tr_specText": "Воспользуйтесь новейшими возможностями создания контента с ускорением ИИ благодаря <strong>ведущему в отрасли аппаратному кодированию AV1</strong> и передовому <strong>медиадвижку X<sup>e</sup>.</strong><sup>22</sup>"
                  }
                },
                {
                  "specName": "Portability_Meets_Performance",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel3.png",
                    "tr_specTitle": "ПОРТАТИВНОСТЬ И ПРОИЗВОДИТЕЛЬНОСТЬ",
                    "tr_specText": "Играйте в новейшие игры где угодно и насладитесь увеличенной производительностью и качеством графики благодаря современным игровым возможностям. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>технология масштабирования Intel® на основе ИИ для дополнительной производительности и плавного игрового процесса. <br/><br/>Поддержка <strong>DirectX* 12 Ultimate:  </strong>выведите игровой процесс на новый уровень реалистичности с помощью таких графических технологий, как трассировка лучей и Variable Rate Shading."
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel4.png",
                    "tr_specTitle": "ВОЗЬМИТЕ КОНТРОЛЬ НАД ИГРАМИ В СВОИ РУКИ",
                    "tr_specText": "<strong>Центр управления Intel® Arc™</strong> предоставляет новые возможности управления возможности благодаря интуитивно понятному современному интерфейсу. Оптимизируйте игры, получайте бесперебойные обновления драйверов и многие другие возможности."
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A310_panel4.png",
                    "tr_specTitle": "ВОЗЬМИТЕ КОНТРОЛЬ НАД ИГРАМИ В СВОИ РУКИ",
                    "tr_specText": "<strong>Центр управления Intel® Arc™</strong> предоставляет новые возможности управления возможности благодаря интуитивно понятному современному интерфейсу. Оптимизируйте игры, получайте бесперебойные обновления драйверов и многие другие возможности."
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games_1",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A730M_panel4.png",
                    "tr_specTitle": "ВОЗЬМИТЕ КОНТРОЛЬ НАД ИГРАМИ В СВОИ РУКИ",
                    "tr_specText": "Получайте бесперебойные обновления драйверов и оптимизируйте любимые игры с помощью программного обеспечения <strong>Центра управления Intel® Arc™</strong>."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_Desktop2",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A310_newPanel5.png",
                    "tr_specTitle": "ПОЛУЧИТЕ МАКСИМУМ ВОЗМОЖНОСТЕЙ ОТ ПЛАТФОРМЫ INTEL®",
                    "tr_specText": "Используйте совместимые процессоры Intel®&nbsp;Core™ для активации <strong>технологии&nbsp;Intel®&nbsp;Deep&nbsp;Link</strong> и для последующей оптимизации процесса создания контента, а также улучшения игрового опыта и потоковой передачи."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_A580",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_newPanel5.png",
                    "tr_specTitle": "ПОЛУЧИТЕ МАКСИМУМ ВОЗМОЖНОСТЕЙ ОТ СИСТЕМЫ INTEL®",
                    "tr_specText": "Используйте совместимые процессоры Intel®&nbsp;Core™ для активации <strong>технологии&nbsp;Intel®&nbsp;Deep&nbsp;Link</strong> и для последующей оптимизации процесса создания контента, а также улучшения игрового опыта и потоковой передачи."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel5.png",
                    "tr_specTitle": "ПОЛУЧИТЕ МАКСИМУМ ВОЗМОЖНОСТЕЙ ОТ ПЛАТФОРМЫ INTEL®",
                    "tr_specText": "Используйте совместимые процессоры Intel®&nbsp;Core™ для активации <strong>технологии&nbsp;Intel®&nbsp;Deep&nbsp;Link</strong> и для последующей оптимизации процесса создания контента, а также улучшения игрового опыта и потоковой передачи."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_newPanel5.png",
                    "tr_specTitle": "ПОЛУЧИТЕ МАКСИМУМ ВОЗМОЖНОСТЕЙ ОТ ПЛАТФОРМЫ INTEL®",
                    "tr_specText": "Используйте совместимые процессоры Intel®&nbsp;Core™ для активации <strong>технологии&nbsp;Intel®&nbsp;Deep&nbsp;Link</strong> и для последующей оптимизации процесса создания контента, а также улучшения игрового опыта и потоковой передачи."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_System",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_newPanel5.png",
                    "tr_specTitle": "ПОЛУЧИТЕ МАКСИМУМ ВОЗМОЖНОСТЕЙ ОТ СИСТЕМЫ INTEL®",
                    "tr_specText": "Используйте совместимые процессоры Intel®&nbsp;Core™ для активации <strong>технологии&nbsp;Intel®&nbsp;Deep&nbsp;Link</strong> и для последующей оптимизации процесса создания контента, а также улучшения игрового опыта и потоковой передачи."
                  }
                },
                {
                  "specName": "Take_Center_Stage",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_panel4.png",
                    "tr_specTitle": "ЗАЙМИТЕ МЕСТО В ЦЕНТРЕ ВНИМАНИЯ",
                    "tr_specText": "Ведите бесперебойные трансляции с помощью технологий потоковой передачи на базе программного обеспечения <strong>Центра управления Intel® Arc™</strong>."
                  }
                },
                {
                  "specName": "Take_Center_Stage_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel4.png",
                    "tr_specTitle": "ЗАЙМИТЕ МЕСТО В ЦЕНТРЕ ВНИМАНИЯ",
                    "tr_specText": "Ведите бесперебойные трансляции с помощью технологий потоковой передачи на базе программного обеспечения <strong>Центра управления Intel® Arc™</strong>."
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A750_panel2.png",
                    "tr_specTitle": "НАСЛАЖДАЙТЕСЬ ВЫСОКОЙ ПРОИЗВОДИТЕЛЬ&shy;НОСТЬЮ И ПОЛНЫМ ПОГРУЖЕНИЕМ В ИГРЫ",
                    "tr_specText": "Добейтесь наилучшей производительности в новейших играх AAA-класса с высоким разрешением и частотой обновления. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>технология масштабирования Intel® на основе ИИ для дополнительной производительности и плавного игрового процесса. <br/><br/>Поддержка <strong>DirectX* 12 Ultimate:  </strong>выведите игровой процесс на новый уровень реалистичности с помощью таких графических технологий, как трассировка лучей и Variable Rate Shading."
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel2.png",
                    "tr_specTitle": "НАСЛАЖДАЙТЕСЬ ВЫСОКОЙ ПРОИЗВОДИТЕЛЬ&shy;НОСТЬЮ И ПОЛНЫМ ПОГРУЖЕНИЕМ В ИГРЫ",
                    "tr_specText": "Добейтесь наилучшей производительности в новейших играх AAA-класса с высоким разрешением и частотой обновления. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>технология масштабирования Intel® на основе ИИ для дополнительной производительности и плавного игрового процесса. <br/><br/>Поддержка <strong>DirectX* 12 Ultimate:  </strong>выведите игровой процесс на новый уровень реалистичности с помощью таких графических технологий, как трассировка лучей и Variable Rate Shading."
                  }
                },
                {
                  "specName": "Give_Your_Games_A_Boost",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A380_panel3.png",
                    "tr_specTitle": "УЛУЧШЕННАЯ ПРОИЗВОДИТЕЛЬНОСТЬ В ИГРАХ",
                    "tr_specText": "Расширьте игровые возможности благодаря <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>технологии масштабирования Intel® на основе ИИ для дополнительной производительности и плавного игрового процесса. <br/><br/>Поддержка <strong>DirectX* 12 Ultimate:  </strong>выведите игровой процесс на новый уровень реалистичности с помощью таких графических технологий, как трассировка лучей и Variable Rate Shading."
                  }
                },
                {
                  "specName": "Experience_Advanced_Fast_Paced_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_panel2.png",
                    "tr_specTitle": "ИСПЫТАЙТЕ КАЧЕСТВЕННЫЙ И ДИНАМИЧНЫЙ ИГРОВОЙ ПРОЦЕСС",
                    "tr_specText": "Наслаждайтесь плавным игровым процессом, а также играйте с высокой частотой обновления во множестве игр AAA-класса: от взрывных киберспортивных шутеров до динамичных стратегий в реальном времени. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>технология масштабирования Intel® на основе ИИ для дополнительной производительности и плавного игрового процесса. <br/><br/>Поддержка <strong>DirectX* 12 Ultimate:  </strong>выведите игровой процесс на новый уровень реалистичности с помощью таких графических технологий как трассировка лучей и Variable Rate Shading."
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A750_panel2.png",
                    "tr_specTitle": "НАСЛАЖДАЙТЕСЬ ВЫСОКОЙ ПРОИЗВОДИТЕЛЬ&shy;НОСТЬЮ И ПОЛНЫМ ПОГРУЖЕНИЕМ В ИГРЫ",
                    "tr_specText": "Добейтесь наилучшей производительности в новейших играх AAA-класса с высоким разрешением и частотой обновления. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>технология масштабирования Intel® на основе ИИ для дополнительной производительности и плавного игрового процесса. <br/><br/>Поддержка <strong>DirectX* 12 Ultimate:  </strong>выведите игровой процесс на новый уровень реалистичности с помощью таких графических технологий, как трассировка лучей и Variable Rate Shading."
                  }
                },
                {
                  "specName": "Graphics_Universe",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графика",
                    "tr_specText": "Графическая вселенная, где есть место для каждого"
                  }
                },
                {
                  "specName": "Accelerate_Your_Frames",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel2.png",
                    "tr_specTitle": "УСКОРЬТЕ ЧАСТОТУ КАДРОВ, УСКОРЬТЕ ИГРУ",
                    "tr_specText": "Технология Intel® X<sup class='small_text_sup_xe'>e</sup> Super Sampling (X<sup class='small_text_sup_xe'>e</sup>SS) выводит ваши игры на новый уровень благодаря масштабированию на основе ИИ для максимальной производительности с высокой точностью изображения. Технология X<sup class='small_text_sup_xe'>e</sup>SS оптимизирована для графических продуктов Intel® Arc™, поэтому вы можете в полной мере использовать преимущества аппаратного ускорения расширений Intel® X<sup class='small_text_sup_xe'>e</sup> Matrix (Intel® XMX)."
                  }
                },
                {
                  "specName": "Ultimate_Visuals_Are_Here",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel3.png",
                    "tr_specTitle": "САМЫЕ ЯРКИЕ ВИЗУАЛЬНЫЕ ЭФФЕКТЫ ЗДЕСЬ",
                    "tr_specText": "С полной поддержкой DirectX* 12 Ultimate во всей графике Intel® Arc™ вы сможете наслаждаться потрясающим игровым процессом с эффектом погружения благодаря новейшим графическим технологиям, таким как трассировка лучей, Variable Rate Shading (VRS), Mesh Shading и Sampler Feedback — основам игр нового поколения."
                  }
                },
                {
                  "specName": "Seamless_Photos_And_Videos",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel4.png",
                    "tr_specTitle": "БЕЗУПРЕЧНОЕ СОЗДАНИЕ ФОТОГРАФИЙ, ВИДЕО И МУЛЬТИМЕДИА",
                    "tr_specText": "Дайте волю своему воображению и привлеките внимание аудитории, используя самый передовой медиадвижок, дополненный ИИ и ускоренный с помощью технологий Intel®, для создания цифрового контента. Создавайте впечатляющий контент на основе графики с поддержкой всех ведущих медиаформатов и самых современных возможностей кодирования видео AV1."
                  }
                },
                {
                  "specName": "Experience_Cutting_Edge",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel5.png",
                    "tr_specTitle": "ИСПОЛЬЗУЙТЕ ПЕРЕДОВЫЕ ВОЗМОЖНОСТИ СОЗДАНИЯ КОНТЕНТА И ИГР С ИИ",
                    "tr_specText": "Графика Intel® Arc™ открывает мощные возможности ИИ, от создания контента на продвинутом уровне до игр с эффектом погружения. Получите максимальную отдачу от современного передового программного обеспечения для создания контента, включая генерацию изображений по текстовому описанию и редактирование видео с помощью ИИ. Кроме того, наслаждайтесь игровым процессом с высоким разрешением благодаря масштабированию X<sup class='small_text_sup_xe'>e</sup>SS с ускорением ИИ."
                  }
                },
                {
                  "specName": "Professional_Graphics",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc_pro_badge.png",
                    "tr_specTitle": "Графика",
                    "tr_specText": "Профессиональная графика начинается здесь"
                  }
                },
                {
                  "specName": "Designers_And_Engineers",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel2.png",
                    "tr_specTitle": "ОТЛИЧНО ПОДХОДИТ ДЛЯ&nbsp;СОЗДАТЕЛЕЙ КОНТЕНТА, ДИЗАЙНЕРОВ И&nbsp;ИНЖЕНЕРОВ, РАБОТАЮЩИХ В&nbsp;ДОРОГЕ",
                    "tr_specText": "Встроенная графика Intel® Arc™ Pro, доступная на некоторых процессорах Intel® Core™ Ultra серии H, имеет в два раза более высокую производительность, прошла сертификацию у независимых поставщиков программного обеспечения (ISV) для повышения надежности и обеспечивает эффективное ускорение аппаратного обеспечения с помощью ИИ и трассировки лучей для создания потрясающего контента в пути.<br/><br/><span class='expandable_heading'>Сертификация для ПО<br/></span><br/>На протяжении многих лет корпорация Intel работала рука об руку с сотнями компаний-разработчиков программного обеспечения, и этот непревзойденный опыт воплотился в нашей линейке видеокарт Intel®&nbsp;Arc™&nbsp;Pro серии A. Сертификация важна для нас так же, как и для вас."
                  }
                },
                {
                  "specName": "Making_Ai_Attainable",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel3.png",
                    "tr_specTitle": "ИИ В ВАШЕМ РАСПОРЯЖЕНИИ",
                    "tr_specText": "Эта линейка ГП включает широкий набор великолепных технологий, в том числе поддержку совместимых инструментов искусственного интеллекта со встроенным выделенным ускорением ИИ там, где это необходимо."
                  }
                },
                {
                  "specName": "Ray_Tracing",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel3.png",
                    "tr_specTitle": "ТРАССИРОВКА ЛУЧЕЙ БЕЗ&nbsp;ПРЕМИУМ-КОМПОНЕНТОВ",
                    "tr_specText": "Видеокарты должны не только выводить пиксели на дисплеи, но и ускорять создание красивых изображений. Аппаратная технология трассировки лучей, встроенная в графику Intel® Arc™ Pro серии A, позволяет совместимому программному обеспечению начать использовать эти новые профессиональные рабочие процессы. Принято считать, что трассировка лучей доступна только в дорогих графических системах, но новейшая линейка профессиональной графики Intel® полностью меняет это представление."
                  }
                },
                {
                  "specName": "Immersive_Display",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel5.png",
                    "tr_specTitle": "РАСШИРЕНИЕ ВОЗМОЖНОСТЕЙ СОЗДАТЕЛЕЙ КОНТЕНТА С&nbsp;ПОМОЩЬЮ ДИСПЛЕЕВ С&nbsp;ЭФФЕКТОМ ПОГРУЖЕНИЯ",
                    "tr_specText": "С полной поддержкой DirectX* 12 Ultimate во всей графике Intel® Arc™ вы сможете наслаждаться потрясающим игровым процессом с эффектом погружения благодаря новейшим графическим технологиям, таким как трассировка лучей, Variable Rate Shading (VRS), Mesh Shading и Sampler Feedback — основам игр нового поколения."
                  }
                },
                {
                  "specName": "Dynamically_Optimised_Images",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel6.png",
                    "tr_specTitle": "ДИНАМИЧЕСКИ ОПТИМИЗИРОВАННЫЕ ИЗОБРАЖЕНИЯ",
                    "tr_specText": "Благодаря специальному аппаратному декодированию на графических процессорах Pro, технология Dolby Vision* помогает добавить глубину, контрастность и больше цветов на совместимом дисплее. Dolby Vision* раскрывает весь потенциал технологии HDR путем динамической оптимизации качества изображения на основании сервиса, устройства дисплея и платформы, чтобы каждый раз обеспечивать потрясающее качество изображения."
                  }
                },
                {
                  "specName": "Expertly_Verified_Software",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel2.png",
                    "tr_specTitle": "ЭКСПЕРТНАЯ ПРОВЕРКА ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ",
                    "tr_specText": "На протяжении многих лет корпорация Intel работала рука об руку с сотнями компаний-разработчиков программного обеспечения, и этот непревзойденный опыт воплотился в линейке профессиональной графики Intel®&nbsp;Arc™&nbsp;Pro серии A. Сертификация и квалификация в области программного обеспечения важны для нас так же, как и для вас."
                  }
                },
                {
                  "specName": "Ray_Tracing_Mobile",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel3.png",
                    "tr_specTitle": "ТРАССИРОВКА ЛУЧЕЙ БЕЗ&nbsp;ПРЕМИУМ-КОМПОНЕНТОВ",
                    "tr_specText": "Видеокарты должны не только выводить пиксели на дисплеи, но и ускорять создание красивых изображений. Аппаратная технология трассировки лучей, встроенная в графику Intel® Arc™ Pro серии A, позволяет совместимому программному обеспечению начать использовать эти новые профессиональные рабочие процессы. Принято считать, что трассировка лучей доступна только в дорогих графических системах, но новейшая линейка профессиональной графики Intel® полностью меняет это представление."
                  }
                },
                {
                  "specName": "Multiple_Large_Display",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel4.png",
                    "tr_specTitle": "НЕСКОЛЬКО БОЛЬШИХ ДИСПЛЕЕВ С&nbsp;ОДНИМ КОМПАКТНЫМ ГП ДЛЯ&nbsp;МОБИЛЬНЫХ&nbsp;ПК",
                    "tr_specText": "Графика Intel® Arc™ Pro для ноутбуков может поддерживать до четырех сверхбольших дисплеев для повышения эффективности рабочего процесса. Добавьте поддержку высокого динамического диапазона (HDR), и вы получите все необходимое для&nbsp;создания впечатляющей домашней конфигурации, достойной социальных сетей, или&nbsp;офисной системы с несколькими дисплеями."
                  }
                },
                {
                  "specName": "Full_Memory_Bandwidth",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel5.png",
                    "tr_specTitle": "ВЕСЬ ПОТЕНЦИАЛ ПРОПУСКНОЙ СПОСОБНОСТИ ПАМЯТИ",
                    "tr_specText": "Пропускная способность вашей видеокарты — важный фактор при выборе рабочей станции. Неправильный выбор может замедлить профессиональные рабочие процессы, поэтому мы обеспечили поддержку современного PCIe* 4.0 в&nbsp;графических процессорах Intel® Arc™ Pro серии A без&nbsp;ущерба для обратной совместимости. Высокая скорость пропускной способности графической памяти позволяет программному обеспечению еще&nbsp;быстрее получать доступ к данным проекта."
                  }
                },
                {
                  "specName": "Breathe_Life",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel2.png",
                    "tr_specTitle": "ВДОХНИТЕ ЖИЗНЬ В КАЖДЫЙ КАДР",
                    "tr_specText": "<span class='expandable_heading'>Усиление ИИ. На&nbsp;базе&nbsp;технологий&nbsp;Intel®.<br/></span><br/>Intel® X<sup class='small_text_sup_xe'>e</sup>SS — это технология масштабирования на базе ИИ, которая повышает производительность без ущерба для красоты каждого кадра, чтобы вы могли наслаждаться игровым процессом так, как это было задумано."
                  }
                },
                {
                  "specName": "Real_Immersive",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel3.png",
                    "tr_specTitle": "В РЕЖИМЕ РЕАЛЬНОГО ВРЕМЕНИ.<br/> РЕАЛЬНОЕ ПОГРУЖЕНИЕ.<br/> РЕАЛИСТИЧНОСТЬ В ЕЕ ЛУЧШЕМ ВИДЕ.",
                    "tr_specText": "Более реалистичные миры ждут вас. Благодаря встроенной трассировке лучей вы сможете ощутить все: от реалистичных теней и отражений до искусного освещения. Другими словами, это визуальный игровой опыт, который вы не захотите упустить."
                  }
                },
                {
                  "specName": "Your_Best_Gameplay",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel4.png",
                    "tr_specTitle": "ВАШ ЛУЧШИЙ ИГРОВОЙ ПРОЦЕСС, ПРЕДСТАВЛЕННЫЙ В ЛУЧШЕМ ВИДЕ",
                    "tr_specText": "Подарите своей аудитории плавный геймплей, который она просто должна увидеть. Благодаря возможностям кодирования AV1 с аппаратным ускорением графики Intel® Arc™ их будет завораживать каждое ваше движение. Более высокое качество изображения при том же битрейте обеспечивает оптимальный стриминг при экономии пропускной способности."
                  }
                },
                {
                  "specName": "Welcome_All_Creators",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel5.png",
                    "tr_specTitle": "Приветствуем создателей контента",
                    "tr_specText": "Новые и усовершенствованные возможности ИИ всегда под рукой. Благодаря передовым ускорителям ИИ, встроенным в графику Intel® Arc™ серии А, вы сможете больше времени уделять творчеству и меньше — ожиданию в различных приложениях.<br/><br/>Выведите создание видео на новый уровень и станьте лидером благодаря высокому качеству и эффективному хранению видео AV1 с передовыми аппаратными возможностями сжатия, встроенными в графику Intel® Arc™."
                  }
                },
                {
                  "specName": "Graphics_Universe_B",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Современные технологии, улучшенная графика, отличный геймплей.",
                    "tr_specText": "Играйте, создавайте, генерируйте"
                  }
                },
                {
                  "specName": "Game_Ready",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel1.png",
                    "tr_specTitle": "ВСЕГДА ГОТОВ К&nbsp;ИГРЕ, С&nbsp;МНОЖЕСТВОМ ПОЛЕЗНЫХ ФУНКЦИЙ",
                    "tr_specText": "Наслаждайтесь высокой производительностью в новейших играх с разрешением <strong>1080p</strong> и <strong>1440p</strong> благодаря масштабированию ИИ и трассировке лучей.<br><br/> Получите производительность и функции, о которых мечтали, по доступной цене.",
                    "subSpecs": [
                      {
                        "tr_title": "Разрешение <strong>1440p<br></strong>"
                      }
                    ]
                  }
                },
                {
                  "specName": "Game_Changing_Modern_Tech",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel2.png",
                    "tr_specTitle": "СОВРЕМЕННЫЕ РЕВОЛЮЦИОННЫЕ ТЕХНОЛОГИИ",
                    "tr_specText": "Повысьте производительность, быстродействие и другие характеристики с помощью игровых технологий графики Intel®&nbsp;Arc™.<br><br/> Получите исключительную производительность и визуальное качество в более чем 150 играх, поддерживаемых технологией Intel® X<sup>e</sup> Super Sampling (X<sup>e</sup>SS) с ускорением ИИ.<br><br/> Сделайте свои игры более плавными и быстрыми благодаря технологиям Intel® X<sup>e</sup>SS Frame Generation и Intel® X<sup>e</sup> Low Latency от Intel.",
                    "subSpecs": [
                      {
                        "tr_title": "<strong>10 ГБ<br></strong>памяти"
                      },
                      {
                        "tr_title": "<strong>Более 150<br></strong>игр"
                      },
                      {
                        "tr_title": "<strong>Intel® X<sup>e</sup>SS<br></strong>"
                      }
                    ]
                  }
                },
                {
                  "specName": "Software_Releases",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel3.png",
                    "tr_specTitle": "АКТУАЛЬНЫЕ ОБНОВЛЕНИЯ ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ",
                    "tr_specText": "Следите за регулярными обновлениями программного обеспечения, поддерживающего новейшие игры, и используйте игровые возможности, которые постоянно улучшаются."
                  }
                },
                {
                  "specName": "Creator_Toolkit",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel4.png",
                    "tr_specTitle": "УНИВЕРСАЛЬНЫЙ ИНСТРУМЕНТАРИЙ ДЛЯ СОЗДАТЕЛЕЙ КОНТЕНТА",
                    "tr_specText": "Экономьте время и быстро экспортируйте видео с помощью двух мультимедийных транскодеров, поддерживающих двойное кодирование. Создавайте контент с поддержкой самых популярных медиаформатов, включая передовой AV1.<br><br/> Мощный медиа-движок Intel® X<sup>e</sup> позволяет быстро создавать и редактировать контент в высоком разрешении."
                  }
                },
                {
                  "specName": "Explore_AI",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel5.png",
                    "tr_specTitle": "СОЗДАН ДЛЯ ОСВОЕНИЯ&nbsp;ИИ",
                    "tr_specText": "Используйте новейшие возможности ИИ, такие как чат&#8209;боты ИИ и преобразование текста в изображения, прямо на ПК. AI Playground, бесплатное частное приложение, объединяет различные возможности ИИ для простоты использования.<br><br/> Наслаждайтесь усовершенствованными играми, ускоренным созданием контента и многими другими преимуществами благодаря специализированным движкам ИИ, которые встроены в графику Intel® Arc™ и называются Intel® Xe Matrix Extensions (Intel®&nbsp;XMX).",
                    "subSpecs": [
                      {
                        "tr_title": "<strong>144<br></strong>движка ИИ<br>Intel® XMX"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "os": [
    {
      "contentType": "WINDOWS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операционная система",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "header-IconTop",
                "badgeUrl": "",
                "tr_title": "Все необходимое для продуктивной работы",
                "tr_pretitle": "Windows* 10",
                "tr_subtitle": "Мощный, тонкий, легкий и надежный – вам не нужно выбирать между этими качествами. Компьютеры с Windows 10 способны предложить вам все самое лучшее, в том числе аккумуляторы большой емкости, прекрасные сенсорные экраны* и новейшие твердотельные накопители (SSD).",
                "tr_noteSection": "*Зависит от используемого оборудования",
                "titleArray": [
                  {
                    "tr_title": "Меньше значит дольше",
                    "tr_subtitle": "Современные компьютеры обычно потребляют меньше энергии, а значит, могут дольше работать в автономном режиме – в среднем, восемь с лишним часов в режиме воспроизведения видео.**",
                    "tr_noteSection": "**Время работы от батареи существенно зависит от устройства, настроек, режима использования и других факторов."
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операционная система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "header-IconTopGaming",
                "tr_pretitle": "ВСЕ НЕОБХОДИМОЕ ДЛЯ ПРОДУКТИВНОЙ РАБОТЫ",
                "tr_title": "Windows* 10",
                "tr_subtitle": "Мощный, тонкий, легкий и надежный – вам не нужно выбирать между этими качествами. Компьютеры с Windows 10 способны предложить вам все самое лучшее, в том числе аккумуляторы большой емкости, прекрасные сенсорные экраны* и новейшие твердотельные накопители (SSD).",
                "tr_noteSection": "*Зависит от используемого оборудования",
                "titleArray": [
                  {
                    "tr_title": "МЕНЬШЕ ЗНАЧИТ ДОЛЬШЕ",
                    "tr_subtitle": "Современные компьютеры обычно потребляют меньше энергии, а значит, могут дольше работать в автономном режиме – в среднем, восемь с лишним часов в режиме воспроизведения видео.**",
                    "tr_noteSection": "**Время работы от батареи существенно зависит от устройства, настроек, режима использования и других факторов."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWSUWP",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операционная система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Оптимизация для безопасности и производитель&shy;ности",
                "tr_pretitle": "Windows* 10 в режиме S",
                "tr_subtitle": "При запуске Windows* 10 в S-режиме вы получаете дополнительный слой безопасности, благодаря чему вы можете спокойно работать, играть и заниматься творчеством, зная, что ваше устройство полностью защищено."
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операционная система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ОПТИМИЗАЦИЯ ДЛЯ БЕЗОПАСНОСТИ И ПРОИЗВОДИТЕЛЬ&shy;НОСТИ",
                "tr_title": "Windows* 10 в режиме S",
                "tr_subtitle": "При запуске Windows* 10 в S-режиме вы получаете дополнительный слой безопасности, благодаря чему вы можете спокойно работать, играть и заниматься творчеством, зная, что ваше устройство полностью защищено."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWS_GENERIC",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операционная система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Воплощайте невероятное",
                "tr_pretitle": "Windows*",
                "tr_subtitle": "Большой выбор вариантов производительности, цены и функциональности. Инновационные устройства 2 в 1, тонкие и легкие ноутбуки, сенсорные экраны, съемные клавиатуры и многое другое&nbsp;— ПК с Windows* подойдут для любого бюджета и образа жизни."
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операционная система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ВОПЛОЩАЙТЕ НЕВЕРОЯТНОЕ",
                "tr_title": "Windows*",
                "tr_subtitle": "Большой выбор вариантов производительности, цены и функциональности. Инновационные устройства 2 в 1, тонкие и легкие ноутбуки, сенсорные экраны, съемные клавиатуры и многое другое&nbsp;— ПК с Windows* подойдут для любого бюджета и образа жизни."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "LINUX",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операционная система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "",
                "tr_pretitle": "LINUX*",
                "tr_subtitle": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWS_11",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операционная система",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "image-only-panel",
                "panelType2": "header-IconTop",
                "badgeUrl": "",
                "tr_title": "",
                "tr_pretitle": "",
                "badgeIcons": [
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/1.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/2.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/3.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/4.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/5.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/6.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/7.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/8.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/9.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/10.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/11.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/12.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/13.png"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "memory": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Память",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_title": "СКОЛЬКО ОПЕРАТИВНОЙ ПАМЯТИ ВАМ НУЖНО?",
                "tr_subtitle": "",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "Повседневные задачи — ОТ 2 ДО 8&nbsp;ГБ ОЗУ",
                    "tr_badgeSubTitle": "Идеально подходит для редактирования документов, просмотра веб-страниц и работы с небольшим количеством программ одновременно."
                  },
                  {
                    "tr_badgeTitle": "Продвинутые задачи — ОТ 8 ДО 16&nbsp;ГБ ОЗУ",
                    "tr_badgeSubTitle": "С большим объемом оперативной памяти ваши приложения будут работать быстрее, и вы также сможете запускать больше приложений одновременно."
                  },
                  {
                    "tr_badgeTitle": "Ресурсоемкие задачи&nbsp;— БОЛЕЕ 16&nbsp;ГБ ОЗУ",
                    "tr_badgeSubTitle": "Для игр, фото, видео, 3D-моделирования и других ресурсоемких программ вам потребуется дополнительный объем оперативной памяти."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GOOD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ПАМЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[XX]&nbsp;ГБ оперативной памяти для многозадачности",
                "tr_subtitle": "Системная память обеспечивает быструю загрузку и бесперебойную работу основных приложений, таких как текстовый редактор и веб-браузер.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ОЗУ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BETTER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ПАМЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[XX]&nbsp;ГБ ОЗУ для выполнения продвинутых задач в многозадачном режиме",
                "tr_subtitle": "Если вы используете несколько программ одновременно, [memory_total]&nbsp;ГБ оперативной памяти позволят вам с легкостью переключаться между ними.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ОЗУ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BEST",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ПАМЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[XX]&nbsp;ГБ ОЗУ для выполнения ресурсоемких задач в многозадачном режиме",
                "tr_subtitle": "У вас будет достаточно памяти для запуска нескольких ресурсоемких программ одновременно без замедления работы компьютера.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ОЗУ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ПАМЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[Value1] ГБ памяти = [Value2]&nbsp;ГБ памяти&nbsp;Intel®&nbsp;Optane™ +&nbsp;[Value3]&nbsp;ГБ ОЗУ",
                "tr_subtitle": "Такое сочетание запоминающих устройств обеспечивает повышенную производительность жесткого диска благодаря памяти Intel® Optane™ и более высокую скорость отклика оперативной памяти.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ПАМЯТИ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Память Intel® Optane™",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "tr_title": "Меньше ожидания. Больше любимых занятий.",
                "tr_subtitle": "При совместной работе памяти Intel® Optane™ с памятью вашей системы обеспечивается более быстрый доступ к часто используемым программам, поэтому они запускаются и загружаются в нужный момент.",
                "tr_pretitle": "[XX] ГБ памяти Intel® Optane™",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "titleArray": [
                  {
                    "tr_title": "КАКУЮ РОЛЬ ИГРАЕТ ПАМЯТЬ В ПК?"
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-optane-faster-content.png",
                    "tr_badgeTitle": "Более быстрое создание контента",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-responsive-gaming.png",
                    "tr_badgeTitle": "Более высокое быстродействие в играх",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-easier-multitasking.png",
                    "tr_badgeTitle": "Более эффективная многозадачность",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-open-programs.png",
                    "tr_badgeTitle": "Более быстрый запуск программ",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Память Intel® Optane™",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "panelType2": "",
                "panelType1": "badgesAndHeadings-memory",
                "tr_title": "<span class='intelOptanMemoryTitle'>Ускорьте свои игры</span>",
                "tr_pretitle": "[XX] ГБ памяти Intel® Optane™",
                "tr_pretitle1": "[XX] ГБ памяти Intel®&nbsp;Optane™ ускоряют&nbsp;игры",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "Запуск игр до<br/><span class=\"optane-game\">98% быстрее</span><br/>с накопителя при использовании процессора [optane_legal_processor_name] и памяти Intel®&nbsp;Optane™<sup>15</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "Загрузка уровней до<br/><span class=\"optane-game\">4,1 раза быстрее</span><br/>с накопителя при использовании процессора [optane_legal_processor_name] и памяти Intel®&nbsp;Optane™<sup>16</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            },
            {
              "deviceType": "DEFAULT_A",
              "details": {
                "tr_tileTitle": "Память Intel® Optane™",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "panelType2": "",
                "panelType1": "badgesAndHeadings-memory",
                "tr_title": "<span class='intelOptanMemoryTitle'>Ускорьте свои игры</span>",
                "tr_pretitle": "[XX] ГБ памяти Intel® Optane™",
                "tr_pretitle1": "[XX] ГБ памяти Intel® Optane™ ускоряют игры",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "Запуск игр до<br/><span class=\"optane-game\">98% быстрее</span><br/>с накопителя при использовании процессора [optane_legal_processor_name] и памяти Intel®&nbsp;Optane™<sup>15</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "Загрузка уровней до<br/><span class=\"optane-game\">4,1 раза быстрее</span><br/>с накопителя при использовании процессора [optane_legal_processor_name] и памяти Intel®&nbsp;Optane™<sup>16</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ПАМЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "[Value1] ГБ памяти = [Value2] ГБ памяти Intel® Optane™ + [Value3] ГБ ОЗУ",
                "tr_subtitle": "Такое сочетание запоминающих устройств обеспечивает повышенную производительность жесткого диска благодаря памяти Intel® Optane™ и более высокую скорость отклика оперативной памяти.",
                "titleArray": [
                  {
                    "tr_title": "[XX]&nbsp;ГБ ОЗУ для работы в многозадачном режиме",
                    "tr_subtitle": "Если вы используете несколько программ одновременно, [memory_total]&nbsp;ГБ оперативной памяти позволят вам с легкостью переключаться между ними."
                  },
                  {
                    "tr_title": "Для повседневных задач",
                    "tr_subtitle": "Системная память обеспечивает быструю загрузку и бесперебойную работу основных приложений, таких как текстовый редактор и веб-браузер."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "DEFAULT",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ПАМЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_title": "[XX] ГБ ОЗУ",
                "tr_pretitle": "ДЛЯ ЛУЧШЕЙ МНОГОЗАДАЧНОСТИ",
                "tr_subtitle": "Оперативная память обеспечивает процессору более быстрый доступ к файлам программ, позволяя ему выполнять несколько задач одновременно.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "Стандартный объем памяти",
                    "tr_badgeSubTitle": "До 8 ГБ ОЗУ"
                  },
                  {
                    "tr_badgeTitle": "Расширенный объем памяти",
                    "tr_badgeSubTitle": "От 8 до 16 ГБ оперативной памяти"
                  },
                  {
                    "tr_badgeTitle": "Элитный объем памяти",
                    "tr_badgeSubTitle": "Более 16 ГБ ОЗУ"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GAMING_12TH_MEMORY",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ПАМЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_title": "[XX] ГБ для улучшенной многозадачности",
                "tr_pretitle": "ДЛЯ ЛУЧШЕЙ МНОГОЗАДАЧНОСТИ",
                "tr_subtitle": "Оперативная память обеспечивает процессору более быстрый доступ к файлам программ, позволяя ему выполнять несколько задач одновременно.",
                "gamingPanleType2": "gaming-panelType1",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "Стандартный объем памяти",
                    "tr_badgeSubTitle": "До 8 ГБ ОЗУ"
                  },
                  {
                    "tr_badgeTitle": "Расширенный объем памяти",
                    "tr_badgeSubTitle": "От 8 до 16 ГБ оперативной памяти"
                  },
                  {
                    "tr_badgeTitle": "Элитный объем памяти",
                    "tr_badgeSubTitle": "Более 16 ГБ ОЗУ"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ОБЪЕМ ПАМЯТИ В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Стандартная",
                      "tr_badgeSubTitle": "<span class='memory-value'>8&nbsp;ГБ <span class='ram_value'>ОЗУ</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Улучшенная",
                      "tr_badgeSubTitle": "<span class='memory-value'>16&nbsp;ГБ <span class='ram_value'>ОЗУ</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Элитная",
                      "tr_badgeSubTitle": "<span class='memory-value'>32&nbsp;ГБ <span class='ram_value'>ОЗУ</span></span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STANDARD_COMMON_12TH_MEMORY",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Память",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_title": "ЭТОТ ОБЪЕМ ПАМЯТИ В СРАВНЕНИИ С ДРУГИМИ",
                "tr_subtitle": "",
                "gamingPanleType2": "gaming-panelType1",
                "enhancementCompare": {
                  "tr_title": "ЭТОТ ОБЪЕМ ПАМЯТИ В СРАВНЕНИИ С ДРУГИМИ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Текущее устройство",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Повседневные задачи",
                      "tr_badgeSubTitle": "<span class='memory-value'>8&nbsp;ГБ <span class='ram_value'>ОЗУ</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Продвинутые задачи",
                      "tr_badgeSubTitle": "<span class='memory-value'>16&nbsp;ГБ <span class='ram_value'>ОЗУ</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Ресурсоемкие задачи",
                      "tr_badgeSubTitle": "<span class='memory-value'>32&nbsp;ГБ <span class='ram_value'>ОЗУ</span></span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ],
  "storage": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Хранилище данных",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png",
                "tr_title": "КАКОЙ ОБЪЕМ ДАННЫХ МОЖЕТ ХРАНИТЬ ВАШ ПК?",
                "tr_subtitle": "Не нужно угадывать. Мы покажем, что именно можно хранить на этом ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/storage-songs-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>Создайте библиотеку из</span> <br/><span class=\"storage-standard\">[num_songs] песен<sup>†</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>†</sup> На основе допущения, что в среднем размер песни составляет 5&nbsp;МБ",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-game-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>Создайте библиотеку из</span><br/><span class=\"storage-standard\">[num_games] игр<sup>†</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>†</sup> На основе допущения, что в среднем размер игры составляет 40&nbsp;ГБ",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-videos-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>Хранилище для</span><br/><span class=\"storage-standard\">[num_videos] видео<sup>§</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>§</sup> На основе допущения, что в среднем размер видео составляет 5&nbsp;ГБ",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-photos-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>Снимайте и храните</span><br/><span class=\"storage-standard\">[num_photos] фотографий<sup>^</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>^</sup> На основе допущения, что в среднем размер фотографии составляет 4&nbsp;МБ",
                    "imgUrl": ""
                  }
                ],
                "titleArray": [
                  {
                    "storageType": "HDD",
                    "tr_pretitle": "Жесткий диск [capacity] ГБ"
                  },
                  {
                    "storageType": "SSD",
                    "tr_pretitle": "SSD-накопи&shy;тель емкостью [capacity] ГБ"
                  },
                  {
                    "storageType": "SSD_AND_HDD",
                    "tr_pretitle": ""
                  },
                  {
                    "storageType": "OPTANE",
                    "tr_pretitle": "Память Intel® Optane™ емкостью [total_optane_memory]&nbsp;ГБ + SSD-накопитель емкостью [convertedSSD]&nbsp;ГБ"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "SSD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ХРАНИЛИЩЕ ДАННЫХ",
                "tileBG": "",
                "badgeUrl": "assets/images/std12storage.svg",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_preTitle": "SSD-накопитель [capacity] ГБ",
                "tr_preTitle1": "SSD-накопитель [capacity] ТБ",
                "titleArray": [
                  {
                    "detailPageName": "WIN10S_Storage",
                    "tr_subtitle": "Этот ПК оснащен SSD-накопителем емкостью [capacity] ГБ. Это означает, что вы сможете сохранять впечатляющее количество фотографий, видео и программ и получать к ним доступ гораздо быстрее, чем при использовании жесткого диска.",
                    "tr_title": "Хранилище данных на вашем ПК"
                  },
                  {
                    "detailPageName": "WIN10S_Storage-1000",
                    "tr_subtitle": "Этот ПК оснащен SSD-накопителем емкостью [capacity] ТБ. Это означает, что вы сможете сохранять впечатляющее количество фотографий, видео и программ и получать к ним доступ гораздо быстрее, чем при использовании жесткого диска.",
                    "tr_title": "Это устройство оснащено впечатляющим хранилищем"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[capacity] ГБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span>  ",
                    "tr_badgeTitle1": "<span class='value'>[capacity] ТБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span> ",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "SSD-НАКОПИ&shy;ТЕЛЬ",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "HDD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ХРАНИЛИЩЕ ДАННЫХ",
                "badgeUrl": "assets/images/std12storage.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgeAndHeadings",
                "tr_preTitle": "Жесткий диск [capacity] ГБ",
                "tr_preTitle1": "Жесткий диск [capacity] ТБ",
                "titleArray": [
                  {
                    "detailPageName": "WIN10S_Storage",
                    "tr_subtitle": "Жесткие диски — хороший выбор для тех, кому требуется накопитель большой емкости непосредственно на ПК.",
                    "tr_title": "Хранилище данных на вашем ПК"
                  },
                  {
                    "detailPageName": "WIN10S_Storage-1000",
                    "tr_subtitle": "Жесткие диски — хороший выбор для тех, кому требуется накопитель большой емкости непосредственно на ПК.",
                    "tr_title": "Это устройство оснащено впечатляющим хранилищем"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[capacity]<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "Жесткий диск",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ХРАНИЛИЩЕ ДАННЫХ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "tr_title": "",
                "tr_pretitle": "КАКОЙ ОБЪЕМ ДАННЫХ МОЖЕТ ХРАНИТЬ ВАШ ПК?",
                "tr_subtitle": "Не нужно угадывать. Мы покажем, что именно можно хранить на этом ПК.",
                "titleArray": [
                  {
                    "tr_title": "Жесткий диск емкостью [XX]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "SSD-накопи&shy;тель емкостью [XX]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "SSD-накопитель Intel® емкостью [total_capacity]&nbsp;ГБ с повышенной производительностью благодаря памяти Intel® Optane™ емкостью [optane_memory_size]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "SSD-накопитель Intel® емкостью [total_capacity] ТБ с повышенной производительностью благодаря памяти Intel® Optane™ емкостью [optane_memory_size]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "SSD-накопитель емкостью [convertedSSD]&nbsp;ГБ + жесткий диск емкостью [convertedHDD]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "SSD-накопитель емкостью [convertedSSD]&nbsp;ТБ + жесткий диск емкостью [convertedHDD]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "SSD-накопитель емкостью [convertedSSD]&nbsp;ГБ + жесткий диск емкостью [convertedHDD]&nbsp;ТБ"
                  },
                  {
                    "tr_title": "SSD-накопитель емкостью [convertedSSD]&nbsp;ТБ + жесткий диск емкостью [convertedHDD]&nbsp;ТБ"
                  }
                ],
                "badgeIcons": [
                  {
                    "storageType": "GB",
                    "items": [
                      {
                        "tr_badgeTitle": "<span class='value'>[capacity] ГБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span>  ",
                        "tr_badgeSubTitle": "SSD-НАКОПИ&shy;ТЕЛЬ"
                      },
                      {
                        "tr_badgeTitle": "<span class='value'>[capacity] ГБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span>  ",
                        "tr_badgeSubTitle": "Жесткий диск"
                      },
                      {
                        "tr_badgeTitle": "<span class='value'>[capacity] ГБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span>  ",
                        "tr_badgeSubTitle": "<span class='subtitle-value'>SSD-накопитель<br/><span class='storage-seperator'> +  </span><br/>Жесткий диск</span>"
                      }
                    ]
                  },
                  {
                    "storageType": "TB",
                    "items": [
                      {
                        "tr_badgeTitle": "<span class='value'>[capacity] ТБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span> ",
                        "tr_badgeSubTitle": "SSD-НАКОПИ&shy;ТЕЛЬ"
                      },
                      {
                        "tr_badgeTitle": "<span class='value'>[capacity] ТБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span> ",
                        "tr_badgeSubTitle": "Жесткий диск"
                      },
                      {
                        "tr_badgeTitle": "<span class='value'>[capacity] ТБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span> ",
                        "tr_badgeSubTitle": "<span class='subtitle-value'>SSD-накопитель<br/><span class='storage-seperator'> +  </span><br/>Жесткий диск</span>"
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "SSD_AND_HDD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ХРАНИЛИЩЕ ДАННЫХ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12storage.svg",
                "tr_preTitle": "SSD-накопитель [convertedSSD] ГБ +&nbsp;жесткий&nbsp;диск&nbsp;[convertedHDD]&nbsp;ГБ",
                "tr_preTitle1": "SSD-накопитель [convertedSSD] ТБ +&nbsp;жесткий&nbsp;диск&nbsp;[convertedHDD]&nbsp;ГБ",
                "tr_preTitle2": "SSD-накопитель [convertedSSD] ГБ +&nbsp;жесткий&nbsp;диск&nbsp;[convertedHDD]&nbsp;ТБ",
                "tr_preTitle3": "SSD-накопитель [convertedSSD] ТБ +&nbsp;жесткий&nbsp;диск&nbsp;[convertedHDD]&nbsp;ТБ",
                "titleArray": [
                  {
                    "tr_title": "Хранилище данных на вашем ПК",
                    "tr_title1": "Это устройство оснащено впечатляющим хранилищем",
                    "tr_subtitle": "Этот ПК оснащен SSD-накопителем емкостью [convertedSSD] ГБ и жестким диском емкостью [convertedHDD] ГБ. Это обеспечит как огромную емкость, так и высокую производительность хранилища.",
                    "tr_subtitle1": "Этот ПК оснащен SSD-накопителем емкостью [convertedSSD] ТБ и жестким диском емкостью [convertedHDD] ГБ. Это обеспечит как огромную емкость, так и высокую производительность хранилища.",
                    "tr_subtitle2": "Этот ПК оснащен SSD-накопителем емкостью [convertedSSD] ГБ и жестким диском емкостью [convertedHDD] ТБ. Это обеспечит как огромную емкость, так и высокую производительность хранилища.",
                    "tr_subtitle3": "Этот ПК оснащен SSD-накопителем емкостью [convertedSSD] ТБ и жестким диском емкостью [convertedHDD] ТБ. Это обеспечит как огромную емкость, так и высокую производительность хранилища."
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[capacity] ГБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span>  ",
                    "tr_badgeTitle1": "<span class='value'>[capacity] ТБ<br/></span><span class='subtitle-value'>ХРАНИЛИЩЕ ДАННЫХ</span> ",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle-value'>SSD-накопитель<br/><span class='storage-seperator'> +  </span><br/>Жесткий диск</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ХРАНИЛИЩЕ ДАННЫХ",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_storage.svg",
                "badgeUrl2": "assets/images/std12storage.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "Ускоренный доступ к SSD большой емкости благодаря памяти Intel® Optane™.",
                "tr_title": "Не бойтесь огромных файлов",
                "tr_pretitle": "SSD-накопитель Intel® емкостью [total_capacity]&nbsp;ГБ с повышенной производительностью благодаря памяти Intel® Optane™ емкостью [optane_memory_size]&nbsp;ГБ",
                "tr_pretitle1": "SSD-накопитель Intel® емкостью [total_capacity] ТБ с повышенной производительностью благодаря памяти Intel® Optane™ емкостью [optane_memory_size]&nbsp;ГБ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "SSD-НАКОПИ&shy;ТЕЛЬ",
                    "tr_badgeSubTitle": ""
                  }
                ],
                "titleArray": [
                  {
                    "tr_subtitle": "Это революционное решение для хранения данных впервые объединяет память Intel® Optane™ и твердотельный накопитель в одной микросхеме. Преимущества:",
                    "tr_title": "ЧТО ТАКОЕ ПАМЯТЬ INTEL® OPTANE™ С SSD-НАКОПИТЕЛЕМ?"
                  }
                ],
                "panel2BadgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-frequency-badge.png",
                    "tr_badgeTitle": "Быстрое открытие необходимых данных",
                    "tr_badgeSubTitle": "Благодаря предварительной загрузке часто используемых файлов и программ вы можете тратить больше времени на творчество и меньше на ожидание.",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/optane-memory-storage-badge.svg",
                    "tr_badgeTitle": "Сочетание большой емкости и скорости",
                    "tr_badgeSubTitle": "У вас будет достаточно места для медиафайлов в сочетании с высокой производительностью твердотельного накопителя.",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-time-badge.png",
                    "tr_badgeTitle": "Повышение быстродействия в процессе работы",
                    "tr_badgeSubTitle": "Память Intel® Optane™ с SSD-накопителем анализирует ваши действия для более эффективной работы ПК.",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ХРАНИЛИЩЕ ДАННЫХ",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "Ваши файлы мультимедиа всегда под рукой благодаря большому объему хранилища данных.",
                "tr_title": "Пространство для всех ваших фотографий, видео и песен"
              }
            }
          ]
        }
      ]
    }
  ],
  "display": [
    {
      "contentType": "TOUCH_SCREEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Дисплей",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "",
                "tr_title": "[screenResolution] млн пикселей с&nbsp;сенсорным управлением для&nbsp;вашего восхищения",
                "tr_subtitle": "Взаимодействуйте со своим ПК как со смартфоном благодаря интуитивно понятному управлению, а также более четкому и реалистичному изображению.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class ='value'>[screenDiagonal]”<br/></span><span class='subtitle-value'>[screenResolutionType]</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "Разрешение: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "Количество пикселей: [screenResolution] млн"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "Дисплей с диагональю [screenDiagonal]&nbsp;дюймов",
                    "tr_badgeSubTitle": "Высота экрана: [screenHeight]″",
                    "tr_badgePreTitle": "Ширина экрана: [YY]″"
                  },
                  {
                    "badgeUrl": "assets/images/display-touchscreen-badge.svg",
                    "tr_badgeTitle": "Сенсорный дисплей",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "DISPLAY",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Дисплей",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "",
                "tr_title": "Погрузитесь в&nbsp;[screenResolution]&nbsp;миллионов пикселей",
                "tr_subtitle": "Все дело в пикселях. Чем их больше, тем более четкими и реалистичными будут изображения.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class ='value'>[screenDiagonal]”<br/></span><span class='subtitle-value'>[screenResolutionType]</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "Разрешение: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "Количество пикселей: [screenResolution] млн"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "Дисплей с диагональю [screenDiagonal]&nbsp;дюймов",
                    "tr_badgeSubTitle": "Высота экрана: [screenHeight]″",
                    "tr_badgePreTitle": "Ширина экрана: [YY]″"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Дисплей",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/display-badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "badgesAndHeadings",
                "tr_title": "[screenDiagonal]&nbsp;дюймов <br/>[screenResolutionX] x [screenResolutionY]",
                "tr_pretitle": "ОКНО В ВАШУ ИГРОВУЮ ВСЕЛЕННУЮ",
                "tr_subtitle": "Для геймерского экрана, как и для обычного телевизора, важны размер и разрешение.",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "Разрешение: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "Количество пикселей: [screenResolution] млн"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "Дисплей с диагональю [screenDiagonal]&nbsp;дюймов",
                    "tr_badgeSubTitle": "Высота экрана: [screenHeight]″",
                    "tr_badgePreTitle": "Ширина экрана: [screenWidth]″"
                  },
                  {
                    "badgeUrl": "assets/images/display-touchscreen-badge.svg",
                    "tr_badgeTitle": "Сенсорный дисплей"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "4K",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Дисплей",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "4K",
                "tr_title": "Это устройство оснащено впечатляющим дисплеем",
                "tr_subtitle": "Более чем восьмикратное увеличение количества пикселей, по сравнению с разрешением HD, обеспечивает совершенно новый уровень четкости и цветопередачи для ваших видео и игр.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "4K",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "Разрешение: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "Количество пикселей: [screenResolution] млн"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "Дисплей с диагональю [screenDiagonal]&nbsp;дюймов",
                    "tr_badgeSubTitle": "Высота экрана: [screenHeight]″",
                    "tr_badgePreTitle": "Ширина экрана: [YY]″"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Дисплей",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "[screenResolution] миллионов пикселей с сенсорным управлением для вашего восхищения",
                    "tr_subTitle": "Смотрите свой любимый контент и взаимодействуйте с ним, наслаждаясь более высокой и реалистичной детализацией."
                  },
                  {
                    "tr_title": "[screenResolution] млн пикселей для расширения цифровых возможностей",
                    "tr_subTitle": "Все дело в пикселях. Чем их больше, тем более четкими и реалистичными будут изображения."
                  },
                  {
                    "tr_title": "Это устройство оснащено впечатляющим дисплеем",
                    "tr_subTitle": "Поскольку здесь почти в четыре раза больше пикселей, чем в разрешении HD, ваши видео и игры выйдут на совершенно новый уровень четкости и цвета."
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "connectivity": [
    {
      "contentType": "VERSION_3",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Подключение",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "Технология Thunderbolt™ 3 обеспечивает самое быстрое и универсальное подключение к любой док-станции, дисплею или устройству хранения данных.",
                "tr_title": "Один универсальный порт",
                "tr_title1": "ОДИН УНИВЕРСАЛЬНЫЙ ПОРТ",
                "titleArray": [
                  {
                    "tr_title": "КАК ИСПОЛЬЗОВАТЬ ТЕХНОЛОГИЮ THUNDERBOLT™ 3?",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Технология Thunderbolt™ 3"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-4k.png",
                    "tr_badgeTitle": "4K-мониторы",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Подключение к дисплеям с потрясающим разрешением, контрастностью и цветопередачей"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-graphic.png",
                    "tr_badgeTitle": "Внешняя видеокарта",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Мгновенная модернизация графики на любом ПК"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-networking.png",
                    "tr_badgeTitle": "Быстрое сетевое подключение",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Обеспечивает быстрое одноранговое подключение"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Подключение",
                "detailBGUrl": "",
                "tr_subtitle": "Технология Thunderbolt™ 3 передает данные с более высокой скоростью, чем USB, что позволяет быстро перемещать файлы и легко интегрировать периферийные устройства, например несколько мониторов или внешние видеокарты.",
                "tr_title": "Технология Thunderbolt™ 3",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_pretitle": "МОЛНИЕНОСНАЯ ПЕРЕДАЧА ДАННЫХ",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "USB* 2.0",
                    "tr_badgeSubTitle": "480 Мбит/с",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "USB* 3.0",
                    "tr_badgeSubTitle": "5 Гбит/с",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Технология Thunderbolt™ 3",
                    "tr_badgeSubTitle": "40 Гбит/с",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_4",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Подключение",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "<ul><li>Один универсальный порт для всех периферийных устройств</li> <li>Одновременная зарядка ноутбука</li> <li>Стандарт, заслуживающий доверие</li></ul>",
                "tr_title": "Поистине универсальный кабель",
                "tr_title1": "ПОИСТИНЕ УНИВЕРСАЛЬНЫЙ КАБЕЛЬ",
                "tr_noteSection": "<sup>†</sup> На основе минимальных требований спецификации",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "tr_title": "КАК ИСПОЛЬЗОВАТЬ ТЕХНОЛОГИЮ THUNDERBOLT™ 4?",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Технология Thunderbolt™ 4"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-create.png",
                    "tr_badgeTitle": "Заниматься творчеством",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Подключите внешний монитор и быстрый накопитель для просмотра и редактирования фотографий и видео."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "Док-станция",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Создайте аккуратное и удобное рабочее пространство, подключив к ноутбуку все необходимые аксессуары с помощью одного кабеля."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-game.png",
                    "tr_badgeTitle": "Играй",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Подключите внешний SSD-накопитель или жесткий диск со скоростью передачи данных до 3000 МБ/с для хранения игровых библиотек и мультимедийных файлов."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "Максимальная производительность<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "В 4 раза быстрее USB* 3.2 <br/>В 2 раза быстрее HDMI* 2"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Подключение",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "Оцените потрясающую производительность технологии Thunderbolt™ 3 в сочетании с расширенными возможностями для подключения новейших совместимых док-станций, мониторов, накопителей и любых устройств с интерфейсом USB*.",
                "tr_title": "Технология Thunderbolt™ 4",
                "tr_pretitle": "ПОИСТИНЕ УНИВЕРСАЛЬНЫЙ КАБЕЛЬ",
                "tr_noteSection": "<sup>†</sup> На основе минимальных требований спецификации",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/thunderbolt-icon.png",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "Один универсальный кабель Thunderbolt™ 4 способен легко заменить все кабели USB-C*."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "Док-станции с технологией Thunderbolt™ 4 имеют до четырех портов Thunderbolt™ и обеспечивают большую гибкость при подключении любых аксессуаров."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "Максимальная производительность<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "В 4 раза быстрее USB* 3.2 <br/>В 2 раза быстрее HDMI* 2"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "EVO",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Подключение",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "<ul><li>Один универсальный порт для всех периферийных устройств</li> <li>Одновременная зарядка ноутбука</li> <li>Стандарт, заслуживающий доверие</li></ul>",
                "tr_title": "Используйте максимум возможностей с помощью технологии Thunderbolt™",
                "tr_noteSection": "<sup>†</sup> На основе минимальных требований спецификации",
                "badgeUrl": "assets/images/evo_thunderbolt4.png",
                "tileBG": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "tr_title": "КАК ИСПОЛЬЗОВАТЬ ТЕХНОЛОГИЮ THUNDERBOLT™ 4?",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/thunderbolt-create.png",
                    "tr_badgeTitle": "Заниматься творчеством",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Подключите внешний монитор и быстрый накопитель для просмотра и редактирования фотографий и видео."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "Док-станция",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Создайте аккуратное и удобное рабочее пространство, подключив к ноутбуку все необходимые аксессуары с помощью одного кабеля."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-game.png",
                    "tr_badgeTitle": "Играй",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Подключите внешний SSD-накопитель или жесткий диск со скоростью передачи данных до 3000 МБ/с для хранения игровых библиотек и мультимедийных файлов."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "Максимальная производительность<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "В 4 раза быстрее USB* 3.2 <br/>В 2 раза быстрее HDMI* 2"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_5",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Подключение",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "gaming-panelType1",
                "tr_subtitle": "Оцените преимущества технологии Thunderbolt™ 5",
                "tr_title": "Одно простое, надежное и сверхбыстрое подключение, которое&nbsp;может&nbsp;все!",
                "tr_title1": "ОДНО ПРОСТОЕ, НАДЕЖНОЕ И СВЕРХБЫСТРОЕ ПОДКЛЮЧЕНИЕ, КОТОРОЕ&nbsp;МОЖЕТ&nbsp;ВСЕ!",
                "tr_noteSection": "",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "imgUrl": "assets/images/unrivaled_icon.svg",
                    "tr_title": "Непревзойденная простота",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/reliable_icon.svg",
                    "tr_title": "Надежное подключение",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/performance_icon.svg",
                    "tr_title": "Максимальная производительность",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/compatibility_icon.svg",
                    "tr_title": "Универсальная совместимость",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "КОМПЬЮТЕРЫ С ТЕХНОЛОГИЕЙ THUNDERBOLT™ 5 ОБЕСПЕЧИВАЮТ МАКСИМАЛЬНУЮ СКОРОСТЬ ПЕРЕДАЧИ ДАННЫХ",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "КОМПЬЮТЕРЫ С ТЕХНОЛОГИЕЙ THUNDERBOLT™ 5 ОБЕСПЕЧИВАЮТ МАКСИМАЛЬНУЮ СКОРОСТЬ ПЕРЕДАЧИ ДАННЫХ",
                  "panelType2": "enhancement-compare",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Технология Thunderbolt™ 5",
                      "tr_badgeSubTitle": "6000 Мбит/с"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Технология Thunderbolt™ 4",
                      "tr_badgeSubTitle": "3000 Мбит/с"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "USB4*",
                      "tr_badgeSubTitle": "1500 Мбит/с"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "USB 3.2",
                      "tr_badgeSubTitle": "450 Мбит/с"
                    }
                  ]
                },
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/thunderbolt_panel1.png",
                    "tr_title": "",
                    "tr_subtitle": "Используйте <strong>утилиту общего доступа Thunderbolt™</strong><br>для простой передачи файлов и совместного использования мониторов, накопителей и других ресурсов с молниеносной скоростью<sup>53</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/thunderbolt_panel2.png",
                    "tr_title": "",
                    "tr_subtitle": "<strong>Более интеллектуальное рабочее пространство с одним кабелем, подключенным к док-станции и аксессуарам</strong><br><br/>Компьютеры, кабели и аксессуары сертифицированы для обеспечения <span class ='expandable_bold_text'>надежного комплексного решения</span>",
                    "align": "right"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "wifi": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "badgeUrl": "",
                "tr_subtitle": "Наиболее распространены следующие типы Wi‑Fi:",
                "tr_title": "ЗНАКОМСТВО СО СТАНДАРТАМИ WI‑FI",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 обеспечивает более высокую скорость, даже когда один и тот же сигнал используется множеством пользователей<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6 (Gig+)",
                    "tr_badgeSubTitle": "Благодаря последним инновациям Intel в области Wi-Fi скорость беспроводного подключения может превышать гигабитный рубеж даже при одновременном использовании одной сети несколькими пользователями<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "Cамое крупное достижение в&nbsp;технологии&nbsp;Wi&#8209;Fi за 20 лет, Wi&#8209;Fi&nbsp;6E&nbsp;обеспечивает новые высокоскоростные каналы для повышения&nbsp;производительности и&nbsp;надежности&nbsp;путём снижения уровня&nbsp;помех."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 обеспечивает более высокую скорость, даже когда один и тот же сигнал используется множеством пользователей<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/standard_wifi_killer_AX1675_badge.svg",
                    "tr_badgeTitle": "Intel® Killer™ Wi-Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "Все преимущества Wi&#8209;Fi&nbsp;6E с&nbsp;приоритизацией Intel®&nbsp;Killer™ для ускорения трафика нужных приложений и сайтов."
                  },
                  {
                    "badgeUrl": "assets/images/Wi-fi-6E-badge.svg",
                    "tr_badgeTitle": "Wi‑Fi 6E",
                    "tr_badgeSubTitle": "Благодаря меньшей конкуренции устройств на высокоскоростных каналах вы получите более высокую производительность и стабильность подключения."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 обеспечивает более высокую скорость, даже когда один и тот же сигнал используется множеством пользователей<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 6 (Gig+)",
                    "tr_badgeSubTitle": "Благодаря меньшему количеству помех, создаваемых Wi-Fi 6, и интеллектуальной производительности механизма приоритизации Intel® Killer™ ваши онлайн-возможности станут быстрее и эффективнее⁶"
                  },
                  {
                    "badgeUrl": "assets/images/standard_generic_wifi.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Благодаря меньшей конкуренции устройств на высокоскоростных каналах вы получите более высокую производительность и стабильность подключения."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-7-badge.png",
                    "tr_badgeTitle": "Intel® Wi-Fi 7 (5 Gig)",
                    "tr_badgeSubTitle": "Скорость Wi-Fi на ПК более 5 Гбит/с со стабильно сверхнизкой задержкой — обмен файлами занимает секунды, а не минуты."
                  },
                  {
                    "badgeUrl": "assets/images/killerwifi-7-badge.png",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 7",
                    "tr_badgeSubTitle": "Intel® Killer™ Wi-Fi 7 (5 Gig) — это&nbsp;новейшая&nbsp;технология, обеспечивающая&nbsp;экстремальную надежность, низкую&nbsp;задержку и&nbsp;высокую&nbsp;скорость благодаря оптимизации сети на&nbsp;базе&nbsp;ИИ."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 обеспечивает более высокую скорость, даже когда один и тот же сигнал используется множеством пользователей<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "Intel® Wi-Fi 6E (Gig+) обеспечивает скорость выше 1 Гбит/с, надежность и низкую задержку при использовании каналов в диапазоне 6 ГГц."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Более высокая эффективность, емкость и скорость по сравнению с Wi-Fi 5 в&nbsp;перегруженных сетях."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_subtitle": "Оставайтесь на связи благодаря Wi&#8209;Fi&nbsp;[XX] и наслаждайтесь более быстрым<sup>†</sup> и надежным подключением к Интернету.",
                "tr_title": "Увеличенный радиус действия и&nbsp;скорость",
                "tr_noteSection": "<sup>†</sup> Реальные значения пропускной способности и/или радиуса действия беспроводной сети могут отличаться.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi [XX]"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В эпоху многопользовательских и онлайн-игр оставаться на связи важнее, чем когда-либо. Помимо скорости, вам также нужен беспроводной сигнал, поддерживающий эти скорости на расстоянии.",
                "tr_title": "[XX]",
                "tr_pretitle": "ПОДКЛЮЧЕНИЕ — КЛЮЧ К УСПЕХУ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-6E-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Подключайте устройства с Intel® Wi‑Fi 6 (Gig+) к маршрутизаторам Wi‑Fi 6 с поддержкой каналов шириной 160 МГц, чтобы обеспечить более быстрое и надежное подключение для большего количества активных пользователей.",
                "tr_title": "Почти в 3 раза выше скорость благодаря Intel® <span class='no-warp'>Wi-Fi 6  </span>(Gig+)<sup>†</sup>",
                "tr_noteSection": "<sup>†</sup> По сравнению со стандартным Wi‑Fi 5. Некоторые функции доступны только в определенных моделях. За дополнительной информацией обращайтесь к производителю. Подробная информация о технологии Wi‑Fi: intel.com/wifi6disclaimers."
              }
            },
            {
              "deviceType": "MODEL_AX101",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-6-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Двухдиапазонный Intel® Wi-Fi 6 начального уровня поддерживает улучшенную производительность для базовых потребностей в подключении, таких как электронная почта и просмотр Интернет-страниц, в перегруженных сетях.<sup>9</sup>",
                "tr_title": "Основные возможности Wi-Fi",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В эпоху многопользовательских и онлайн-игр оставаться на связи важнее, чем когда-либо. Помимо скорости, вам также нужен беспроводной сигнал, поддерживающий эти скорости на расстоянии.",
                "tr_title": "[XX]",
                "tr_pretitle": "ПОДКЛЮЧЕНИЕ — КЛЮЧ К УСПЕХУ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6E",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                "tr_subtitle": "Благодаря новым каналам Wi‑Fi вам не придется делиться пропускной способностью со старыми устройствами по соседству. Они обеспечивает стабильную потоковую трансляцию, быстрый просмотр веб-страниц, а также комфортную удаленную работу и обучение.",
                "tr_title": "Подключайтесь к сети без проблем",
                "tr_noteSection": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHERS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                "tr_subtitle": "Оставайтесь на связи благодаря [XX] и наслаждайтесь более быстрым<sup>†</sup> и надежным подключением к Интернету.",
                "tr_title": "Увеличенный радиус действия и&nbsp;скорость",
                "tr_noteSection": "<sup>†</sup> Реальные значения пропускной способности и/или радиуса действия беспроводной сети могут отличаться.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В эпоху многопользовательских и онлайн-игр оставаться на связи важнее, чем когда-либо. Помимо скорости, вам также нужен беспроводной сигнал, поддерживающий эти скорости на расстоянии.",
                "tr_title": "[graphic_display]",
                "tr_pretitle": "ПОДКЛЮЧЕНИЕ — КЛЮЧ К УСПЕХУ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Встроенная поддержка сверхскоростных сетей Wi‑Fi",
                "tr_subtitle": "Оставайтесь с быстрым Интернетом даже без проводного подключения."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6E_KILLER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1675_badge.svg",
                "tr_subtitle": "Благодаря выделенным высокоскоростным каналам с меньшим уровнем помех и механизму приоритизации Intel® Killer™, который ставит игры на первое место, возможности для онлайн-игр существенно расширились.",
                "tr_title": "Забудьте о борьбе за пропускную способность",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/[image_path].png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "Благодаря выделенным высокоскоростным каналам с меньшим уровнем помех и механизму приоритизации Intel® Killer™, который ставит игры на первое место, возможности для онлайн-игр существенно расширились.",
                "tr_title": "[XX]",
                "tr_pretitle": "ЗАБУДЬТЕ О БОРЬБЕ ЗА ПРОПУСКНУЮ СПОСОБНОСТЬ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_6E",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/[image_path].png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "Благодаря выделенным высокоскоростным линиям и меньшему уровню помех, что ставит игры на первое место, возможности для онлайн-игр существенно улучшились.",
                "tr_title": "[XX]",
                "tr_pretitle": "ЗАБУДЬТЕ О БОРЬБЕ ЗА ПРОПУСКНУЮ СПОСОБНОСТЬ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6_KILLER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                "tr_subtitle": "Intel® Killer™ Wi‑Fi автоматически ускоряет сетевой трафик для приложений, которым он необходим больше всего, чтобы потоковые видео были четкими и занимали меньше места в буфере памяти.",
                "tr_title": "Более быстрый и эффективный способ подключения⁶",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В эпоху многопользовательских и онлайн-игр оставаться на связи важнее, чем когда-либо. Помимо скорости, вам также нужен беспроводной сигнал, поддерживающий эти скорости на расстоянии.",
                "tr_title": "[XX]",
                "tr_pretitle": "ПОДКЛЮЧЕНИЕ — КЛЮЧ К УСПЕХУ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "KILLER_VERSION_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_subtitle": "Оставайтесь на связи&nbsp;благодаря Wi&#8209;Fi&nbsp;5 и&nbsp;наслаждайтесь более быстрым<sup>†</sup>&nbsp;и&nbsp;надежным подключением&nbsp;к&nbsp;Интернету.",
                "tr_title": "Увеличенный радиус действия и&nbsp;скорость",
                "tr_noteSection": "<sup>†</sup> Реальные значения пропускной способности и/или радиуса действия беспроводной сети могут отличаться.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "THIRDPARTY_6E",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В эпоху многопользовательских и онлайн-игр оставаться на связи важнее, чем когда-либо. Помимо скорости, вам также нужен беспроводной сигнал, поддерживающий эти скорости на расстоянии.",
                "tr_title": "[XX]",
                "tr_pretitle": "ЗАБУДЬТЕ О БОРЬБЕ ЗА ПРОПУСКНУЮ СПОСОБНОСТЬ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-7-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Wi-Fi 7 будет сочетать в себе как свойства более ранних поколений Wi-Fi, так и новые улучшенные качества. Это не только более высокая скорость, но и улучшенный отклик и повышенная надежность, которые делают работу приятнее и закладывают основу для еще более продвинутых технологий будущего.",
                "tr_title": "Проводные сети ПК",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "Wi-Fi 7 будет сочетать в себе как свойства более ранних поколений Wi-Fi, так и новые улучшенные качества. Это не только более высокая скорость, но и улучшенный отклик и повышенная надежность, которые делают работу приятнее и закладывают основу для еще более продвинутых технологий будущего.",
                "tr_title": "[XX]",
                "tr_pretitle": "ТРАНСФОРМАЦИЯ ПОЛЬЗОВАТЕЛЬСКОГО ОПЫТА",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "KILLER_VERSION_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/killerwifi-7-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "",
                "tr_title": "Высокая скорость, надежность и&nbsp;низкая&nbsp;задержка благодаря оптимизации&nbsp;сети на&nbsp;базе&nbsp;ИИ",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/killerwifi-7-badge.png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "Высокая скорость, надежность и&nbsp;низкая&nbsp;задержка благодаря оптимизации&nbsp;сети на&nbsp;базе&nbsp;ИИ.",
                "tr_title": "[XX]",
                "tr_pretitle": "БЫСТРОДЕЙСТВИЕ ПРОВОДНОГО ИНТЕРНЕТА",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "battery": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Батарея",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-power-icon.png",
                    "tr_badgeTitle": "Как проводятся измерения?",
                    "tr_badgeSubTitle": "Большинство производителей указывают время автономной работы своих устройств в часах. Несмотря на то, что эти показатели не являются абсолютно точными, они помогут вам сравнить время автономной работы одного ПК с другим."
                  }
                ],
                "tr_subtitle": "",
                "tr_title": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Батарея",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/battery-badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ДЛЯ ИГР В МОБИЛЬНОМ РЕЖИМЕ",
                "tr_subtitle": "Благодаря мощности современных игровых ноутбуков вы больше не привязаны к настольному ПК. Теперь играть можно в любом месте.",
                "tr_title": "[Dynamic.battery.values.hours] часов автономной работы"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BATTERYLIFE",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Intel® Core™ Ultra: эталон автономной работы ПК",
                "detailBGUrl": "assets/images/battery_life_bg.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "bannerImgUrl": "assets/images/battery_life_banner_img.svg",
                "tr_subtitle": "Новый эталон автономной работы ПК",
                "tr_title": "Процессор Intel® Core™ Ultra серии 200V",
                "tr_noteSection": "Относится к процессорам серии Intel® Core™ Ultra серии 200V по состоянию на август 2025 года, исходя из их уникальной архитектуры и впечатляющего времени автономной работы, измеренного на ведущих моделях.<br/>Подробнее: www.Intel.com/PerformanceIndex.<br/>Ни один продукт не может быть полностью защищен. ©&nbsp;Корпорация&nbsp;Intel.",
                "tileBG": "assets/images/batteryLifeTile_img.svg",
                "titleArray": [
                  {
                    "tr_title": "Больше возможностей на одном заряде",
                    "tr_subTitle": ""
                  },
                  {
                    "tr_title": "Превосходная производительность без подключения к сети",
                    "tr_subTitle": ""
                  },
                  {
                    "tr_title": "Творите и черпайте вдохновение без усилий",
                    "tr_subTitle": ""
                  }
                ],
                "badgeUrl": "assets/images/badges/battery_life_badge.svg",
                "tr_badgeTitle": "Вся мощь <span class='battery_highlight'>Intel&nbsp;Inside®</span>."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GOOD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Батарея",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "Отключайтесь от электросети и часами оставайтесь на связи, работайте с приложениями, играйте и слушайте музыку.",
                "tr_title": "[XX] часов трансляции без подзарядки<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup> На основании времени автономной работы, заявленного производителем ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] часов",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BETTER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Батарея",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "Отключайтесь от электросети и часами оставайтесь на связи, работайте с приложениями, играйте и слушайте музыку.",
                "tr_title": "[Dynamic.battery.values.hours] часов автономной работы в пути<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup> На основании времени автономной работы, заявленного производителем ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] часов",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BEST",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Батарея",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "Отключайтесь от электросети и часами оставайтесь на связи, работайте с приложениями, играйте и слушайте музыку.",
                "tr_title": "[Dynamic.battery.values.hours] часов непрерывной работы в течение всего дня без подзарядки<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup> На основании времени автономной работы, заявленного производителем ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] часов",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Батарея",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/battery-badge.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "Этот ПК продлевает время работы батареи и обеспечивает не менее 4 часов автономной работы при 30-минутной зарядке.<sup>4</sup>.",
                "tr_title": "Обходитесь без розеток дольше благодаря [Dynamic.battery.values.hours] часам автономной работы<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup> На основании времени автономной работы, заявленного производителем ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] часов",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "headerTabs": [
    {
      "tabName": "homepage",
      "headerDetails": {
        "tr_specTitle": "Главная",
        "targetURL": "Home",
        "iconURL": "assets/images/home.svg"
      }
    },
    {
      "tabName": "why_this_pc",
      "headerDetails": {
        "tr_specTitle": "Почему именно этот ПК",
        "targetURL": "WhyThisPC",
        "iconURL": "assets/images/whythispc.svg"
      }
    },
    {
      "tabName": "pc_specs",
      "headerDetails": {
        "tr_specTitle": "Смотреть все технические характеристики",
        "targetURL": "PcSpec",
        "iconURL": "assets/images/pcspecs.svg"
      }
    },
    {
      "tabName": "remote",
      "headerDetails": {
        "tr_specTitle": "Удалить",
        "targetURL": "",
        "iconURL": "assets/images/Frame_3468.svg"
      }
    },
    {
      "tabName": "mobile",
      "headerDetails": {
        "tr_specTitle": "Устройство",
        "targetURL": "",
        "iconURL": "assets/images/Frame_3468.svg"
      }
    },
    {
      "tabName": "legal",
      "headerDetails": {
        "tr_specTitle": "Юридическая информация",
        "tr_paragraph_array": [
          "Программное обеспечение и рабочие нагрузки, использованные при тестировании, могли быть оптимизированы исключительно под микропроцессоры Intel®. Тесты производительности, такие как SYSmark* и MobileMark*, проводятся для конкретных конфигураций компьютерных систем, компонентов и функций. Любые изменения этих факторов могут сказаться на результатах. При принятии решения о покупке следует свериться с другими источниками информации и результатами иных тестов, в том числе с показателями производительности этого продукта в сочетании с другими продуктами. Подробная информация о производительности и результатах эталонных тестов: www.intel.com/benchmarks.",
          "¹ Продукция Intel® Wi-Fi 6 (Gig+) поддерживает дополнительные каналы шириной 160&nbsp;МГц, что позволяет достичь максимально возможной теоретической скорости (2402&nbsp;Мбит/с) для продукции стандарта Wi-Fi 802.11ax (2x2 канала) для ПК. Продукция Intel® Wi-Fi 6 (Gig+) премиум-класса обеспечивает максимальную теоретическую скорость, в 2–4 раза превышающую скорость продукции стандарта Wi-Fi 802.11ax (2x2 канала, 1201&nbsp;Мбит/с или 1x1 канал, 600&nbsp;Мбит/с), которая поддерживает только каналы шириной 80&nbsp;МГц в соответствии с обязательными требованиями.",
          "² Рекомендации приводятся исключительно в информационных целях. При принятии решения о покупке обратитесь также к другим источникам информации.",
          "³ Возможности и преимущества технологий Intel зависят от конфигурации системы. Для их работы может потребоваться специальное оборудование, ПО или активация сервисов. Производительность зависит от конфигурации системы. Ни одна компьютерная система не может быть полностью защищена. Проконсультируйтесь с производителем или продавцом ПК, либо ознакомьтесь с подробной информацией на сайте intel.com.",
          "⁴ Для систем с дисплеями Full HD при использовании для просмотра веб-страниц через беспроводное соединение. При выключенном питании, с установленного производителем уровня выключения по умолчанию.",
          "⁵ По сравнению с другими технологиями ввода-вывода для ПК, включая eSATA, USB и IEEE 1394* FireWire. Реальные значения производительности могут различаться в зависимости от используемого оборудования и программного обеспечения. Обязательно использование устройства с технологией Thunderbolt™.",
          "⁶ Почти в 3 раза быстрее: как указано в спецификации стандартов беспроводного подключения IEEE 802.11*, стандарт 802.11ax (2x2 канала, 160 МГц) обеспечивает максимальную теоретическую скорость передачи данных 2402 Мбит/с, что почти в 3 раза превышает скорость 867 Мбит/с стандарта 802.11ac (2x2 канала, 80 МГц) и требует использования аналогично настроенных беспроводных сетевых маршрутизаторов стандарта 802.11ax.",
          "⁷ Снижение уровня задержек на 75%: на основе данных моделирования Intel (79%) для сетей стандарта 802.11ax с использованием схемы OFDMA и без нее на примере 9 клиентов. Средняя задержка без OFDMA составляет 36&nbsp;мс, а средняя задержка при использовании OFDMA снижается до 7,6&nbsp;мс. Для снижения задержки требуется маршрутизатор 802.11ax (Wi-Fi 6) и поддержка OFDMA всеми клиентами.",
          "⁸ Как указано в спецификации IEEE 802.11*, Wi‑Fi 6/6E (2x2 канала, 160 МГц, стандарт 802.11ax) обеспечивает максимальную теоретическую скорость передачи данных 2402 Мбит/с, что в 2,8 раза выше по сравнению с Wi‑Fi 5 (2x2 канала, 80 МГц, стандарт 802.11ac), обеспечивающим скорость передачи данных 867 Мбит/с.",
          "⁹ Лучшая в своем классе технология Wi&#8209;Fi&nbsp;6: продукция Intel® Wi‑Fi 6 (Gig+) поддерживает дополнительные каналы шириной 160 МГц, что позволяет достичь максимально возможной теоретической скорости (2402 Мбит/с) для стандартной продукции Wi‑Fi 802.11ax (2x2 канала) для ПК. Продукция Intel® Wi‑Fi 6 (Gig+) премиум-класса обеспечивает максимальную теоретическую скорость, в 2–4 раза превышающую скорость продукции стандарта Wi‑Fi 802.11ax (2x2 канала, 1201 Мбит/с или 1x1 канал, 600 Мбит/с), которая поддерживает только каналы шириной 80 МГц в соответствии с обязательными требованиями.",
          "Только в некоторых моделях, функциональные возможности зависят от конструкции OEM-производителя. Проконсультируйтесь с OEM-производителем или розничным продавцом. Для получения дополнительной информации о Wi‑Fi посетите веб-сайт intel.com/wifi6disclaimers.",
          "¹⁰ Технология Thunderbolt™ 4 со скоростью 40 Гбит/с обеспечивает самое быстрое, простое и надежное решение с одним кабелем для док-станции, дисплея или устройства хранения данных по сравнению с другими технологиями ввода/вывода для ПК, включая eSATA*, USB* и IEEE 1394* FireWire.",
          "¹¹ Требуется маршрутизатор стандарта 802.11ax, поддерживающий OFDMA и несколько клиентов в сети с поддержкой AX. При использовании OFDMA на клиентских системах и точках доступа стандарта 802.11ax повышается эффективность в средах высокой плотности. 2&nbsp;Гбит/с на основе предположения о приблизительно 70% от теоретической максимальной скорости передачи данных по спецификации IEEE 802.11* для стандарта 802.11ax (160&nbsp;МГц, 2402&nbsp;Мбит/с).",
          "¹² По результатам измерения рабочей нагрузки «Открытие документа при выполнении других действий в фоновом режиме» для сравнения процессоров Intel®&nbsp;Core™&nbsp;i7&#8209;8565U 8-го поколения (SSD-накопитель емкостью 512&nbsp;ГБ, TLC) и Intel®&nbsp;Core™&nbsp;i7&#8209;8565U 8-го поколения (память Intel® Optane™ H10 емкостью 32&nbsp;ГБ с твердотельным накопителем емкостью 512&nbsp;ГБ).",
          "¹³ Технология Intel® Thread Director, разработанная для процессоров Intel®&nbsp;Core™ 12-го поколения, помогает поддерживающим операционным системам более интеллектуально распределять рабочие нагрузки между ядрами. От пользователя не требуется никаких действий. Подробнее: intel.com.",
          "¹⁴ Недоступно на определенных процессорах Intel® Core™ 12-го поколения. Высокопроизводительная гибридная архитектура предусматривает сочетание на одном кристалле процессора двух новых микроархитектур ядер: Performance-core (P-core) и Efficient-core (E-core). Определенные процессоры Intel®&nbsp;Core™ 12&#8209;го поколения (некоторые процессоры Intel® Core™ i5 12-го поколения и ниже) не поддерживают высокопроизводительную гибридную архитектуру, а только ядра P-core.",
          "¹⁵ По результатам теста с рабочей нагрузкой «Запуск игры» для процессора Intel® Core™ i7-8750H 8-го поколения (модуль памяти Intel® Optane™ емкостью 32 ГБ + твердотельный накопитель Intel® (PCIe*) емкостью 256 ГБ + жесткий диск емкостью 1 ТБ) по сравнению с процессором Intel® Core™ i7-8750H 8-го поколения (твердотельный накопитель Intel® (PCIe*) емкостью 256 ГБ + жесткий диск емкостью 1 ТБ). Рабочая нагрузка «Запуск игры»&nbsp;— рабочая нагрузка, разработанная корпорацией Intel, которая измеряет время запуска игры Total War*: WARHAMMER*&nbsp;II (сборка 5577.0) и перехода в главное меню с отключенными вступительными видео (запуск). Конфигурации ускорения накопителя данных памяти Intel® Optane™: процессор Intel® Core™ i7-8750H, расчетная мощность PL1 = 45 Вт, 6 ядер/12 потоков, тактовая частота до 4&nbsp;ГГц в режиме Turbo на предпроизводственной системе производителя, графическая система: NVIDIA* GeForce* GTX 1070, память: 2&nbsp;модуля DDR4 емкостью по 4&nbsp;ГБ, накопитель: твердотельный накопитель Intel® 760p (PCIe*) емкостью 256 ГБ + жесткий диск емкостью 1 ТБ + модуль памяти Intel® Optane™ емкостью 32&nbsp;ГБ, ОС: Windows* 10 RS3, сборка 1709, MCU 0x84; процессор Intel® Core™ i7-8750H, расчетная мощность PL1&nbsp;=&nbsp;45&nbsp;Вт, 6&nbsp;ядер/12&nbsp;потоков, тактовая частота до 4&nbsp;ГГц на предпроизводственной системе производителя, графическая система: NVIDIA* GeForce* GTX 1070, память: 2&nbsp;модуля DDR4 емкостью по 4&nbsp;ГБ, накопитель: твердотельный накопитель Intel® 760p (PCIe*) емкостью 256&nbsp;ГБ + жесткий диск емкостью 1&nbsp;ТБ, ОС: Windows* 10 RS3, сборка 1709, MCU 0x84.",
          "¹⁶ По результатам теста с рабочей нагрузкой «Загрузка игрового уровня» для процессора Intel® Core™ i7-8750H 8-го поколения (модуль памяти Intel® Optane™ емкостью 32&nbsp;ГБ) по сравнению с процессором Intel® Core™ i7-8750H 8-го поколения (только жесткий диск). Рабочая нагрузка «Загрузка игрового уровня» — рабочая нагрузка, разработанная корпорацией Intel, которая измеряет время с момента перехода в главное меню до завершения загрузки уровня игры Total War*: WARHAMMER*&nbsp;II (сборка: 5577.0). Конфигурации ускорения накопителя данных памяти Intel® Optane™: процессор Intel® Core™ i7-8750H, расчетная мощность PL1 = 45 Вт, 6 ядер/12 потоков, тактовая частота до 4&nbsp;ГГц в режиме Turbo на предпроизводственной системе производителя, графическая система: NVIDIA* GeForce* GTX 1070, память: 2&nbsp;модуля DDR4 емкостью по 4&nbsp;ГБ, накопитель: твердотельный накопитель Intel® 760p (PCIe*) емкостью 256 ГБ + жесткий диск емкостью 1 ТБ + модуль памяти Intel® Optane™ емкостью 32&nbsp;ГБ, ОС: Windows* 10 RS3, сборка 1709, MCU 0x84; процессор Intel® Core™ i7-8750H, расчетная мощность PL1&nbsp;=&nbsp;45&nbsp;Вт, 6&nbsp;ядер/12&nbsp;потоков, тактовая частота до 4&nbsp;ГГц на предпроизводственной системе производителя, графическая система: NVIDIA* GeForce* GTX 1070, память: 2&nbsp;модуля DDR4 емкостью по 4&nbsp;ГБ, накопитель: твердотельный накопитель Intel® 760p (PCIe*) емкостью 256&nbsp;ГБ + жесткий диск емкостью 1&nbsp;ТБ, ОС: Windows* 10 RS3, сборка 1709, MCU 0x84.",
          "¹⁷ На ядрах Performance-core. Производительность зависит от использования, конфигурации и других факторов. Дополнительная информация: www.intel.com/PerformanceIndex.",
          "¹⁸ Изменение тактовой частоты или напряжения может привести к повреждениям или сократить срок службы процессора и других системных компонентов, а также может стать причиной ухудшения стабильности и производительности системы. В случае использования процессора с настройками, превышающими номинальные, продукция может не подлежать гарантийному обслуживанию. За дополнительной информацией обращайтесь к производителям системы и компонентов.",
          "¹⁹ Согласно результатам непревзойденного сочетания возможностей безопасности выше и ниже уровня ОС, защиты приложений и данных и передовых средств защиты от угроз, которые обеспечивает платформа Intel vPro® для бизнеса любого размера, а также приоритетного подхода Intel к безопасности при разработке, производстве и поддержке продуктов. Все ПК для бизнеса, построенные на платформе Intel vPro®, прошли проверку на соответствие строгим спецификациям, включая уникальные аппаратные функции безопасности. Подробную информацию см. по ссылке www.intel.com/PerformanceIndex (платформы). Ни один продукт или компонент не может быть полностью защищен.",
          "²⁰ Intel® Connectivity Performance Suite доступен только в системах на базе Windows*. Тестирование Wi-Fi Intel Over The Air (OTA) в загруженной сети по сравнению с отсутствием приоритизации беспроводного трафика приложений ПО ICPS и интеллектуального переключения точки доступа. Подробную информацию см. по ссылке www.intel.com/PerformanceIndex (подключение). Полученные результаты могут отличаться от приведенных.",
          "²¹ По сравнению с предыдущим поколением процессоров",
          "²² Графика Intel® Arc™ первой на рынке поддерживает кодирование AV1 (по состоянию на 1 квартал 2022 года). Подробная информация: intel.com/performanceindex.",
          "²³ По результатам измерений уникальных характеристик разработок Intel® Evo™, которые также проверены на соответствие ключевым пороговым значениям удовлетворенности мобильных пользователей. Тестирование по состоянию на февраль 2022 года.",
          "²⁴ Решение Intel® Unison™ в настоящее время доступно только для поддерживаемых разработок Intel® Evo™ для ПК под управлением ОС Windows* и работает только с телефонами на базе Android или iOS; на всех устройствах должна быть установлена поддерживаемая версия ОС.",
          "²⁵ Максимальное быстродействие памяти достигается с конфигурацией 1 DIMM на канал (1DPC). Установка дополнительного DIMM на какой-либо канал может снизить максимальную скорость работы памяти. До DDR5-5600 МТ/с 1DPC UDIMM 1Rx8, 1Rx16 и DDR5-5200 1Rx8, 1Rx16, 2Rx8 на определенных моделях. Максимальная емкость памяти достигается с конфигурацией 2DPC.",
          "²⁶ В сравнении со стандартом Wi-Fi. Подробную информацию см. по адресу intel.com/performance-wireless. Полученные результаты могут отличаться от приведенных.",
          "²⁷ Высокопроизводительная гибридная архитектура сочетает два типа микроархитектуры ядра — ядра Performance-core (P&#8209;core) и Efficient-core (E&#8209;core) — на одном кристалле, впервые представленном в процессорах Intel®&nbsp;Core™ 12&#8209;го поколения. Определенные процессоры Intel® Core™ 12&#8209;го и процессоры более новых поколений не имеют высокопроизводительной гибридной архитектуры, а только ядра P&#8209;core, и имеют такой же размер кэш&#8209;памяти, что и предыдущее поколение. Подробную информацию о модели см. на сайте ark.intel.com.",
          "²⁸ Реализованная на аппаратном уровне технология Intel® Thread Director предусмотрена только в конфигурациях высокопроизводительной гибридной архитектуры процессоров Intel®&nbsp;Core™ 12&#8209;го или более новых поколений. Требуется поддержка ОС. Доступные функции и возможности зависят от ОС.",
          "²⁹ Реализованная на аппаратном уровне технология Intel® Thread Director предусмотрена только в конфигурациях высокопроизводительной гибридной архитектуры процессоров Intel®&nbsp;Core™ 12&#8209;го и 13&#8209;го поколения. Требуется поддержка ОС. Доступные функции и возможности зависят от ОС.",
          "³⁰ По результатам измерений производительности эталонной платформы проверки процессора Intel®&nbsp;Core™ Ultra для мобильных ПК (Серия 2 — кодовое название: Lunar Lake) по сравнению с процессором Intel®&nbsp;Core™ Ultra для мобильных ПК (Серия 1 — кодовое название: Meteor Lake) на 3DMark Time Spy. Подробнее: intel.com/performanceindex. Результаты могут отличаться.",
          "³¹ Размытие фона и отслеживание лица доступны только в системах на базе Windows*.",
          "³² Продукты Wi&#8209;Fi&nbsp;7 могут использовать каналы шириной 320&nbsp;МГц в диапазоне 6&nbsp;ГГц, а также комбинации каналов шириной 160&nbsp;МГц в диапазоне 5&nbsp;ГГц благодаря новым возможностям Multi&#8209;Resource&nbsp;Unit&nbsp;Puncturing.",
          "³³ На основе спецификаций стандартов беспроводной связи IEEE и&nbsp;максимальной теоретической скорости передачи данных для&nbsp;двухпоточных&nbsp;устройств.",
          "³⁴ Инженерное моделирование перегруженных сетевых сред, проведенное Intel, показало, что&nbsp;благодаря новым возможностям Wi&#8209;Fi&nbsp;7&nbsp;Multi&#8209;Link&nbsp;Operation достижимо значительное сокращение задержек.",
          "³⁵ Минимальный заряд достигается с установленного OEM-производителем уровня выключения по умолчанию. Результаты отдельных систем могут отличаться. Подробнее: intel.com/performance-evo.",
          "³⁶ Диапазон Wi-Fi 6 ГГц доступен для использования не во всех странах/регионах.",
          "³⁷ Только для Windows*.",
          "³⁸ Заряд достигается с установленного OEM-производителем уровня выключения по умолчанию. Подробная информация о производительности и результатах эталонных тестов: intel.com/Evo.",
          "³⁹ Относится к процессорам Intel®&nbsp;Core™&nbsp;Ultra для мобильных ПК (Серия&nbsp;2) на базе уникальных аппаратных функций безопасности, непревзойденной комбинации возможностей безопасности выше и ниже уровня ОС, впечатляющей производительности даже при более низком энергопотреблении по сравнению с предыдущим поколением (по состоянию на сентябрь 2024 года). Подробнее: intel.com/performanceindex. Результаты могут отличаться.",
          "⁴⁰ Программные приложения изображены только в иллюстративных целях. Функции ИИ могут требовать покупки дополнительного программного обеспечения, подписки или поддержки со стороны поставщика программного обеспечения либо платформы, а также могут иметь требования к конфигурации или совместимости. Подробнее: www.intel.com/PerformanceIndex. Результаты могут отличаться. ©&nbsp;Корпорация&nbsp;Intel.",
          "⁴¹ Показанные изображения могут быть изменены или смоделированы. Функции ИИ могут требовать покупки дополнительного программного обеспечения, подписки или поддержки со стороны поставщика программного обеспечения либо платформы, а также могут иметь требования к конфигурации или совместимости. Подробнее: www.intel.com/AIPC.",
          "⁴² Внедрение выполняется постепенно в режиме предварительного просмотра в последнем обновлении Windows* 11 на отдельных мировых рынках. Время доступности зависит от устройства и рынка. Подробнее: aka.ms/WindowsAIFeatures. ©&nbsp;Корпорация&nbsp;Intel.",
          "⁴³ В настоящее время решение Intel®&nbsp;Unison™ доступно для соответствующих моделей. Подробнее: www.intel.com/PerformanceIndex.",
          "⁴⁴ Частота кадров увеличена с помощью Intel® X<sup>e</sup>SS по сравнению с обычной частотой кадров по результатам измерений Dying Light 2 Stay Human на процессоре Intel® Core™ Ultra 7 165H. Подробнее: www.intel.com/PerformanceIndex. Результаты могут отличаться.",
          "⁴⁵ По результатам измерений интегрированной системы с низким энергопотреблением процессора Intel®&nbsp;Core™ Ultra для мобильных ПК (Серия&nbsp;2 — кодовое название Lunar Lake), эталонная платформа проверки, по сравнению с процессором Intel®&nbsp;Core™&nbsp;Ultra для мобильных ПК (Серия&nbsp;1 — кодовое название Meteor Lake), эталонная платформа проверки, на YouTube* 4K 30 кадров в секунду AV1. Подробнее: intel.com/performanceindex. Результаты могут отличаться.",
          "⁴⁶ По результатам измерений производительности эталонной платформы проверки процессора Intel®&nbsp;Core™&nbsp;Ultra для мобильных ПК (Ceрия 2 — кодовое название: Lunar Lake) по сравнению с Meteor Lake на 3DMark* Time Spy. Подробнее: intel.com/performanceindex. Результаты могут отличаться.",
          "⁴⁷ По результатам измерений интегрированной системы с низким энергопотреблением процессора Intel®&nbsp;Core™&nbsp;Ultra для мобильных ПК (Ceрия 2 — кодовое название Lunar Lake), эталонная платформа проверки, по сравнению с эталонной платформой проверки Meteor Lake на YouTube* 4K 30 кадров в секунду AV1. Подробнее: intel.com/performanceindex. Результаты могут отличаться.",
          "⁴⁸ Intel® Application Optimization — это политика технологии Intel® Dynamic Tuning, которая оптимизирует производительность в некоторых играх с требуемыми конфигурациями на некоторых процессорах Intel® Core™ 14-го поколения. Подробнее об Intel® Application Optimization: <br/>www.intel.com/content/<br/>www/us/en/support/articles/<br/>000095419/processors.html.",
          "⁴⁹ Подключение Wi-Fi зависит от доступности пропускной способности, поддержки операционной системы и совместимости маршрутизатора. Подробная информация на intel.com/performance-wireless. Результаты могут отличаться.",
          "⁵⁰ По состоянию на апрель 2024 года по сравнению с другими клиентскими технологиями двунаправленного подключения ввода/вывода, такими как технология Thunderbolt™ 5, eSATA и USB. Для обеспечения полноценной производительности необходимо подключение через аксессуары с поддержкой технологии Thunderbolt™ 5. Подробнее: intel.com/performance-wired. Результаты могут отличаться.",
          "⁵¹ Подробнее о технологии Thunderbolt™ 5: intel.com/thunderbolt.",
          "⁵² Производительность на основе минимальных требований к спецификации.",
          "⁵³ Утилита общего доступа Thunderbolt™ — это дополнительное лицензионное программное решение от производителя, которое может присутствовать не на всех ПК или устройствах с поддержкой Thunderbolt™ 5.<br>Быстрое подключение по сравнению с другими технологиями подключения ПК ввода/вывода, включая eSATA, USB и IEEE 1394 FireWire. Реальные значения производительности могут различаться в зависимости от используемых аппаратных средств и программного обеспечения. Необходимо использовать устройство с поддержкой Thunderbolt™.<br>Thunderbolt™ 4 и Thunderbolt™ 5 поддерживают интерфейс DisplayPort, через который по умолчанию можно подключить все мониторы с DisplayPort и mini-DisplayPort. Кроме того, при помощи адаптеров также возможно подключение ко всем остальным современным интерфейсам мониторов, включая HDMI, DVI и VGA.<br>Результаты отдельных аксессуаров могут отличаться; питание и производительность зависят от использования, конфигурации и других факторов и не гарантируют производительность отдельных аксессуаров.",
          "⁵⁴ На основе широкой совместимости, множества вариантов программного обеспечения, уникальной архитектуры и впечатляющей производительности процессоров Intel® Core™ Ultra, которые вместе обеспечивают лучшие общие возможности ИИ, в том числе по сравнению с процессорами конкурентов (по состоянию на август 2024 года).",
          "⁵⁵ Время автономной работы значительно зависит от настроек, режима использования и других факторов.",
          "⁵⁶ Относится к определенным ноутбукам Dell* XPS на базе процессора Intel® Core™ Ultra 7 268V на основе эталонного теста времени автономной работы UL Procyon* Battery Life Benchmark для оценки производительности в офисных приложениях; разрешение дисплея: 1920 x 1080; емкость аккумулятора 55 Вт·ч.",
          "⁵⁷ Графический процессор Intel® Arc™ доступен только в некоторых системах на базе процессоров Intel® Core™ Ultra. В других конфигурациях системы используется графика Intel® Graphics. Для получения информации о конфигурациях системы обратитесь к OEM-производителю или продавцу.",
          "⁵⁸ © 2025 Take-Two Interactive Software, Inc. © 2025 Techland S.A. ©&nbsp;Корпорация&nbsp;Intel. Воспользуйтесь до 15 сентября 2025 года. Действуют условия.",
          "⁵⁹ Целевой ПК должен быть оснащен процессором Intel® Core™ Ultra, работать на ОС Windows* 11 Home или Pro и быть подключенным к сети Интернет. Использовать бесплатную версию Laplink* PCmover* Express следует до 28 февраля 2026 года.",
          "⁶⁰ Относится к производительности в ряде популярных эталонных тестов на компьютерах с процессорами Intel®&nbsp;Core™&nbsp;Ultra серии 200V по сравнению с процессорами конкурентов.",
          "⁶¹ Относится к результатам тестирования производительности, полученным в августе 2024 года для различных популярных игр на компьютерах с процессорами Intel®&nbsp;Core™&nbsp;Ultra серии 200V, по сравнению с процессорами конкурентов.",
          "⁶² Относится к системам на базе процессоров Intel®&nbsp;Core™&nbsp;Ultra серии 200V со встроенной графикой Intel®&nbsp;Arc™ по сравнению с другими ультратонкими системами по состоянию на август 2024 года на основе впечатляющей производительности в эталонных тестах графики, производительности игрового процесса и высоких показателях в эталонных тестах графики на основе ИИ, в том числе по сравнению с процессорами конкурентов.",
          "⁶³ Относится к системам на базе процессоров Intel® Core™ Ultra серии 200V на основе наивысших показателей производительности в широком диапазоне вариантов использования, эталонных тестов и рабочих нагрузок по сравнению с процессорами конкурентов (по состоянию на август 2024 г.). Требуется бесплатное обновление; сроки зависят от устройства и региона. Подробнее: aka.ms/copilotpluspcs.",
          "⁶⁴ Относится к определенным ноутбукам Dell* XPS на базе процессора Intel® Core™ Ultra 7 268V на основе эталонного теста времени автономной работы UL Procyon* Battery Life Benchmark для оценки производительности в офисных приложениях; разрешение дисплея: 1920 x 1080; емкость аккумулятора 55 Вт·ч. Подробную информацию по сноскам 1–7 см. по адресу intel.com/performanceindex.",
          "⁶⁵ По результатам измерений уникальных характеристик разработок Intel® Evo™, таких как высокопроизводительные процессоры Intel® Core™, премиальные компоненты, непревзойденная совместимость и новейшие решения для подключения в элегантном инновационном дизайне (по состоянию на январь 2024 года). Все разработки под фабричной маркой Intel® Evo™ должны соответствовать ключевым требованиям пользователей мобильных устройств, включая быстродействие и время автономной работы. Производительность устройств может отличаться. Подробнее: www.intel.com/performance-evo. Ни один продукт или компонент не может быть полностью защищен. Программные приложения изображены только в иллюстративных целях. Функции ИИ могут требовать приобретения, подписки или активации ПО или могут иметь определенные требования к конфигурации или совместимости. Преимущества конфиденциальности данных обеспечиваются необлачными приложениями ИИ. Подробнее: atintel.com/AIPC. Результаты могут отличаться. ©&nbsp;Корпорация&nbsp;Intel. Другие наименования и товарные знаки являются собственностью своих законных владельцев.",
          "⁶⁶ На основе проверенных данных о времени автономной работы в реальных условиях при среднестатистическом ежедневном использовании для выполнения типичных рабочих процессов. Результаты могут отличаться. Подробная информация на intel.com/Performance-Evo. ©&nbsp;Корпорация&nbsp;Intel.",
          "[ZhCn Only Legal Text General]",
          "[ZhCn Only Legal Text Point12]",
          "[ZhCn Only Legal Text Point13]",
          "Корпорация Intel не принимает на себя никакой ответственности за неточности в ценах.",
          "* Другие наименования и товарные знаки являются собственностью своих законных владельцев.",
          "© INFLEXION GAMES, 2022. NIGHTINGALE, INFLEXION GAMES И СВЯЗАННЫЕ РАЗРАБОТКИ И КОМБИНИРОВАННЫЕ ЗНАКИ ЯВЛЯЮТСЯ ТОВАРНЫМИ ЗНАКАМИ INFLEXION STUDIOS INC. ВСЕ ПРАВА ЗАЩИЩЕНЫ.",
          "Для работы технологий Intel может потребоваться соответствующие аппаратные средства, программное обеспечение или активация сервисов. Ни один продукт или компонент не может быть полностью защищен. Ваши расходы и результаты могут отличаться. Подробнее о конфигурации: https://edc.intel.com/content/<br/>www/us/en/products/performance/<br/>benchmarks/wired/.",
          "Любые результаты и данные NERO* предоставляются для удобства и исключительно в информационных целях. Корпорация Intel не несет ответственности, например, за точность приложения NERO*, результаты и оценки производительности или возможные отличия от других загружаемых версий приложения, которые доступны на веб-сайте www.nero.com или других сторонних веб-сайтах. Эталонные тесты NERO* для ПК проводятся с использованием конкретных конфигураций компьютерных систем, компонентов, программного обеспечения, операций и функций. Любые изменения этих факторов могут сказаться на результатах. При принятии решения о покупке следует свериться с другими источниками информации и результатами иных тестов, в том числе с показателями производительности этого продукта в сочетании с другими продуктами.",
          "Для всех версий платформы Intel vPro® требуется подходящий процессор Intel®&nbsp;Core™, поддерживаемая операционная система, микросхема Intel® LAN и/или WLAN, усовершенствования микропрограммы и другое необходимое оборудование и программное обеспечение для возможностей управления, функций безопасности, производительности и стабильности системы, которые определяют платформу.",
          "Производительность зависит от использования, конфигурации и других факторов. Дополнительная информация: www.intel.com/PerformanceIndex.",
          "Intel не контролирует и не проверяет сторонние данные. Для оценки точности следует обращаться к другим источникам информации.",
          "© 2024 Ubisoft Entertainment*. All Rights Reserved. ©&nbsp;Корпорация&nbsp;Intel. Intel, логотип Intel и другие торговые марки Intel являются товарными знаками корпорации Intel или ее подразделений. * Другие наименования и товарные знаки являются собственностью своих законных владельцев.",
          "Ни один продукт или компонент не может быть полностью защищен.",
          "Ваши расходы и результаты могут отличаться.",
          "Intel, логотип Intel, Intel Core, Intel Optane, Intel Iris, Thunderbolt и логотип Thunderbolt являются товарными знаками корпорации Intel или ее подразделений. Другие наименования и товарные знаки являются собственностью своих законных владельцев.",
          "©&nbsp;Корпорация&nbsp;Intel."
        ],
        "targetURL": "",
        "iconURL": ""
      }
    },
    {
      "tabName": "navigation",
      "navigationTabs": [
        {
          "tr_specTitle": "Главная",
          "targetURL": "mob-content",
          "iconURL": "assets/images/nav-home.svg"
        },
        {
          "tr_specTitle": "Сравнение устройств",
          "targetURL": "compare",
          "iconURL": ""
        },
        {
          "tr_specTitle": "Популярное",
          "targetURL": "trending",
          "iconURL": "assets/images/trending.svg"
        }
      ]
    }
  ],
  "trending": [
    {
      "tr_specTitle": "Откройте новые возможности ИИ с помощью процессоров Intel® Core™ Ultra",
      "targetURL": "assets/lang/[XX]/trending/Ultra_Processor_Video.mp4",
      "iconURL": "",
      "videoName": "Ultra_Processor_Video"
    },
    {
      "tr_specTitle": "Откройте новые возможности ИИ с помощью процессоров Intel® Core™ Ultra",
      "targetURL": "assets/videos/trending/IPOS_AI_Video.mp4",
      "iconURL": "",
      "videoName": "IPOS_AI_Video"
    },
    {
      "tr_specTitle": "Откройте новые возможности ИИ с помощью процессоров Intel® Core™ Ultra",
      "targetURL": "assets/lang/[XX]/trending/Ultra_Processor_Video_Panel2.mp4",
      "iconURL": "",
      "videoName": "Ultra_Processor_Video_Panel2"
    },
    {
      "tr_specTitle": "Stable Diffusion*: генерация изображений по текстовому описанию",
      "targetURL": "assets/lang/[XX]/trending/text_link.mp4",
      "iconURL": "",
      "videoName": "text_link"
    },
    {
      "tr_specTitle": "Adobe*: редактирование фотографий",
      "targetURL": "assets/lang/[XX]/trending/photo_link.mp4",
      "iconURL": "",
      "videoName": "photo_link"
    },
    {
      "tr_specTitle": "Intel® X<sup>e</sup>SS: масштабирование изображений",
      "targetURL": "assets/lang/[XX]/trending/imgUpscaling_link.mp4",
      "iconURL": "",
      "videoName": "imgUpscaling_link"
    },
    {
      "tr_specTitle": "McAfee*: Детектор дипфейка",
      "targetURL": "assets/lang/[XX]/trending/Security_link.mp4",
      "iconURL": "",
      "videoName": "Security_link"
    },
    {
      "tr_specTitle": "Microsoft* Copilot",
      "targetURL": "assets/lang/[XX]/trending/copilot_link.mp4",
      "iconURL": "",
      "videoName": "copilot_link"
    },
    {
      "tr_specTitle": "Эффекты для совместной работы (Teams)",
      "targetURL": "assets/lang/[XX]/trending/Collaboration_link.mp4",
      "iconURL": "",
      "videoName": "Collaboration_link"
    },
    {
      "tr_specTitle": "IQIYI: управление жестами",
      "targetURL": "assets/lang/[XX]/trending/Gesture_link.mp4",
      "iconURL": "",
      "videoName": "Gesture_link"
    },
    {
      "tr_specTitle": "Синхронизируйте компьютер с телефоном и просматривайте уведомления, звонки и текстовые сообщения",
      "targetURL": "assets/videos/trending/unison_evo_mtl_ultra_processor_video.mp4",
      "iconURL": "",
      "videoName": "unison_evo_mtl_ultra_processor_video"
    },
    {
      "tr_specTitle": "Живое и яркое изображение благодаря встроенной графике",
      "targetURL": "assets/videos/trending/intel_iris_plus_graphics.mp4",
      "iconURL": "",
      "videoName": "intel_iris_plus_graphics"
    },
    {
      "tr_specTitle": "Microsoft*: управляйте своей жизнью",
      "targetURL": "assets/videos/trending/standard_home_detail_run_your_life_with_microsoft_365.mp4",
      "iconURL": "",
      "videoName": "standard_home_detail_run_your_life_with_microsoft_365"
    },
    {
      "tr_specTitle": "Microsoft*: всё для вас. Всё и сразу – всегда под рукой",
      "targetURL": "assets/videos/trending/standard_home_detail_onedrive_in_microsoft_365.mp4",
      "iconURL": "",
      "videoName": "standard_home_detail_onedrive_in_microsoft_365"
    },
    {
      "tr_specTitle": "Xbox* Game Pass Ultimate",
      "targetURL": "assets/videos/trending/windows_10_home.mp4",
      "iconURL": "",
      "videoName": "windows_10_home"
    },
    {
      "tr_specTitle": "Обеспечьте более быструю работу процессора на более высоких частотах благодаря точной настройке системы",
      "targetURL": "assets/videos/trending/gaming_processor_detail_enthusiast _overclocking.mp4",
      "iconURL": "",
      "videoName": "gaming_processor_detail_enthusiast _overclocking"
    },
    {
      "tr_specTitle": "Повысьте производительность настольной или мобильной системы, не жертвуя местом для хранения данных",
      "targetURL": "assets/videos/trending/optane_memory.mp4",
      "iconURL": "",
      "videoName": "optane_memory"
    },
    {
      "tr_specTitle": "Повысьте производительность настольной или мобильной системы, не жертвуя местом для хранения данных",
      "targetURL": "assets/videos/trending/standard_detail_panel_memory_optanememory_optane-memory.mp4",
      "iconURL": "",
      "videoName": "standard_detail_panel_memory_optanememory_optane-memory"
    },
    {
      "tr_specTitle": "Samsung OLED: бальзам для усталых глаз",
      "targetURL": "assets/lang/[XX]/trending/Samsung_OLED.mp4",
      "iconURL": "",
      "videoName": "Samsung_OLED"
    },
    {
      "tr_specTitle": "Высокая скорость, надежность и&nbsp;низкая&nbsp;задержка благодаря оптимизации&nbsp;сети на&nbsp;базе&nbsp;ИИ",
      "targetURL": "assets/videos/trending/standard__wifi_killer_7.mp4",
      "iconURL": "",
      "videoName": "standard__wifi_7_killer"
    },
    {
      "tr_specTitle": "Проводные сети ПК",
      "targetURL": "assets/videos/trending/standard_wifi_7.mp4",
      "iconURL": "",
      "videoName": "standard_wifi_7"
    },
    {
      "tr_specTitle": "Проводные сети ПК",
      "targetURL": "assets/videos/trending/wifi_7_desktop_video.mp4",
      "iconURL": "",
      "videoName": "wifi_7_desktop_video"
    },
    {
      "tr_specTitle": "Почти в 3 раза выше скорость благодаря Intel®&nbsp;Wi&#8209;Fi&nbsp;6&nbsp;(Gig+)",
      "targetURL": "assets/lang/[XX]/trending/nongaming__wifi_6e.mp4",
      "iconURL": "",
      "videoName": "wifi_6e"
    },
    {
      "tr_specTitle": "Подключайтесь к сети без проблем",
      "targetURL": "assets/videos/trending/standard_tile_wifi_intel_panel2_video.mp4",
      "iconURL": "",
      "videoName": "standard_tile_wifi_intel_panel2_video"
    },
    {
      "tr_specTitle": "Поистине универсальный кабель",
      "targetURL": "assets/videos/trending/standard_facttag_details_thunderbolt_version3.mp4",
      "iconURL": "",
      "videoName": "standard_facttag_details_thunderbolt_version3"
    },
    {
      "tr_specTitle": "Играйте как профессионал: узнайте, как Intel поддерживает игры и геймеров",
      "targetURL": "assets/videos/trending/gaming_graphics_detail.mp4",
      "iconURL": "",
      "videoName": "gaming_graphics_detail"
    },
    {
      "tr_specTitle": "Играйте как профессионал: с Intel рождаются чемпионы",
      "targetURL": "assets/videos/trending/gaming_detail_panel_influencer_video.mp4",
      "iconURL": "",
      "videoName": "gaming_detail_panel_influencer_video"
    }
  ],
  "uiText": {
    "tr_welcomePageTitle": "ДОБРО ПОЖАЛОВАТЬ",
    "tr_welcomePagetrSubtitle": "Управляйте этим ПК с помощью своего смартфона",
    "tr_welcomePagembSubtitle": "Здравствуйте! Ознакомьтесь с техническими характеристиками ПК с помощью смартфона",
    "tr_welcomePageBtnText": "Давайте начнем!",
    "tr_welcomePageText": "Просмотр и сравнение характеристик ПК с помощью смартфона",
    "tr_scrollText": "Навигация по устройству перед вами",
    "tr_toolTipTextc1": "Используйте эти кнопки для навигации по различным страницам на экране компьютера.",
    "tr_toolTipTextc2": "При нажатии на карточки ниже, откроется страница с подробными характеристиками каждого устройства.",
    "tr_toolTipTextc3": "Используйте эти кнопки для перемещения вверх и вниз по экрану.",
    "tr_toolTipTextc4": "Для просмотра технических характеристик устройства на своем смартфоне выключите удаленный режим.",
    "tr_toolTipTextmb1": "Выбирайте карточки для просмотра страниц с подробной информацией.",
    "tr_toolTipTextmb2": "Нажмите для просмотра кратких технических характеристик всех устройств.",
    "tr_toolTipTextmb3": "Нажмите кнопку для сканирования QR-кода и сравнения устройств",
    "tr_nextButton": "Далее",
    "tr_prevButton": "Назад",
    "tr_gotItButton": "ПОНЯТНО",
    "tr_skipButton": "Пропустить",
    "tr_placeholderText": "*заполнитель",
    "tr_processorHeading": "Процессор",
    "tr_processorSubheading": "Процессор Intel® Core™ i7 10&#8209;го поколения",
    "tr_memorySubheading": "[XX]&nbsp;ГБ",
    "tr_storageSubheading": "[XX]&nbsp;ГБ памяти Intel® Optane™ + SSD-накопи&shy;тель емкостью [YY]&nbsp;ГБ",
    "tr_coachmarkProcessor": "Процессор XX",
    "tr_coachmarkGraphics": "Графика [XX]",
    "tr_coachmarkMemory": "Технические характеристики",
    "tr_coachmarkOS": "[XX]",
    "tr_deviceName": "HP Envy 17T",
    "tr_price": "999,95 долл. США",
    "tr_compare": "Сравнить",
    "tr_viewallspecs": "ПРОСМОТР ВСЕХ ХАРАКТЕРИСТИК",
    "tr_operatingSystem": "ОС",
    "tr_AmdProcessorNonIntel": "Процессор AMD*",
    "tr_QualcommProcessorNonIntel": "Процессор Qualcomm*",
    "tr_GBText": "ГБ",
    "tr_remoteText": "Характеристики, отображаемые на экране ноутбука",
    "tr_scanErrorText": "Вы можете сравнивать до 3 отсканированных устройств. Удалите одно или несколько устройств.",
    "tr_scanErrorText2": "Вы уже сканировали это устройство. Отсканируйте другое устройство.",
    "tr_scanMsg": "Сканировать для добавления устройства",
    "tr_backToScan": "К сравнению",
    "tr_scanToCompare": "Сканировать для сравнения",
    "tr_compareDevice": "Сравнение устройств",
    "tr_processorTitle": "ПРОЦЕССОР",
    "tr_graphicTitle": "ГРАФИКА",
    "tr_storageTitle": "ХРАНИЛИЩЕ ДАННЫХ",
    "tr_displayTitle": "ДИСПЛЕЙ",
    "tr_batteryTitle": "БАТАРЕЯ",
    "tr_memoryTitle": "ПАМЯТЬ",
    "tr_wifiTitle": "Wi‑Fi",
    "tr_connectivityTitle": "ПОДКЛЮЧЕНИЕ",
    "tr_priceTitle": "ЦЕНА",
    "tr_operatingSystemTitle": "ОПЕРАЦИОННАЯ СИСТЕМА",
    "tr_batteryHoursText": "[XX] ч",
    "tr_hrsText": "ч",
    "tr_touchscreeenText": "Сенсорный дисплей [screenDiagonal]”",
    "tr_HDText": "HD",
    "tr_FHDText": "FHD",
    "tr_4KText": "4K",
    "tr_HDTochScreenText": "HD, сенсорный экран",
    "tr_FHDTouchScreenText": "FHD, сенсорный экран",
    "tr_4KTouchscreenText": "4K, сенсорный экран",
    "tr_wifi_gigText": "(Gig+)",
    "tr_save": "Сохранить",
    "tr_device_comparison": "Протокол сравнения устройств [dd].[mm].[yyyy]",
    "tr_Save_As_JPEG": "Сохранить как JPEG",
    "tr_Save_As_PDF": "Сохранить как PDF",
    "tr_Downloading_PDF": "Загрузка PDF",
    "tr_pdf_file": "[XXX].pdf",
    "tr_open": "Открыть",
    "tr_logo": "логотип",
    "tr_laptop_name": "Название ноутбука",
    "tr_TBText": "ТБ",
    "tr_optaneMemoryTitle": "Память Intel® Optane™",
    "tr_inchUnit": "дюймов",
    "tr_wifi1": "Wi‑Fi 1",
    "tr_wifi2": "Wi‑Fi 2",
    "tr_wifi3": "Wi‑Fi 3",
    "tr_wifi4": "Wi‑Fi 4",
    "tr_wifi5": "Wi‑Fi 5",
    "tr_wifi6": "Intel® Wi‑Fi 6 (Gig+)",
    "tr_wifi6Caps": "INTEL® WI‑FI 6 (GIG+)",
    "tr_wifi6e": "6E",
    "tr_wifi6eValue": "Wi‑Fi 6E",
    "tr_wifiXX": "Wi‑Fi [XX]",
    "tr_wifiXXCaps": "WI‑FI [XX]",
    "tr_wifi6E": "Intel® Wi‑Fi 6E (Gig+)",
    "tr_IntelOptaneMemory": "ПАМЯТЬ INTEL® OPTANE™",
    "tr_Thunderbolt3": "Технология Thunderbolt™ 3",
    "tr_Thunderbolt4": "Технология Thunderbolt™ 4",
    "tr_Thunderbolt5": "Технология Thunderbolt™ 5",
    "tr_processorGraphicsCaps": "ПРОЦЕССОРНАЯ ГРАФИКА",
    "tr_processorGraphicsSmall": "Процессорная графика",
    "tr_graphicsCardCaps": "ВЫДЕЛЕННАЯ ГРАФИКА",
    "tr_graphicsCardSmall": "Выделенная графика",
    "tr_processorTitleCamel": "Процессор",
    "tr_graphicTitleCamel": "Графика",
    "tr_storageTitleCamel": "Хранилище данных",
    "tr_displayTitleCamel": "Дисплей",
    "tr_batteryTitleCamel": "Батарея",
    "tr_batteryLifeTitleCamel": "Время автономной работы",
    "tr_exceptionalBattery": "Исключительное время автономной работы",
    "tr_memoryTitleCamel": "Память",
    "tr_connectivityTitleCamel": "Подключение",
    "tr_priceTitleCamel": "Цена",
    "tr_operatingSystemTitleCamel": "Операционная система",
    "tr_viewallspecsCamel": "Смотреть все технические характеристики",
    "tr_displayText": "[screenDiagonal]”",
    "tr_displayTextResolution": "[screenDiagonal]” [screenResolutionType]",
    "tr_displayTextResolutionTouchscreen": "Сенсорный дисплей [screenDiagonal]” [screenResolutionType]",
    "tr_OS": "ОС",
    "tr_Chrome_OS": "Chrome* OS",
    "tr_PCSpecs_text": "Спецификации ПК",
    "tr_explorePC_text": "Подробнее об этом ПК",
    "tr_mtlPC_text": "Узнайте об устройствах, которые по-настоящему могут всё",
    "tr_optaneMemory": "Память Intel®&nbsp;Optane™",
    "tr_displayText_Display": "ДИСПЛЕЙ [screenDiagonal]\"",
    "tr_displayTextResolution_Display": "ДИСПЛЕЙ [screenDiagonal]\" [screenResolutionType]",
    "tr_displayTextResolutionTouchscreen_Display": "СЕНСОРНЫЙ ДИСПЛЕЙ [screenDiagonal]\" [screenResolutionType]",
    "tr_displayTextTouchscreeenText": "СЕНСОРНЫЙ ДИСПЛЕЙ [screenDiagonal]\"",
    "tr_learnMoreLabel": "Подробнее",
    "tr_batteryHoursTextUpperCase": "[XX] Ч.",
    "tr_processorGraphicsIrisXe": "ПРОЦЕССОР INTEL® CORE™ [cpu_fam] 11-ГО ПОКОЛЕНИЯ И ГРАФИКА INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax": "ПРОЦЕССОР INTEL® CORE™ [cpu_fam] 11-ГО ПОКОЛЕНИЯ И ГРАФИКА INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup> MAX",
    "tr_Thunderbolt3UpperCase": "ТЕХНОЛОГИЯ THUNDERBOLT™ 3",
    "tr_Thunderbolt4UpperCase": "ТЕХНОЛОГИЯ THUNDERBOLT™ 4",
    "tr_Thunderbolt5UpperCase": "ОЦЕНИТЕ ПРЕИМУЩЕСТВА ТЕХНОЛОГИИ THUNDERBOLT™ 5",
    "tr_processorWithArcGraphics": "ПРОЦЕССОР INTEL® CORE™ [cpu_fam] 12-ГО ПОКОЛЕНИЯ И ГРАФИКА INTEL® ARC™",
    "tr_processorGraphicsIrisXe12Gen": "ПРОЦЕССОР INTEL® CORE™ [cpu_fam] 12-ГО ПОКОЛЕНИЯ И ГРАФИКА INTEL® IRIS®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax12Gen": "ПРОЦЕССОР INTEL® CORE™ [cpu_fam] 12-ГО ПОКОЛЕНИЯ И ГРАФИКА INTEL® IRIS®&nbsp;X<sup class='small_text_sup_xe'>e</sup> MAX",
    "tr_samsung_oled": "Samsung OLED",
    "tr_oled": "OLED",
    "tr_processorWithArcGraphics13Gen": "ПРОЦЕССОР INTEL® CORE™ [cpu_fam] 13-ГО ПОКОЛЕНИЯ И ГРАФИКА INTEL® ARC™",
    "tr_processorGraphicsIrisXe13Gen": "ПРОЦЕССОР INTEL® CORE™ [cpu_fam] 13-ГО ПОКОЛЕНИЯ И ГРАФИКА INTEL® IRIS®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax13Gen": "ПРОЦЕССОР INTEL® CORE™ [cpu_fam] 13-ГО ПОКОЛЕНИЯ И ГРАФИКА INTEL® IRIS®&nbsp;X<sup class='small_text_sup_xe'>e</sup> MAX",
    "tr_ultra5": "Intel®&nbsp;Core™ Ultra&nbsp;5",
    "tr_ultra7": "Intel®&nbsp;Core™ Ultra&nbsp;7",
    "tr_ultra9": "Intel®&nbsp;Core™ Ultra&nbsp;9",
    "tr_arcGraphicsBadgeToModelNameMapping": {
      "tr_A350M": "ГРАФИКА INTEL® ARC™ A350M",
      "tr_A370M": "ГРАФИКА INTEL® ARC™ A370M",
      "tr_A730M": "ГРАФИКА INTEL® ARC™ A730M",
      "tr_A770M": "ГРАФИКА INTEL® ARC™ A770M",
      "tr_A310": "ГРАФИКА INTEL® ARC™ A310",
      "tr_A380": "ГРАФИКА INTEL® ARC™ A380",
      "tr_A580": "ГРАФИКА INTEL® ARC™ A580",
      "tr_A750": "ГРАФИКА INTEL® ARC™ A750",
      "tr_A770": "ГРАФИКА INTEL® ARC™ A770"
    },
    "tr_memoryValue": "[XX] ГБ ОЗУ",
    "tr_memoryWithOptaneDesc": "[Value1] ГБ памяти = [Value2] ГБ памяти Intel® Optane™ + [Value3] ГБ ОЗУ",
    "tr_textGBGB": "SSD-накопитель емкостью [convertedSSD]&nbsp;ГБ + жесткий диск емкостью [convertedHDD]&nbsp;ГБ",
    "tr_textGBTB": "SSD-накопитель емкостью [convertedSSD]&nbsp;ГБ + жесткий диск емкостью [convertedHDD]&nbsp;ТБ",
    "tr_textTBGB": "SSD-накопитель емкостью [convertedSSD]&nbsp;ТБ + жесткий диск емкостью [convertedHDD]&nbsp;ГБ",
    "tr_textTBTB": "SSD-накопитель емкостью [convertedSSD]&nbsp;ТБ + жесткий диск емкостью [convertedHDD]&nbsp;ТБ",
    "tr_textGBSSD": "SSD-накопи&shy;тель емкостью [convertedSSD]&nbsp;ГБ",
    "tr_textTBSSD": "SSD-накопитель емкостью [convertedSSD]&nbsp;ТБ",
    "tr_textGBHDD": "Жесткий диск [convertedHDD]&nbsp;ГБ",
    "tr_textTBHDD": "Жесткий диск [convertedHDD]&nbsp;ТБ",
    "tr_textStorageWithOptaneGB": "Память Intel®&nbsp;Optane™ емкостью [XX]&nbsp;ГБ + SSD&#8209;накопитель емкостью [convertedSSD]&nbsp;ГБ",
    "tr_textStorageWithOptaneTB": "Память Intel®&nbsp;Optane™ емкостью [XX]&nbsp;ГБ + SSD&#8209;накопитель емкостью [convertedSSD]&nbsp;ТБ",
    "tr_OSDescriptionMapping": {
      "tr_OS_A": "Windows* 7",
      "tr_OS_B": "Windows* 7 Домашняя базовая",
      "tr_OS_C": "Windows* 7 Домашняя расширенная",
      "tr_OS_D": "Windows* 7 Профессиональная",
      "tr_OS_E": "Windows* 7 Корпоративная",
      "tr_OS_F": "Windows* 7 Максимальная",
      "tr_OS_G": "Windows* 8",
      "tr_OS_H": "Windows* 8 Pro",
      "tr_OS_I": "Windows* 8 Корпоративная",
      "tr_OS_J": "Windows* 8.1",
      "tr_OS_K": "Windows* 8.1 Pro",
      "tr_OS_L": "Windows* 8.1 Корпоративная",
      "tr_OS_M": "Windows* 8.1",
      "tr_OS_N": "ОС Windows* 10 Домашняя",
      "tr_OS_O": "Windows* 10 Pro",
      "tr_OS_P": "Windows* 10 Корпоративная",
      "tr_OS_Q": "Windows* 11 Домашняя",
      "tr_OS_R": "Windows* 11 Pro",
      "tr_OS_S": "Windows* 11 Корпоративная",
      "tr_OS_T": "Windows* 10 Домашняя в режиме S",
      "tr_OS_U": "Windows* 10 Pro в режиме S",
      "tr_OS_V": "Windows* 10 Корпоративная в режиме S",
      "tr_OS_W": "Windows* 11 Домашняя в режиме S",
      "tr_OS_X": "Windows* 11 Pro в режиме S",
      "tr_OS_Y": "Windows* 11 Корпоративная в режиме S"
    },
    "tr_GraphicsDescriptionMapping": {
      "tr_GR1": "AMD* Mobility Radeon* 4100",
      "tr_GR2": "AMD* Mobility Radeon* HD 2400",
      "tr_GR3": "AMD* Mobility Radeon* HD 2400 XT",
      "tr_GR4": "AMD* Mobility Radeon* HD 2600",
      "tr_GR5": "AMD* Mobility Radeon* HD 2600 XT",
      "tr_GR6": "AMD* Mobility Radeon* HD 3400",
      "tr_GR7": "AMD* Mobility Radeon* HD 3430",
      "tr_GR8": "AMD* Mobility Radeon* HD 3650",
      "tr_GR9": "AMD* Mobility Radeon* HD 3670",
      "tr_GR10": "AMD* Mobility Radeon* HD 3850",
      "tr_GR11": "AMD* Mobility Radeon* HD 3850 X2",
      "tr_GR12": "AMD* Mobility Radeon* HD 3870",
      "tr_GR13": "AMD* Mobility Radeon* HD 3870 X2",
      "tr_GR14": "AMD* Mobility Radeon* HD 4200",
      "tr_GR15": "AMD* Mobility Radeon* HD 4300",
      "tr_GR16": "AMD* Mobility Radeon* HD 4330",
      "tr_GR17": "AMD* Mobility Radeon* HD 4500",
      "tr_GR18": "AMD* Mobility Radeon* HD 4650",
      "tr_GR19": "AMD* Mobility Radeon* HD 4670",
      "tr_GR20": "AMD* Mobility Radeon* HD 4830",
      "tr_GR21": "AMD* Mobility Radeon* HD 4850",
      "tr_GR22": "AMD* Mobility Radeon* HD 4860",
      "tr_GR23": "AMD* Mobility Radeon* HD 4870",
      "tr_GR24": "AMD* Mobility Radeon* HD 5000",
      "tr_GR25": "AMD* Mobility Radeon* HD 5570",
      "tr_GR26": "AMD* Mobility Radeon* HD 5800",
      "tr_GR27": "AMD* Mobility Radeon* HD 6000",
      "tr_GR28": "AMD* Radeon* HD 2350",
      "tr_GR29": "AMD* Radeon* HD 2400",
      "tr_GR30": "AMD* Radeon* HD 2400 Pro",
      "tr_GR31": "AMD* Radeon* HD 2400 XT",
      "tr_GR32": "AMD* Radeon* HD 2600",
      "tr_GR33": "AMD* Radeon* HD 2600 Pro",
      "tr_GR34": "AMD* Radeon* HD 2600 XT",
      "tr_GR35": "AMD* Radeon* HD 2900 GT",
      "tr_GR36": "AMD* Radeon* HD 2900 Pro",
      "tr_GR37": "AMD* Radeon* HD 2900 XT",
      "tr_GR38": "AMD* Radeon* HD 3200",
      "tr_GR39": "AMD* Radeon* HD 3300",
      "tr_GR40": "AMD* Radeon* HD 3450",
      "tr_GR41": "AMD* Radeon* HD 3470",
      "tr_GR42": "AMD* Radeon* HD 3600",
      "tr_GR43": "AMD* Radeon* HD 3650",
      "tr_GR44": "AMD* Radeon* HD 3830",
      "tr_GR45": "AMD* Radeon* HD 3850",
      "tr_GR46": "AMD* Radeon* HD 3850 X2",
      "tr_GR47": "AMD* Radeon* HD 3870",
      "tr_GR48": "AMD* Radeon* HD 3870 X2",
      "tr_GR49": "AMD* Radeon* HD 4200",
      "tr_GR50": "AMD* Radeon* HD 4250",
      "tr_GR51": "AMD* Radeon* HD 4290",
      "tr_GR52": "AMD* Radeon* HD 4300",
      "tr_GR53": "AMD* Radeon* HD 4550",
      "tr_GR54": "AMD* Radeon* HD 4600",
      "tr_GR55": "AMD* Radeon* HD 4700",
      "tr_GR56": "AMD* Radeon* HD 4770",
      "tr_GR57": "AMD* Radeon* HD 4800",
      "tr_GR58": "AMD* Radeon* HD 4850 X2",
      "tr_GR59": "AMD* Radeon* HD 4870 X2",
      "tr_GR60": "AMD* Radeon* HD 5000",
      "tr_GR61": "AMD* Radeon* HD 5400",
      "tr_GR62": "AMD* Radeon* HD 5450",
      "tr_GR63": "AMD* Radeon* HD 5470",
      "tr_GR64": "AMD* Radeon* HD 5490",
      "tr_GR65": "AMD* Radeon* HD 5500",
      "tr_GR66": "AMD* Radeon* HD 5530",
      "tr_GR67": "AMD* Radeon* HD 5570",
      "tr_GR68": "AMD* Radeon* HD 5600",
      "tr_GR69": "AMD* Radeon* HD 5630",
      "tr_GR70": "AMD* Mobility Radeon* 4100",
      "tr_GR71": "AMD* Radeon* HD 5690",
      "tr_GR72": "AMD* Radeon* HD 5700",
      "tr_GR73": "AMD* Radeon* HD 5730",
      "tr_GR74": "AMD* Radeon* HD 5800",
      "tr_GR75": "AMD* Radeon* HD 5850X2",
      "tr_GR76": "AMD* Radeon* HD 5900",
      "tr_GR77": "AMD* Radeon* HD 6230",
      "tr_GR78": "AMD* Radeon* HD 6250",
      "tr_GR79": "AMD* Radeon* HD 6290",
      "tr_GR80": "AMD* Radeon* HD 6300M",
      "tr_GR81": "AMD* Radeon* HD 6350",
      "tr_GR82": "AMD* Radeon* HD 6350A",
      "tr_GR83": "AMD* Radeon* HD 6390",
      "tr_GR84": "AMD* Radeon* HD 6400",
      "tr_GR85": "AMD* Radeon* HD 6430M",
      "tr_GR86": "AMD* Radeon* HD 6450",
      "tr_GR87": "AMD* Radeon* HD 6490",
      "tr_GR88": "AMD* Radeon* HD 6500",
      "tr_GR89": "AMD* Radeon* HD 6510",
      "tr_GR90": "AMD* Radeon* HD 6530",
      "tr_GR91": "AMD* Radeon* HD 6570",
      "tr_GR92": "AMD* Radeon* HD 6600A",
      "tr_GR93": "AMD* Radeon* HD 6610",
      "tr_GR94": "AMD* Radeon* HD 6670",
      "tr_GR95": "AMD* Radeon* HD 6700",
      "tr_GR96": "AMD* Radeon* HD 6700M",
      "tr_GR97": "AMD* Radeon* HD 6750",
      "tr_GR98": "AMD* Radeon* HD 6800",
      "tr_GR99": "AMD* Radeon* HD 6800M",
      "tr_GR100": "AMD* Radeon* HD 6850",
      "tr_GR101": "AMD* Radeon* HD 6850 X2",
      "tr_GR102": "AMD* Radeon* HD 6870",
      "tr_GR103": "AMD* Radeon* HD 6870 X2",
      "tr_GR104": "AMD* Radeon* HD 6900",
      "tr_GR105": "AMD* Radeon* HD 6900M",
      "tr_GR106": "AMD* Radeon* HD 7000",
      "tr_GR107": "AMD* Radeon* HD 7000M",
      "tr_GR108": "AMD* Radeon* HD 7300",
      "tr_GR109": "AMD* Radeon* HD 7350",
      "tr_GR110": "AMD* Radeon* HD 7400",
      "tr_GR111": "AMD* Radeon* HD 7400A",
      "tr_GR112": "AMD* Radeon* HD 7400G",
      "tr_GR113": "AMD* Radeon* HD 7400M",
      "tr_GR114": "AMD* Radeon* HD 7420G",
      "tr_GR115": "AMD* Radeon* HD 7450",
      "tr_GR116": "AMD* Radeon* HD 7450A",
      "tr_GR117": "AMD* Radeon* HD 7470",
      "tr_GR118": "AMD* Radeon* HD 7480D",
      "tr_GR119": "AMD* Radeon* HD 7500",
      "tr_GR120": "AMD* Radeon* HD 7500G",
      "tr_GR121": "AMD* Radeon* HD 7500M",
      "tr_GR122": "AMD* Radeon* HD 7510",
      "tr_GR123": "AMD* Radeon* HD 7520G",
      "tr_GR124": "AMD* Radeon* HD 7540D",
      "tr_GR125": "AMD* Radeon* HD 7560D",
      "tr_GR126": "AMD* Radeon* HD 7570",
      "tr_GR127": "AMD* Radeon* HD 7600",
      "tr_GR128": "AMD* Radeon* HD 7600A",
      "tr_GR129": "AMD* Radeon* HD 7600G",
      "tr_GR130": "AMD* Radeon* HD 7600M",
      "tr_GR131": "AMD* Radeon* HD 7620G",
      "tr_GR132": "AMD* Radeon* HD 7640G",
      "tr_GR133": "AMD* Radeon* HD 7660D",
      "tr_GR134": "AMD* Radeon* HD 7660G",
      "tr_GR135": "AMD* Radeon* HD 7670",
      "tr_GR136": "AMD* Radeon* HD 7670M",
      "tr_GR137": "AMD* Radeon* HD 7700",
      "tr_GR138": "AMD* Radeon* HD 7700M",
      "tr_GR139": "AMD* Radeon* HD 7720",
      "tr_GR140": "AMD* Radeon* HD 7800",
      "tr_GR141": "AMD* Radeon* HD 7800M",
      "tr_GR142": "AMD* Radeon* HD 7900",
      "tr_GR143": "AMD* Radeon* HD 7970M",
      "tr_GR144": "AMD* Radeon* HD 8180",
      "tr_GR145": "AMD* Radeon* HD 8200",
      "tr_GR146": "AMD* Radeon* HD 8210",
      "tr_GR147": "AMD* Radeon* HD 8210E",
      "tr_GR148": "AMD* Radeon* HD 8250",
      "tr_GR149": "AMD* Radeon* HD 8280E",
      "tr_GR150": "AMD* Radeon* HD 8310G",
      "tr_GR151": "AMD* Radeon* HD 8330",
      "tr_GR152": "AMD* Radeon* HD 8330E",
      "tr_GR153": "AMD* Radeon* HD 8350",
      "tr_GR154": "AMD* Radeon* HD 8350G",
      "tr_GR155": "AMD* Radeon* HD 8370D",
      "tr_GR156": "AMD* Radeon* HD 8400",
      "tr_GR157": "AMD* Radeon* HD 8400E",
      "tr_GR158": "AMD* Radeon* HD 8410G",
      "tr_GR159": "AMD* Radeon* HD 8450",
      "tr_GR160": "AMD* Radeon* HD 8450G",
      "tr_GR161": "AMD* Radeon* HD 8470",
      "tr_GR162": "AMD* Radeon* HD 8470D",
      "tr_GR163": "AMD* Radeon* HD 8490",
      "tr_GR164": "AMD* Radeon* HD 8500M",
      "tr_GR165": "AMD* Radeon* HD 8510",
      "tr_GR166": "AMD* Radeon* HD 8510G",
      "tr_GR167": "AMD* Radeon* HD 8550",
      "tr_GR168": "AMD* Radeon* HD 8550D",
      "tr_GR169": "AMD* Radeon* HD 8550G",
      "tr_GR170": "AMD* Radeon* HD 8570",
      "tr_GR171": "AMD* Radeon* HD 8570D",
      "tr_GR172": "AMD* Radeon* HD 8600",
      "tr_GR173": "AMD* Radeon* HD 8600M",
      "tr_GR174": "AMD* Radeon* HD 8610G",
      "tr_GR175": "AMD* Radeon* HD 8650D",
      "tr_GR176": "AMD* Radeon* HD 8650G",
      "tr_GR177": "AMD* Radeon* HD 8670D",
      "tr_GR178": "AMD* Radeon* HD 8730",
      "tr_GR179": "AMD* Radeon* HD 8760",
      "tr_GR180": "AMD* Radeon* HD 8770",
      "tr_GR181": "AMD* Radeon* HD 8790M",
      "tr_GR182": "AMD* Radeon* HD 8800M",
      "tr_GR183": "AMD* Radeon* HD 8870",
      "tr_GR184": "AMD* Radeon* HD 8950",
      "tr_GR185": "AMD* Radeon* HD 8970",
      "tr_GR186": "AMD* Radeon* HD 8970M",
      "tr_GR187": "AMD* Radeon* HD 8990",
      "tr_GR188": "AMD* Radeon* HD 9000",
      "tr_GR189": "AMD* Radeon* Pro 450",
      "tr_GR190": "AMD* Radeon* Pro 455",
      "tr_GR191": "AMD* Radeon* Pro 460",
      "tr_GR192": "AMD* Radeon* Pro 465",
      "tr_GR193": "AMD* Radeon* Pro Duo",
      "tr_GR194": "AMD* Radeon* Pro SSG",
      "tr_GR195": "AMD* Radeon* Pro V340",
      "tr_GR196": "AMD* Radeon* Pro V5300X",
      "tr_GR197": "AMD* Radeon* Pro V7300X",
      "tr_GR198": "AMD* Radeon* Pro V7350x2",
      "tr_GR199": "AMD* Radeon* Pro Vega 56",
      "tr_GR200": "AMD* Radeon* Pro VII",
      "tr_GR201": "AMD* Radeon* Pro W5500",
      "tr_GR202": "AMD* Radeon* Pro W5500M",
      "tr_GR203": "AMD* Radeon* Pro W5700",
      "tr_GR204": "AMD* Radeon* Pro W6300",
      "tr_GR205": "AMD* Radeon* Pro W6300M",
      "tr_GR206": "AMD* Radeon* Pro W6400",
      "tr_GR207": "AMD* Radeon* Pro W6500M",
      "tr_GR208": "AMD* Radeon* Pro W6600",
      "tr_GR209": "AMD* Radeon* Pro W6600M",
      "tr_GR210": "AMD* Radeon* Pro W6800",
      "tr_GR211": "AMD* Radeon* Pro W7500",
      "tr_GR212": "AMD* Radeon* Pro W7600",
      "tr_GR213": "AMD* Radeon* Pro W7700",
      "tr_GR214": "AMD* Radeon* Pro W7800",
      "tr_GR215": "AMD* Radeon* Pro W7900",
      "tr_GR216": "AMD* Radeon* Pro WX 2100",
      "tr_GR217": "AMD* Radeon* Pro WX 3100",
      "tr_GR218": "AMD* Radeon* Pro WX 3200",
      "tr_GR219": "AMD* Radeon* Pro WX 4100",
      "tr_GR220": "AMD* Radeon* Pro WX 4150",
      "tr_GR221": "AMD* Radeon* Pro WX 4170",
      "tr_GR222": "AMD* Radeon* Pro WX 5100",
      "tr_GR223": "AMD* Radeon* Pro WX 7100",
      "tr_GR224": "AMD* Radeon* Pro WX 8200",
      "tr_GR225": "AMD* Radeon* Pro WX 9100",
      "tr_GR226": "AMD* Radeon* R5 200",
      "tr_GR227": "AMD* Radeon* R5 220",
      "tr_GR228": "AMD* Radeon* R5 230",
      "tr_GR229": "AMD* Radeon* R5 235",
      "tr_GR230": "AMD* Radeon* R5 240",
      "tr_GR231": "AMD* Radeon* R5 340",
      "tr_GR232": "AMD* Radeon* R5 340X",
      "tr_GR233": "AMD* Radeon* R5 420",
      "tr_GR234": "AMD* Radeon* R5 430",
      "tr_GR235": "AMD* Radeon* R5 430M",
      "tr_GR236": "AMD* Radeon* R5 M200",
      "tr_GR237": "AMD* Radeon* R5 M230",
      "tr_GR238": "AMD* Radeon* R5 M240",
      "tr_GR239": "AMD* Radeon* R5 M255",
      "tr_GR240": "AMD* Radeon* R5 M315",
      "tr_GR241": "AMD* Radeon* R5 M320",
      "tr_GR242": "AMD* Radeon* R5 M330",
      "tr_GR243": "AMD* Radeon* R5 M335",
      "tr_GR244": "AMD* Radeon* R5 M430",
      "tr_GR245": "AMD* Radeon* R5 M435",
      "tr_GR246": "AMD* Radeon* R6 M255DX",
      "tr_GR247": "AMD* Radeon* R6 M335DX",
      "tr_GR248": "AMD* Radeon* R6 M340DX",
      "tr_GR249": "AMD* Radeon* R6 M435DX",
      "tr_GR250": "AMD* Radeon* R7 200",
      "tr_GR251": "AMD* Radeon* R7 240",
      "tr_GR252": "AMD* Radeon* R7 250",
      "tr_GR253": "AMD* Radeon* R7 250X",
      "tr_GR254": "AMD* Radeon* R7 265",
      "tr_GR255": "AMD* Radeon* R7 300",
      "tr_GR256": "AMD* Radeon* R7 340",
      "tr_GR257": "AMD* Radeon* R7 350",
      "tr_GR258": "AMD* Radeon* R7 350X",
      "tr_GR259": "AMD* Radeon* R7 360",
      "tr_GR260": "AMD* Radeon* R7 370",
      "tr_GR261": "AMD* Radeon* R7 430",
      "tr_GR262": "AMD* Radeon* R7 450",
      "tr_GR263": "AMD* Radeon* R7 M260",
      "tr_GR264": "AMD* Radeon* R7 M260DX",
      "tr_GR265": "AMD* Radeon* R7 M265",
      "tr_GR266": "AMD* Radeon* R7 M265DX",
      "tr_GR267": "AMD* Radeon* R7 M340",
      "tr_GR268": "AMD* Radeon* R7 M350",
      "tr_GR269": "AMD* Radeon* R7 M360",
      "tr_GR270": "AMD* Radeon* R7 M370",
      "tr_GR271": "AMD* Radeon* R7 M380",
      "tr_GR272": "AMD* Radeon* R7 M440",
      "tr_GR273": "AMD* Radeon* R7 M460",
      "tr_GR274": "AMD* Radeon* R7 M465",
      "tr_GR275": "AMD* Radeon* R7 M465X",
      "tr_GR276": "AMD* Radeon* R8 M350DX",
      "tr_GR277": "AMD* Radeon* R8 M435DX",
      "tr_GR278": "AMD* Radeon* R8 M535DX",
      "tr_GR279": "AMD* Radeon* R9 200",
      "tr_GR280": "AMD* Radeon* R9 255",
      "tr_GR281": "AMD* Radeon* R9 260",
      "tr_GR282": "AMD* Radeon* R9 270",
      "tr_GR283": "AMD* Radeon* R9 280",
      "tr_GR284": "AMD* Radeon* R9 290",
      "tr_GR285": "AMD* Radeon* R9 290X",
      "tr_GR286": "AMD* Radeon* R9 295X2",
      "tr_GR287": "AMD* Radeon* R9 360",
      "tr_GR288": "AMD* Radeon* R9 370",
      "tr_GR289": "AMD* Radeon* R9 370X",
      "tr_GR290": "AMD* Radeon* R9 380",
      "tr_GR291": "AMD* Radeon* R9 390",
      "tr_GR292": "AMD* Radeon* R9 390X",
      "tr_GR293": "AMD* Radeon* R9 Fury",
      "tr_GR294": "AMD* Radeon* R9 Fury X",
      "tr_GR295": "AMD* Radeon* R9 M200X",
      "tr_GR296": "AMD* Radeon* R9 M275X",
      "tr_GR297": "AMD* Radeon* R9 M280X",
      "tr_GR298": "AMD* Radeon* R9 M360",
      "tr_GR299": "AMD* Radeon* R9 M365X",
      "tr_GR300": "AMD* Radeon* R9 M370X",
      "tr_GR301": "AMD* Radeon* R9 M375",
      "tr_GR302": "AMD* Radeon* R9 M375X",
      "tr_GR303": "AMD* Radeon* R9 M380",
      "tr_GR304": "AMD* Radeon* R9 M385",
      "tr_GR305": "AMD* Radeon* R9 M385X",
      "tr_GR306": "AMD* Radeon* R9 M390X",
      "tr_GR307": "AMD* Radeon* R9 M395X",
      "tr_GR308": "AMD* Radeon* R9 M470X",
      "tr_GR309": "AMD* Radeon* RX 455",
      "tr_GR310": "AMD* Radeon* RX 460",
      "tr_GR311": "AMD* Radeon* RX 470",
      "tr_GR312": "AMD* Radeon* RX 480",
      "tr_GR313": "AMD* Radeon* RX 5300",
      "tr_GR314": "AMD* Radeon* RX 5300M",
      "tr_GR315": "AMD* Radeon* RX 540",
      "tr_GR316": "AMD* Radeon* RX 540X",
      "tr_GR317": "AMD* Radeon* RX 550",
      "tr_GR318": "AMD* Radeon* RX 5500",
      "tr_GR319": "AMD* Radeon* RX 5500 XT",
      "tr_GR320": "AMD* Radeon* RX 5500M",
      "tr_GR321": "AMD* Radeon* RX 550X",
      "tr_GR322": "AMD* Radeon* RX 560",
      "tr_GR323": "AMD* Radeon* RX 560 XT",
      "tr_GR324": "AMD* Radeon* RX 5600",
      "tr_GR325": "AMD* Radeon* RX 5600 OEM",
      "tr_GR326": "AMD* Radeon* RX 5600 XT",
      "tr_GR327": "AMD* Radeon* RX 5600M",
      "tr_GR328": "AMD* Radeon* RX 560X",
      "tr_GR329": "AMD* Radeon* RX 570",
      "tr_GR330": "AMD* Radeon* RX 5700",
      "tr_GR331": "AMD* Radeon* RX 5700 XT",
      "tr_GR332": "AMD* Radeon* RX 5700M",
      "tr_GR333": "AMD* Radeon* RX 570X",
      "tr_GR334": "AMD* Radeon* RX 580",
      "tr_GR335": "AMD* Radeon* RX 580X",
      "tr_GR336": "AMD* Radeon* RX 590",
      "tr_GR337": "AMD* Radeon* RX 590 GME",
      "tr_GR338": "AMD* Radeon* RX 6300",
      "tr_GR339": "AMD* Radeon* RX 6300M",
      "tr_GR340": "AMD* Radeon* RX 640",
      "tr_GR341": "AMD* Radeon* RX 6400",
      "tr_GR342": "AMD* Radeon* RX 6450M",
      "tr_GR343": "AMD* Radeon* RX 6500",
      "tr_GR344": "AMD* Radeon* RX 6500 XT",
      "tr_GR345": "AMD* Radeon* RX 6500M",
      "tr_GR346": "AMD* Radeon* RX 6550M",
      "tr_GR347": "AMD* Radeon* RX 6600",
      "tr_GR348": "AMD* Radeon* RX 6600 LE",
      "tr_GR349": "AMD* Radeon* RX 6600 XT",
      "tr_GR350": "AMD* Radeon* RX 6600M",
      "tr_GR351": "AMD* Radeon* RX 6600S",
      "tr_GR352": "AMD* Radeon* RX 6650 XT",
      "tr_GR353": "AMD* Radeon* RX 6650M",
      "tr_GR354": "AMD* Radeon* RX 6650M XT",
      "tr_GR355": "AMD* Radeon* RX 6700",
      "tr_GR356": "AMD* Radeon* RX 6700 XT",
      "tr_GR357": "AMD* Radeon* RX 6700M",
      "tr_GR358": "AMD* Radeon* RX 6700S",
      "tr_GR359": "AMD* Radeon* RX 6750 GRE",
      "tr_GR360": "AMD* Radeon* RX 6750 XT",
      "tr_GR361": "AMD* Radeon* RX 6800",
      "tr_GR362": "AMD* Radeon* RX 6800 XT",
      "tr_GR363": "AMD* Radeon* RX 6800M",
      "tr_GR364": "AMD* Radeon* RX 6800S",
      "tr_GR365": "AMD* Radeon* RX 6850M XT",
      "tr_GR366": "AMD* Radeon* RX 6900 XT",
      "tr_GR367": "AMD* Radeon* RX 6950 XT",
      "tr_GR368": "AMD* Radeon* RX 7600",
      "tr_GR369": "AMD* Radeon* RX 7600 XT",
      "tr_GR370": "AMD* Radeon* RX 7600M",
      "tr_GR371": "AMD* Radeon* RX 7600M XT",
      "tr_GR372": "AMD* Radeon* RX 7600S",
      "tr_GR373": "AMD* Radeon* RX 7700 XT",
      "tr_GR374": "AMD* Radeon* RX 7700S",
      "tr_GR375": "AMD* Radeon* RX 7800 XT",
      "tr_GR376": "AMD* Radeon* RX 7900 GRE",
      "tr_GR377": "AMD* Radeon* RX 7900 XT",
      "tr_GR378": "AMD* Radeon* RX 7900 XTX",
      "tr_GR379": "AMD* Radeon* RX 7900M",
      "tr_GR380": "AMD* Radeon* RX Vega",
      "tr_GR381": "AMD* Radeon* RX Vega 10",
      "tr_GR382": "AMD* Radeon* RX Vega 11",
      "tr_GR383": "AMD* Radeon* RX Vega 64",
      "tr_GR384": "AMD* Radeon* RX Vega M GH",
      "tr_GR385": "AMD* Radeon* RX Vega M GL",
      "tr_GR386": "Графика Intel® Arc™ A310",
      "tr_GR387": "Графика Intel®&nbsp;Arc™ A350M",
      "tr_GR388": "Графика Intel®&nbsp;Arc™ A370M",
      "tr_GR389": "Графика Intel® Arc™ A380",
      "tr_GR390": "Графика Intel®&nbsp;Arc™ A530M",
      "tr_GR391": "Графика Intel®&nbsp;Arc™ A550M",
      "tr_GR392": "Графика Intel®&nbsp;Arc™ A570M",
      "tr_GR393": "Графика Intel® Arc™ A580",
      "tr_GR394": "Графика Intel®&nbsp;Arc™ A730M",
      "tr_GR395": "Графика Intel® Arc™ A750",
      "tr_GR396": "Графика Intel® Arc™ A770",
      "tr_GR397": "Графика Intel®&nbsp;Arc™ A770M",
      "tr_GR398": "Графика Intel® Arc™",
      "tr_GR399": "Графика Intel®&nbsp;Arc™&nbsp;Pro A30M",
      "tr_GR400": "Графика Intel® Arc™ Pro A40/A50",
      "tr_GR401": "Графика Intel® Arc™ Pro A60",
      "tr_GR402": "Графика Intel®&nbsp;Arc™&nbsp;Pro A60M",
      "tr_GR403": "Графика Intel®",
      "tr_GR404": "HD-графика Intel® 2000",
      "tr_GR405": "HD-графика Intel® 2500",
      "tr_GR406": "HD-графика Intel® 3000",
      "tr_GR407": "HD-графика Intel® 400",
      "tr_GR408": "HD-графика Intel® 4000",
      "tr_GR409": "HD-графика Intel® 405",
      "tr_GR410": "HD-графика Intel® 4200",
      "tr_GR411": "HD-графика Intel® 4400",
      "tr_GR412": "HD-графика Intel® 4600",
      "tr_GR413": "HD-графика Intel® 500",
      "tr_GR414": "HD-графика Intel® 5000",
      "tr_GR415": "HD-графика Intel® 505",
      "tr_GR416": "HD-графика Intel® 510",
      "tr_GR417": "HD-графика Intel® 515",
      "tr_GR418": "HD-графика Intel® 520",
      "tr_GR419": "HD-графика Intel® 530",
      "tr_GR420": "HD-графика Intel® 5300",
      "tr_GR421": "HD-графика Intel® 5500",
      "tr_GR422": "HD-графика Intel® 5600",
      "tr_GR423": "HD-графика Intel® 6000",
      "tr_GR424": "HD-графика Intel® 610",
      "tr_GR425": "HD-графика Intel® 615",
      "tr_GR426": "HD-графика Intel® 620",
      "tr_GR427": "HD-графика Intel® 630",
      "tr_GR428": "HD-графика Intel®",
      "tr_GR429": "Графика Intel® Iris® 5100",
      "tr_GR430": "Графика Intel® Iris® 540",
      "tr_GR431": "Графика Intel® Iris® 550",
      "tr_GR432": "Графика Intel® Iris® 6100",
      "tr_GR433": "Графика Intel® Iris® Plus 640",
      "tr_GR434": "Графика Intel® Iris® Plus 645",
      "tr_GR435": "Графика Intel® Iris® Plus 650",
      "tr_GR436": "Графика Intel® Iris® Plus 655",
      "tr_GR437": "Графика Intel® Iris® Plus",
      "tr_GR438": "Графика Intel® Iris® Pro 5200",
      "tr_GR439": "Графика Intel® Iris® Pro 580",
      "tr_GR440": "Графика Intel® Iris® Pro 6200",
      "tr_GR441": "Графика Intel® Iris® X<sup>e</sup>",
      "tr_GR442": "Графика Intel® Iris® X<sup>e</sup> MAX A220M",
      "tr_GR443": "Графика Intel® Iris® X<sup>e</sup> MAX",
      "tr_GR444": "Интегрированная графика Intel®",
      "tr_GR445": "UHD-графика Intel® 600",
      "tr_GR446": "UHD-графика Intel® 605",
      "tr_GR447": "UHD-графика Intel® 610",
      "tr_GR448": "UHD-графика Intel® 615",
      "tr_GR449": "UHD-графика Intel® 617",
      "tr_GR450": "UHD-графика Intel® 620",
      "tr_GR451": "UHD-графика Intel® 630",
      "tr_GR452": "UHD-графика Intel® 710",
      "tr_GR453": "UHD-графика Intel® 730",
      "tr_GR454": "UHD-графика Intel® 770",
      "tr_GR455": "UHD-графика Intel®",
      "tr_GR456": "UHD-графика Intel®",
      "tr_GR457": "UHD-графика Intel®",
      "tr_GR458": "NVIDIA* GeForce* MX110",
      "tr_GR459": "NVIDIA* GeForce* MX130",
      "tr_GR460": "NVIDIA* GeForce* MX150",
      "tr_GR461": "NVIDIA* GeForce* MX230",
      "tr_GR462": "NVIDIA* GeForce* MX250",
      "tr_GR463": "NVIDIA* GeForce* MX330",
      "tr_GR464": "NVIDIA* GeForce* MX350",
      "tr_GR465": "NVIDIA* GeForce* 410M",
      "tr_GR466": "NVIDIA* GeForce* MX450",
      "tr_GR467": "NVIDIA* GeForce* 510",
      "tr_GR468": "NVIDIA* GeForce* MX550",
      "tr_GR469": "NVIDIA* GeForce* MX570",
      "tr_GR470": "NVIDIA* GeForce* MX570 A",
      "tr_GR471": "NVIDIA* GeForce* 605",
      "tr_GR472": "NVIDIA* GeForce* 610",
      "tr_GR473": "NVIDIA* GeForce* 610M",
      "tr_GR474": "NVIDIA* GeForce* 615",
      "tr_GR475": "NVIDIA* GeForce* 620M",
      "tr_GR476": "NVIDIA* GeForce* 705A",
      "tr_GR477": "NVIDIA* GeForce* 705M",
      "tr_GR478": "NVIDIA* GeForce* 710A",
      "tr_GR479": "NVIDIA* GeForce* 710M",
      "tr_GR480": "NVIDIA* GeForce* 720A",
      "tr_GR481": "NVIDIA* GeForce* 720M",
      "tr_GR482": "NVIDIA* GeForce* 730A",
      "tr_GR483": "NVIDIA* GeForce* 800A",
      "tr_GR484": "NVIDIA* GeForce* 800M",
      "tr_GR485": "NVIDIA* GeForce* 805A",
      "tr_GR486": "NVIDIA* GeForce* 810A",
      "tr_GR487": "NVIDIA* GeForce* 810M",
      "tr_GR488": "NVIDIA* GeForce* 820A",
      "tr_GR489": "NVIDIA* GeForce* 820M",
      "tr_GR490": "NVIDIA* GeForce* 825M",
      "tr_GR491": "NVIDIA* GeForce* 830A",
      "tr_GR492": "NVIDIA* GeForce* 830M",
      "tr_GR493": "NVIDIA* GeForce* 840A",
      "tr_GR494": "NVIDIA* GeForce* 840M",
      "tr_GR495": "NVIDIA* GeForce* 845M",
      "tr_GR496": "NVIDIA* GeForce* 910M",
      "tr_GR497": "NVIDIA* GeForce* 920A",
      "tr_GR498": "NVIDIA* GeForce* 920M",
      "tr_GR499": "NVIDIA* GeForce* 920MX",
      "tr_GR500": "NVIDIA* GeForce* 930A",
      "tr_GR501": "NVIDIA* GeForce* 930M",
      "tr_GR502": "NVIDIA* GeForce* 930MX",
      "tr_GR503": "NVIDIA* GeForce* 940A",
      "tr_GR504": "NVIDIA* GeForce* 940M",
      "tr_GR505": "NVIDIA* GeForce* 940MX",
      "tr_GR506": "NVIDIA* GeForce* 945A",
      "tr_GR507": "NVIDIA* GeForce* 945M",
      "tr_GR508": "NVIDIA* GeForce* GT 1010",
      "tr_GR509": "NVIDIA* GeForce* GT 1030",
      "tr_GR510": "NVIDIA* GeForce* GT 415M",
      "tr_GR511": "NVIDIA* GeForce* GT 420",
      "tr_GR512": "NVIDIA* GeForce* GT 420M",
      "tr_GR513": "NVIDIA* GeForce* GT 425M",
      "tr_GR514": "NVIDIA* GeForce* GT 430",
      "tr_GR515": "NVIDIA* GeForce* GT 435M",
      "tr_GR516": "NVIDIA* GeForce* GT 440",
      "tr_GR517": "NVIDIA* GeForce* GT 445M",
      "tr_GR518": "NVIDIA* GeForce* GT 520",
      "tr_GR519": "NVIDIA* GeForce* GT 520M",
      "tr_GR520": "NVIDIA* GeForce* GT 520MX",
      "tr_GR521": "NVIDIA* GeForce* GT 525M",
      "tr_GR522": "NVIDIA* GeForce* GT 530",
      "tr_GR523": "NVIDIA* GeForce* GT 540M",
      "tr_GR524": "NVIDIA* GeForce* GT 545",
      "tr_GR525": "NVIDIA* GeForce* GT 550M",
      "tr_GR526": "NVIDIA* GeForce* GT 555M",
      "tr_GR527": "NVIDIA* GeForce* GT 610",
      "tr_GR528": "NVIDIA* GeForce* GT 620",
      "tr_GR529": "NVIDIA* GeForce* GT 620M",
      "tr_GR530": "NVIDIA* GeForce* GT 625",
      "tr_GR531": "NVIDIA* GeForce* GT 625M",
      "tr_GR532": "NVIDIA* GeForce* GT 630",
      "tr_GR533": "NVIDIA* GeForce* GT 630M",
      "tr_GR534": "NVIDIA* GeForce* GT 635",
      "tr_GR535": "NVIDIA* GeForce* GT 635M",
      "tr_GR536": "NVIDIA* GeForce* GT 640",
      "tr_GR537": "NVIDIA* GeForce* GT 640M",
      "tr_GR538": "NVIDIA* GeForce* GT 640M LE",
      "tr_GR539": "NVIDIA* GeForce* GT 645",
      "tr_GR540": "NVIDIA* GeForce* GT 645M",
      "tr_GR541": "NVIDIA* GeForce* GT 650M",
      "tr_GR542": "NVIDIA* GeForce* GT 705",
      "tr_GR543": "NVIDIA* GeForce* GT 710",
      "tr_GR544": "NVIDIA* GeForce* GT 710M",
      "tr_GR545": "NVIDIA* GeForce* GT 720",
      "tr_GR546": "NVIDIA* GeForce* GT 720A",
      "tr_GR547": "NVIDIA* GeForce* GT 720M",
      "tr_GR548": "NVIDIA* GeForce* GT 730",
      "tr_GR549": "NVIDIA* GeForce* GT 730M",
      "tr_GR550": "NVIDIA* GeForce* GT 735M",
      "tr_GR551": "NVIDIA* GeForce* GT 740",
      "tr_GR552": "NVIDIA* GeForce* GT 740A",
      "tr_GR553": "NVIDIA* GeForce* GT 740M",
      "tr_GR554": "NVIDIA* GeForce* GT 745A",
      "tr_GR555": "NVIDIA* GeForce* GT 745M",
      "tr_GR556": "NVIDIA* GeForce* GT 750M",
      "tr_GR557": "NVIDIA* GeForce* GT 755M",
      "tr_GR558": "NVIDIA* GeForce* GT 820M",
      "tr_GR559": "NVIDIA* GeForce* GTS 450",
      "tr_GR560": "NVIDIA* GeForce* GTX 1050",
      "tr_GR561": "NVIDIA* GeForce* GTX 1050 Max-Q",
      "tr_GR562": "NVIDIA* GeForce* GTX 1050 Ti",
      "tr_GR563": "NVIDIA* GeForce* GTX 1050 Ti Max-Q",
      "tr_GR564": "NVIDIA* GeForce* GTX 1060",
      "tr_GR565": "NVIDIA* GeForce* GTX 1060 Max-Q",
      "tr_GR566": "NVIDIA* GeForce* GTX 1070",
      "tr_GR567": "NVIDIA* GeForce* GTX 1070 Max-Q",
      "tr_GR568": "NVIDIA* GeForce* GTX 1070 Ti",
      "tr_GR569": "NVIDIA* GeForce* GTX 1080",
      "tr_GR570": "NVIDIA* GeForce* GTX 1080 Max-Q",
      "tr_GR571": "NVIDIA* GeForce* GTX 1080 Ti",
      "tr_GR572": "NVIDIA* GeForce* GTX 1630",
      "tr_GR573": "NVIDIA* GeForce* GTX 1650",
      "tr_GR574": "NVIDIA* GeForce* GTX 1650 Max-Q",
      "tr_GR575": "NVIDIA* GeForce* GTX 1650 SUPER",
      "tr_GR576": "NVIDIA* GeForce* GTX 1650 Ti",
      "tr_GR577": "NVIDIA* GeForce* GTX 1650 Ti Max-Q",
      "tr_GR578": "NVIDIA* GeForce* GTX 1660",
      "tr_GR579": "NVIDIA* GeForce* GTX 1660 SUPER",
      "tr_GR580": "NVIDIA* GeForce* GTX 1660 Ti",
      "tr_GR581": "NVIDIA* GeForce* GTX 1660 Ti Max-Q",
      "tr_GR582": "NVIDIA* GeForce* GTX 460",
      "tr_GR583": "NVIDIA* GeForce* GTX 460 SE",
      "tr_GR584": "NVIDIA* GeForce* GTX 460 v2",
      "tr_GR585": "NVIDIA* GeForce* GTX 460M",
      "tr_GR586": "NVIDIA* GeForce* GTX 465",
      "tr_GR587": "NVIDIA* GeForce* GTX 470",
      "tr_GR588": "NVIDIA* GeForce* GTX 470M",
      "tr_GR589": "NVIDIA* GeForce* GTX 480",
      "tr_GR590": "NVIDIA* GeForce* GTX 480M",
      "tr_GR591": "NVIDIA* GeForce* GTX 485M",
      "tr_GR592": "NVIDIA* GeForce* GTX 550 Ti",
      "tr_GR593": "NVIDIA* GeForce* GTX 555",
      "tr_GR594": "NVIDIA* GeForce* GTX 560",
      "tr_GR595": "NVIDIA* GeForce* GTX 560 SE",
      "tr_GR596": "NVIDIA* GeForce* GTX 560 Ti",
      "tr_GR597": "NVIDIA* GeForce* GTX 560M",
      "tr_GR598": "NVIDIA* GeForce* GTX 570",
      "tr_GR599": "NVIDIA* GeForce* GTX 570M",
      "tr_GR600": "NVIDIA* GeForce* GTX 580",
      "tr_GR601": "NVIDIA* GeForce* GTX 580M",
      "tr_GR602": "NVIDIA* GeForce* GTX 590",
      "tr_GR603": "NVIDIA* GeForce* GTX 645",
      "tr_GR604": "NVIDIA* GeForce* GTX 650",
      "tr_GR605": "NVIDIA* GeForce* GTX 650 Ti",
      "tr_GR606": "NVIDIA* GeForce* GTX 660",
      "tr_GR607": "NVIDIA* GeForce* GTX 660 Ti",
      "tr_GR608": "NVIDIA* GeForce* GTX 660M",
      "tr_GR609": "NVIDIA* GeForce* GTX 670",
      "tr_GR610": "NVIDIA* GeForce* GTX 670M",
      "tr_GR611": "NVIDIA* GeForce* GTX 670MX",
      "tr_GR612": "NVIDIA* GeForce* GTX 675M",
      "tr_GR613": "NVIDIA* GeForce* GTX 675MX",
      "tr_GR614": "NVIDIA* GeForce* GTX 680",
      "tr_GR615": "NVIDIA* GeForce* GTX 680M",
      "tr_GR616": "NVIDIA* GeForce* GTX 680MX",
      "tr_GR617": "NVIDIA* GeForce* GTX 690",
      "tr_GR618": "NVIDIA* GeForce* GTX 745",
      "tr_GR619": "NVIDIA* GeForce* GTX 750",
      "tr_GR620": "NVIDIA* GeForce* GTX 750 Ti",
      "tr_GR621": "NVIDIA* GeForce* GTX 760",
      "tr_GR622": "NVIDIA* GeForce* GTX 760 Ti",
      "tr_GR623": "NVIDIA* GeForce* GTX 760A",
      "tr_GR624": "NVIDIA* GeForce* GTX 760M",
      "tr_GR625": "NVIDIA* GeForce* GTX 765M",
      "tr_GR626": "NVIDIA* GeForce* GTX 770",
      "tr_GR627": "NVIDIA* GeForce* GTX 770M",
      "tr_GR628": "NVIDIA* GeForce* GTX 775M",
      "tr_GR629": "NVIDIA* GeForce* GTX 780",
      "tr_GR630": "NVIDIA* GeForce* GTX 780 Ti",
      "tr_GR631": "NVIDIA* GeForce* GTX 780M",
      "tr_GR632": "NVIDIA* GeForce* GTX 850A",
      "tr_GR633": "NVIDIA* GeForce* GTX 850M",
      "tr_GR634": "NVIDIA* GeForce* GTX 860M",
      "tr_GR635": "NVIDIA* GeForce* GTX 870M",
      "tr_GR636": "NVIDIA* GeForce* GTX 880M",
      "tr_GR637": "NVIDIA* GeForce* GTX 950",
      "tr_GR638": "NVIDIA* GeForce* GTX 950A",
      "tr_GR639": "NVIDIA* GeForce* GTX 950M",
      "tr_GR640": "NVIDIA* GeForce* GTX 960",
      "tr_GR641": "NVIDIA* GeForce* GTX 960A",
      "tr_GR642": "NVIDIA* GeForce* GTX 960M",
      "tr_GR643": "NVIDIA* GeForce* GTX 965M",
      "tr_GR644": "NVIDIA* GeForce* GTX 970",
      "tr_GR645": "NVIDIA* GeForce* GTX 970M",
      "tr_GR646": "NVIDIA* GeForce* GTX 980",
      "tr_GR647": "NVIDIA* GeForce* GTX 980 Ti",
      "tr_GR648": "NVIDIA* GeForce* GTX 980M",
      "tr_GR649": "NVIDIA* GeForce* GTX TITAN",
      "tr_GR650": "NVIDIA* GeForce* GTX TITAN Black",
      "tr_GR651": "NVIDIA* GeForce* GTX TITAN X",
      "tr_GR652": "NVIDIA* GeForce* GTX TITAN Z",
      "tr_GR653": "NVIDIA* GeForce* RTX 2050",
      "tr_GR654": "NVIDIA* GeForce* RTX 2060",
      "tr_GR655": "NVIDIA* GeForce* RTX 2060 Max-Q",
      "tr_GR656": "NVIDIA* GeForce* RTX 2060 SUPER",
      "tr_GR657": "NVIDIA* GeForce* RTX 2070",
      "tr_GR658": "NVIDIA* GeForce* RTX 2070 Max-Q",
      "tr_GR659": "NVIDIA* GeForce* RTX 2070 SUPER",
      "tr_GR660": "NVIDIA* GeForce* RTX 2070 Super Max-Q",
      "tr_GR661": "NVIDIA* GeForce* RTX 2080",
      "tr_GR662": "NVIDIA* GeForce* RTX 2080 Max-Q",
      "tr_GR663": "NVIDIA* GeForce* RTX 2080 SUPER",
      "tr_GR664": "NVIDIA* GeForce* RTX 2080 Super Max-Q",
      "tr_GR665": "NVIDIA* GeForce* RTX 2080 Ti",
      "tr_GR666": "NVIDIA* GeForce* RTX 3050",
      "tr_GR667": "NVIDIA* GeForce* RTX 3050 Ti",
      "tr_GR668": "NVIDIA* GeForce* RTX 3060",
      "tr_GR669": "NVIDIA* GeForce* RTX 3060 Ti",
      "tr_GR670": "NVIDIA* GeForce* RTX 3070",
      "tr_GR671": "NVIDIA* GeForce* RTX 3070 Ti",
      "tr_GR672": "NVIDIA* GeForce* RTX 3080",
      "tr_GR673": "NVIDIA* GeForce* RTX 3080 Ti",
      "tr_GR674": "NVIDIA* GeForce* RTX 3090",
      "tr_GR675": "NVIDIA* GeForce* RTX 3090 Ti",
      "tr_GR676": "NVIDIA* GeForce* RTX 4050",
      "tr_GR677": "NVIDIA* GeForce* RTX 4060",
      "tr_GR678": "NVIDIA* GeForce* RTX 4060 Ti",
      "tr_GR679": "NVIDIA* GeForce* RTX 4070",
      "tr_GR680": "NVIDIA* GeForce* RTX 4070 SUPER",
      "tr_GR681": "NVIDIA* GeForce* RTX 4070 Ti",
      "tr_GR682": "NVIDIA* GeForce* RTX 4070 Ti SUPER",
      "tr_GR683": "NVIDIA* GeForce* RTX 4080",
      "tr_GR684": "NVIDIA* GeForce* RTX 4090",
      "tr_GR685": "NVIDIA* GeForce* RTX 4090 D",
      "tr_GR686": "NVIDIA* NVS* 310",
      "tr_GR687": "NVIDIA* NVS* 315",
      "tr_GR688": "NVIDIA* NVS* 4200M",
      "tr_GR689": "NVIDIA* NVS* 510",
      "tr_GR690": "NVIDIA* NVS* 5200M",
      "tr_GR691": "NVIDIA* NVS* 5400M",
      "tr_GR692": "NVIDIA* NVS* 810",
      "tr_GR693": "NVIDIA* Quadro* 410",
      "tr_GR694": "NVIDIA* Quadro* GP100",
      "tr_GR695": "NVIDIA* Quadro* GV100",
      "tr_GR696": "NVIDIA* Quadro* K1000M",
      "tr_GR697": "NVIDIA* Quadro* K1100M",
      "tr_GR698": "NVIDIA* Quadro* K1200",
      "tr_GR699": "NVIDIA* Quadro* K2000",
      "tr_GR700": "NVIDIA* Quadro* K2000D",
      "tr_GR701": "NVIDIA* Quadro* K2000M",
      "tr_GR702": "NVIDIA* Quadro* K2100M",
      "tr_GR703": "NVIDIA* Quadro* K2200",
      "tr_GR704": "NVIDIA* Quadro* K2200M",
      "tr_GR705": "NVIDIA* Quadro* K3000M",
      "tr_GR706": "NVIDIA* Quadro* K3100M",
      "tr_GR707": "NVIDIA* Quadro* K4000",
      "tr_GR708": "NVIDIA* Quadro* K4000M",
      "tr_GR709": "NVIDIA* Quadro* K4100M",
      "tr_GR710": "NVIDIA* Quadro* K420",
      "tr_GR711": "NVIDIA* Quadro* K4200",
      "tr_GR712": "NVIDIA* Quadro* K5000",
      "tr_GR713": "NVIDIA* Quadro* K5000M",
      "tr_GR714": "NVIDIA* Quadro* K500M",
      "tr_GR715": "NVIDIA* Quadro* K5100M",
      "tr_GR716": "NVIDIA* Quadro* K510M",
      "tr_GR717": "NVIDIA* Quadro* K5200",
      "tr_GR718": "NVIDIA* Quadro* K600",
      "tr_GR719": "NVIDIA* Quadro* K6000",
      "tr_GR720": "NVIDIA* Quadro* K610M",
      "tr_GR721": "NVIDIA* Quadro* K620",
      "tr_GR722": "NVIDIA* Quadro* K620M",
      "tr_GR723": "NVIDIA* Quadro* M1000M",
      "tr_GR724": "NVIDIA* Quadro* M1200",
      "tr_GR725": "NVIDIA* Quadro* M2000",
      "tr_GR726": "NVIDIA* Quadro* M2000M",
      "tr_GR727": "NVIDIA* Quadro* M2200",
      "tr_GR728": "NVIDIA* Quadro* M3000M",
      "tr_GR729": "NVIDIA* Quadro* M4000",
      "tr_GR730": "NVIDIA* Quadro* M4000M",
      "tr_GR731": "NVIDIA* Quadro* M5000",
      "tr_GR732": "NVIDIA* Quadro* M5000M",
      "tr_GR733": "NVIDIA* Quadro* M500M",
      "tr_GR734": "NVIDIA* Quadro* M520",
      "tr_GR735": "NVIDIA* Quadro* M5500",
      "tr_GR736": "NVIDIA* Quadro* M6000",
      "tr_GR737": "NVIDIA* Quadro* M600M",
      "tr_GR738": "NVIDIA* Quadro* M620",
      "tr_GR739": "NVIDIA* Quadro* P1000",
      "tr_GR740": "NVIDIA* Quadro* P2000",
      "tr_GR741": "NVIDIA* Quadro* P2000 Max-Q",
      "tr_GR742": "NVIDIA* Quadro* P2200",
      "tr_GR743": "NVIDIA* Quadro* P3000",
      "tr_GR744": "NVIDIA* Quadro* P3200",
      "tr_GR745": "NVIDIA* Quadro* P3200 Max-Q",
      "tr_GR746": "NVIDIA* Quadro* P400",
      "tr_GR747": "NVIDIA* Quadro* P4000",
      "tr_GR748": "NVIDIA* Quadro* P4000 Max-Q",
      "tr_GR749": "NVIDIA* Quadro* P4200",
      "tr_GR750": "NVIDIA* Quadro* P4200 Max-Q",
      "tr_GR751": "NVIDIA* Quadro* P500",
      "tr_GR752": "NVIDIA* Quadro* P5000",
      "tr_GR753": "NVIDIA* Quadro* P520",
      "tr_GR754": "NVIDIA* Quadro* P5200",
      "tr_GR755": "NVIDIA* Quadro* P5200 Max-Q",
      "tr_GR756": "NVIDIA* Quadro* P600",
      "tr_GR757": "NVIDIA* Quadro* P6000",
      "tr_GR758": "NVIDIA* Quadro* P620",
      "tr_GR759": "NVIDIA* Quadro* RTX 3000",
      "tr_GR760": "NVIDIA* Quadro* RTX 3000 Max-Q",
      "tr_GR761": "NVIDIA* Quadro* RTX 4000",
      "tr_GR762": "NVIDIA* Quadro* RTX 4000 Max-Q",
      "tr_GR763": "NVIDIA* Quadro* RTX 5000",
      "tr_GR764": "NVIDIA* Quadro* RTX 5000 Max-Q",
      "tr_GR765": "NVIDIA* Quadro* RTX 6000",
      "tr_GR766": "NVIDIA* Quadro* RTX 8000",
      "tr_GR767": "NVIDIA* Quadro* T1000",
      "tr_GR768": "NVIDIA* Quadro* T1000 Max-Q",
      "tr_GR769": "NVIDIA* Quadro* T2000",
      "tr_GR770": "NVIDIA* Quadro* T2000 Max-Q",
      "tr_GR771": "NVIDIA* T500",
      "tr_GR772": "NVIDIA* RTX 2000 Ada Generation",
      "tr_GR773": "NVIDIA* RTX 3000 Ada Generation",
      "tr_GR774": "NVIDIA* RTX 3500 Ada Generation",
      "tr_GR775": "NVIDIA* RTX 4000 Ada Generation",
      "tr_GR776": "NVIDIA* RTX 4000 SFF Ada Generation",
      "tr_GR777": "NVIDIA* RTX 4500 Ada Generation",
      "tr_GR778": "NVIDIA* RTX 5000 Ada Generation",
      "tr_GR779": "NVIDIA* RTX 5880 Ada Generation",
      "tr_GR780": "NVIDIA* Tesla* C2050 / C2070",
      "tr_GR781": "NVIDIA* Tesla* C2070",
      "tr_GR782": "NVIDIA* Tesla* C2075",
      "tr_GR783": "NVIDIA* Tesla* K10",
      "tr_GR784": "NVIDIA* Tesla* K20c",
      "tr_GR785": "NVIDIA* Tesla* K20m",
      "tr_GR786": "NVIDIA* Tesla* K20s",
      "tr_GR787": "NVIDIA* Tesla* K20Xm",
      "tr_GR788": "NVIDIA* Tesla* K40c",
      "tr_GR789": "NVIDIA* Tesla* K40m",
      "tr_GR790": "NVIDIA* Tesla* K40s",
      "tr_GR791": "NVIDIA* Tesla* K40st",
      "tr_GR792": "NVIDIA* Tesla* K40t",
      "tr_GR793": "NVIDIA* Tesla* K8",
      "tr_GR794": "NVIDIA* Tesla* K80",
      "tr_GR795": "NVIDIA* Tesla* M2050",
      "tr_GR796": "NVIDIA* Tesla* M2070",
      "tr_GR797": "NVIDIA* Tesla* M2070-Q",
      "tr_GR798": "NVIDIA* Tesla* M2075",
      "tr_GR799": "NVIDIA* Tesla* M2090",
      "tr_GR800": "NVIDIA* Tesla* S2050",
      "tr_GR801": "NVIDIA* Tesla* T20",
      "tr_GR802": "NVIDIA* Tesla* T4",
      "tr_GR803": "NVIDIA* Tesla* X2070",
      "tr_GR804": "NVIDIA* Tesla* X2090",
      "tr_GR805": "NVIDIA* TITAN RTX",
      "tr_GR806": "NVIDIA* TITAN V",
      "tr_GR807": "NVIDIA* TITAN X",
      "tr_GR808": "NVIDIA* TITAN Xp",
      "tr_GR809": "NVIDIA* GeForce* RTX 4080 SUPER",
      "tr_GR810": "NVIDIA* RTX 500 Ada Generation",
      "tr_GR811": "NVIDIA* RTX 1000 Ada Generation",
      "tr_GR812": "Графика Intel® Arc™",
      "tr_GR813": "NVIDIA* GeForce* RTX 3050 A",
      "tr_GR814": "NVIDIA RTX* 2000E Ada Generation",
      "tr_GR815": "AMD Radeon* Pro W7900 с двумя разъемами",
      "tr_GR816": "AMD Radeon* RX 7800M",
      "tr_GR817": "Графика Intel® Arc™ B570",
      "tr_GR818": "Графика Intel® Arc™ B580",
      "tr_GR819": "Графика Intel® Arc™ A310E",
      "tr_GR820": "Графика Intel® Arc™ A350E",
      "tr_GR821": "Графика Intel® Arc™ A370E",
      "tr_GR822": "Графика Intel® Arc™ A380E",
      "tr_GR823": "Графика Intel® Arc™ A580E",
      "tr_GR824": "Графика Intel® Arc™ A750E",
      "tr_GR825": "Графика Intel® Iris® X<sup>e</sup> MAX 101",
      "tr_GR826": "Графика Intel® UHD 750",
      "tr_GR827": "NVIDIA* GeForce* RTX 5080",
      "tr_GR828": "NVIDIA* GeForce* RTX 5090",
      "tr_GR829": "NVIDIA* GeForce* RTX 5090 D",
      "tr_GR830": "AMD Radeon* RX 7650 GRE",
      "tr_GR831": "AMD Radeon* RX 9070",
      "tr_GR832": "AMD Radeon* RX 9070 XT",
      "tr_GR833": "NVIDIA* GeForce* RTX 5070",
      "tr_GR834": "NVIDIA* GeForce* RTX 5070 Ti",
      "tr_GR835": "Графика Intel® Arc™ B390"
    },
    "tr_ProcessorDescriptionMapping": {
      "tr_Proc1": "Процессор Intel® Core™ Ultra 5, серия 225",
      "tr_Proc2": "Процессор Intel® Core™ Ultra 5 225F",
      "tr_Proc3": "Процессор Intel® Core™ Ultra 5 225H",
      "tr_Proc4": "Процессор Intel® Core™ Ultra 5 225T",
      "tr_Proc5": "Процессор Intel® Core™ Ultra 5 225U",
      "tr_Proc6": "Процессор Intel® Core™ Ultra 5, серия 235",
      "tr_Proc7": "Процессор Intel® Core™ Ultra 5 235H",
      "tr_Proc8": "Процессор Intel® Core™ Ultra 5 235HX",
      "tr_Proc9": "Процессор Intel® Core™ Ultra 5 235T",
      "tr_Proc10": "Процессор Intel® Core™ Ultra 5 235U",
      "tr_Proc11": "Процессор Intel® Core™ Ultra 5, серия 245",
      "tr_Proc12": "Процессор Intel® Core™ Ultra 5 245HX",
      "tr_Proc13": "Процессор Intel® Core™ Ultra 5 245T",
      "tr_Proc14": "Процессор Intel® Core™ Ultra 7 255H",
      "tr_Proc15": "Процессор Intel® Core™ Ultra 7 255HX",
      "tr_Proc16": "Процессор Intel® Core™ Ultra 7 255U",
      "tr_Proc17": "Процессор Intel® Core™ Ultra 7, серия 265",
      "tr_Proc18": "Процессор Intel® Core™ Ultra 7 265F",
      "tr_Proc19": "Процессор Intel® Core™ Ultra 7 265H",
      "tr_Proc20": "Процессор Intel® Core™ Ultra 7 265HX",
      "tr_Proc21": "Процессор Intel® Core™ Ultra 7 265T",
      "tr_Proc22": "Процессор Intel® Core™ Ultra 7 265U",
      "tr_Proc23": "Процессор Intel® Core™ Ultra 9 275HX",
      "tr_Proc24": "Процессор Intel® Core™ Ultra 9, серия 285",
      "tr_Proc25": "Процессор Intel® Core™ Ultra 9 285H",
      "tr_Proc26": "Процессор Intel® Core™ Ultra 9 285HX",
      "tr_Proc27": "Процессор Intel® Core™ Ultra 9 285T",
      "tr_Proc28": "Процессор Intel® Core™ Ultra 5 245K",
      "tr_Proc29": "Процессор Intel® Core™ Ultra 5 245KF",
      "tr_Proc30": "Процессор Intel® Core™ Ultra 7 265K",
      "tr_Proc31": "Процессор Intel® Core™ Ultra 7 265KF",
      "tr_Proc32": "Процессор Intel® Core™ Ultra 9 285K",
      "tr_Proc33": "Процессор Intel® Core™ Ultra 5 226V",
      "tr_Proc34": "Процессор Intel® Core™ Ultra 5 228V",
      "tr_Proc35": "Процессор Intel® Core™ Ultra 5 236V",
      "tr_Proc36": "Процессор Intel® Core™ Ultra 5 238V",
      "tr_Proc37": "Процессор Intel® Core™ Ultra 7 256V",
      "tr_Proc38": "Процессор Intel® Core™ Ultra 7 258V",
      "tr_Proc39": "Процессор Intel® Core™ Ultra 7 266V",
      "tr_Proc40": "Процессор Intel® Core™ Ultra 7 268V",
      "tr_Proc41": "Процессор Intel® Core™ Ultra 9 288V",
      "tr_Proc42": "Процессор Intel® Core™ Ultra 7 105UL",
      "tr_Proc43": "Процессор Intel® Core™ Ultra 5 125HL",
      "tr_Proc44": "Процессор Intel® Core™ Ultra 5 125UL",
      "tr_Proc45": "Процессор Intel® Core™ Ultra 5 135HL",
      "tr_Proc46": "Процессор Intel® Core™ Ultra 5 135UL",
      "tr_Proc47": "Процессор Intel® Core™ Ultra 7 155HL",
      "tr_Proc48": "Процессор Intel® Core™ Ultra 7 155UL",
      "tr_Proc49": "Процессор Intel® Core™ Ultra 7 165HL",
      "tr_Proc50": "Процессор Intel® Core™ Ultra 7 165UL",
      "tr_Proc51": "Процессор Intel® Core™ Ultra 5 125H",
      "tr_Proc52": "Процессор Intel® Core™ Ultra 5 125U",
      "tr_Proc53": "Процессор Intel® Core™ Ultra 5 134U",
      "tr_Proc54": "Процессор Intel® Core™ Ultra 5 135H",
      "tr_Proc55": "Процессор Intel® Core™ Ultra 5 135U",
      "tr_Proc56": "Процессор Intel® Core™ Ultra 7 155H",
      "tr_Proc57": "Процессор Intel® Core™ Ultra 7 155U",
      "tr_Proc58": "Процессор Intel® Core™ Ultra 7 164U",
      "tr_Proc59": "Процессор Intel® Core™ Ultra 7 165H",
      "tr_Proc60": "Процессор Intel® Core™ Ultra 7 165U",
      "tr_Proc61": "Процессор Intel® Core™ Ultra 9 185H",
      "tr_Proc62": "Процессор Intel® Core™ Ultra 5 250K",
      "tr_Proc63": "Процессор Intel® Core™ Ultra 5 250KF",
      "tr_Proc64": "Процессор Intel® Core™ Ultra 7 270K",
      "tr_Proc65": "Процессор Intel® Core™ Ultra 9 290K",
      "tr_Proc66": "Процессор Intel® Core™ Ultra 5 322",
      "tr_Proc67": "Процессор Intel® Core™ Ultra 5 325",
      "tr_Proc68": "Процессор Intel® Core™ Ultra 5 332",
      "tr_Proc69": "Процессор Intel® Core™ Ultra 5 335",
      "tr_Proc70": "Процессор Intel® Core™ Ultra 5 336H",
      "tr_Proc71": "Процессор Intel® Core™ Ultra 5 338H",
      "tr_Proc72": "Процессор Intel® Core™ Ultra 7 355",
      "tr_Proc73": "Процессор Intel® Core™ Ultra 7 356H",
      "tr_Proc74": "Процессор Intel® Core™ Ultra 7 365",
      "tr_Proc75": "Процессор Intel® Core™ Ultra 7 366H",
      "tr_Proc76": "Процессор Intel® Core™ Ultra 9 386H",
      "tr_Proc77": "Процессор Intel® Core™ Ultra X7 358H",
      "tr_Proc78": "Процессор Intel® Core™ Ultra X7 368H",
      "tr_Proc79": "Процессор Intel® Core™ Ultra X9 388H"
    },
    "tr_WifiDescMapping": {
      "tr_Wifi1": "Intel® Centrino® Advanced-N 6200 ABG",
      "tr_Wifi2": "Intel® Centrino® Advanced-N 6200 AGN",
      "tr_Wifi3": "Intel® Centrino® Advanced-N 6200 BG",
      "tr_Wifi4": "Intel® Centrino® Advanced-N 6205",
      "tr_Wifi5": "Intel® Centrino® Advanced-N 6230",
      "tr_Wifi6": "Intel® Centrino® Advanced-N 6235",
      "tr_Wifi7": "Intel® Centrino® Advanced-N 6250 ABG",
      "tr_Wifi8": "Intel® Centrino® Advanced-N 6250 AGN",
      "tr_Wifi9": "Intel® Centrino® Ultimate-N 6300 AGN",
      "tr_Wifi10": "Intel® Centrino® Wireless-N 100",
      "tr_Wifi11": "Intel® Centrino® Wireless-N 1000",
      "tr_Wifi12": "Intel® Centrino® Wireless-N 1030",
      "tr_Wifi13": "Intel® Centrino® Wireless-N 105",
      "tr_Wifi14": "Intel® Centrino® Wireless-N 135",
      "tr_Wifi15": "Intel® Centrino® Wireless-N 2200",
      "tr_Wifi16": "Intel® Centrino® Wireless-N 2230",
      "tr_Wifi17": "Intel® Centrino® Wireless-N WiMAX 6150",
      "tr_Wifi18": "Intel® Dual Band Wireless-AC 3160",
      "tr_Wifi19": "Intel® Dual Band Wireless-AC 3165",
      "tr_Wifi20": "Intel® Dual Band Wireless-AC 7260",
      "tr_Wifi21": "Intel® Dual Band Wireless-AC 7265",
      "tr_Wifi22": "Intel® Dual Band Wireless-N 3160",
      "tr_Wifi23": "Intel® Dual Band Wireless-N 7260",
      "tr_Wifi24": "Intel® Dual Band Wireless-N 7265",
      "tr_Wifi25": "Intel® Tri-Band Wireless-AC 17261",
      "tr_Wifi26": "Intel® Wi-Fi 6 AX101",
      "tr_Wifi27": "Intel® Wi-Fi 6 AX200",
      "tr_Wifi28": "Intel® Wi-Fi 6 AX201",
      "tr_Wifi29": "Intel® Wi-Fi 6 AX203",
      "tr_Wifi30": "Intel® Wi-Fi 6E AX210",
      "tr_Wifi31": "Intel® Wi-Fi 6E AX211",
      "tr_Wifi32": "Intel® Wi-Fi 6E AX411",
      "tr_Wifi33": "Intel® Wi-Fi 7 BE200",
      "tr_Wifi34": "Intel® Wi-Fi 7 BE202",
      "tr_Wifi35": "Intel® Wireless-AC 3165",
      "tr_Wifi36": "Intel® Wireless-AC 3168",
      "tr_Wifi37": "Intel® Wireless-AC 8265",
      "tr_Wifi38": "Intel® Wireless-AC 9260",
      "tr_Wifi39": "Intel® Wireless-AC 9461",
      "tr_Wifi40": "Intel® Wireless-AC 9462",
      "tr_Wifi41": "Intel® Wireless-AC 9560",
      "tr_Wifi42": "Intel® Wireless-N 3160",
      "tr_Wifi43": "Intel® Wireless-N 7260",
      "tr_Wifi44": "Intel® Wireless-N 7265",
      "tr_Wifi45": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi46": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi47": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi48": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi49": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi50": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi51": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi52": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi53": "Intel® Killer™ Wi-Fi 6E AX1690",
      "tr_Wifi54": "Intel® Killer™ Wi-Fi 7 BE1750",
      "tr_Wifi55": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi56": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi57": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi58": "Intel® Wi-Fi 7 BE201",
      "tr_Wifi59": "Intel® Killer™ Wi-Fi 7 BE1750",
      "tr_Wifi60": "Intel® Killer™ Wi-Fi 7 BE1750"
    },
    "tr_textBuyNow": "Купить сейчас ",
    "tr_textTryagain": "Повторить попытку",
    "tr_textBuynowErr": "В связи с прерыванием соединения опция «Купить сейчас» недоступна",
    "tr_chatbotPlaceholder_text": "Спросите что-нибудь об устройстве",
    "tr_chatbotPlaceholder_gaming_text": "Задайте любой вопрос об устройстве с помощью ИИ",
    "tr_deviceSpecs_text": "Характеристики устройства",
    "tr_laptop": "Ноутбук",
    "tr_desktop": "Настольный ПК",
    "tr_back": "Назад",
    "tr_HomePageNavigation": {
      "tr_overview": "Обзор",
      "tr_specs": "Технические характеристики",
      "tr_virtualAssistant": "Виртуальный помощник",
      "tr_promos": "Промоакции",
      "tr_compareDevices": "Сравнение устройств"
    },
    "tr_compareText": "Сравнить это устройство",
    "tr_PTLHomePageText": "Ваш следующий важный шаг начинается здесь",
    "tr_PTL12XEHomePageText": "Ультратонкий и производительный",
    "tr_OnboardingText": {
      "tr_welcome": "Добро пожаловать",
      "tr_start_text": "С чего бы вы хотели начать?",
      "tr_tabs": [
        {
          "tr_tab_heading": "Обзор",
          "tr_tab_subheading": "Узнайте, на что способно это устройство."
        },
        {
          "tr_tab_heading": "Технические характеристики",
          "tr_tab_subheading": "Изучите функции и оборудование."
        },
        {
          "tr_tab_heading": "Сезонные предложения и акции",
          "tr_tab_subheading": "Найдите актуальные предложения."
        },
        {
          "tr_tab_heading": "Сравнение",
          "tr_tab_subheading": "Сравните устройства между собой."
        },
        {
          "tr_tab_heading": "Виртуальный помощник",
          "tr_tab_subheading": "Получить ответы с помощью ИИ."
        }
      ],
      "ptl_right_arrow_icon": "assets/images/ptl_right_chevron.svg",
      "ptl_12xe_right_arrow_icon": "assets/images/ptl_12xe_right_chevron.svg",
      "ptl_intel_logo": "assets/images/ptl_intel_logo.svg",
      "ptl_12xe_intel_logo": "assets/images/ptl_12xe_intel_logo.svg"
    },
    "tr_VAHomepageText": {
      "tr_VAHeading": "Добро пожаловать!",
      "tr_VASubHeading": "Начать чат с ИИ-помощником",
      "tr_VAInputboxQuestion": "Спросите меня об этом устройстве",
      "ptl_VASearchSendIcon": "assets/images/ptl_va_search_send.png",
      "ptl12xe_VASearchSendIcon": "assets/images/ptl12xe_va_search_send.png",
      "ptl_homePage_icon": "assets/images/ptl_homepage_icon.gif",
      "ptl_12xe_homePage_icon": "assets/images/ptl12xe_homepage_icon.gif"
    }
  },
  "backgroundMedia": [
    {
      "uiType": "S11",
      "backgroundURL": "url(../assets/images/11th_gen_background.png)"
    },
    {
      "uiType": "G11",
      "backgroundURL": "url(../assets/images/gaming_background.png)"
    },
    {
      "uiType": "evo",
      "backgroundURL": "url(../assets/images/evo_background.png)"
    },
    {
      "uiType": "athena",
      "backgroundURL": "url(../assets/images/mobile-tiles-athena-background.jpg)"
    },
    {
      "uiType": "NI",
      "backgroundURL": "url(../assets/images/ni_background.png)"
    },
    {
      "uiType": "S10",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S8_9",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S7",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "G12",
      "backgroundURL": "url(../assets/images/12th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "default",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S12",
      "backgroundURL": "url(../assets/images/12th_gen_bg.svg)"
    },
    {
      "uiType": "G13",
      "backgroundURL": "url(../assets/images/13th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "INTEL_INSIDE",
      "backgroundURL": "url(../assets/images/intel_inside/intel_inside_bg.png)"
    },
    {
      "uiType": "G14",
      "backgroundURL": "url(../assets/images/13th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "S14_AI_IPOS",
      "backgroundURL": "url(../assets/images/standard/std_mtl_background.svg)"
    },
    {
      "uiType": "EVO_AI_IPOS",
      "backgroundURL": "url(../assets/images/evo/evo_mtl_background.svg)"
    },
    {
      "uiType": "GAMING_AI_IPOS",
      "backgroundURL": "url(../assets/images/gaming_ai_ipos_background.svg)"
    }
  ],
  "hybridDetails": [
    {
      "badgeTitle": "I3_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I3_HYBRID.svg",
      "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i3 с&nbsp;технологией Intel® Hybrid"
    },
    {
      "badgeTitle": "I5_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I5_HYBRID.svg",
      "tr_gen_core_title": "Процессор Intel®&nbsp;Core™&nbsp;i5 с&nbsp;технологией Intel® Hybrid"
    },
    {
      "badgeTitle": "I7_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I7_HYBRID.svg"
    }
  ],
  "tiles": [
    {
      "tilesType": "GAMING",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Мстители Marvel",
              "tileUrlName": "avengers",
              "tileBadgeUrl": "assets/images/gaming/avengers-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "Получайте максимальное удовольствие от игр с технологиями Intel®",
                "tr_subtitle": "Погрузитесь в мир «Мстителей Marvel»* с внутриигровой оптимизацией на базе технологий Intel®.",
                "videoUrl": "assets/lang/[XX]/gaming/videos/avengers_[XX].mp4",
                "videoPosterUrl": "assets/images/gaming/avengers-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "Посетите Intel® Extreme Masters",
              "tileUrlName": "esl",
              "tileBadgeUrl": "assets/images/gaming/esl-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "Где соревнуются лучшие в мире геймеры",
                "tr_subtitle": "Intel® Extreme Masters, самая продолжительная серия мероприятий в истории видеоигр, задает стандарты киберспорта.",
                "videoUrl": "assets/videos/gaming/esl_video.mp4",
                "videoPosterUrl": "assets/images/gaming/esl-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "Играйте, как профессионал",
              "tileUrlName": "influencer",
              "tileBadgeUrl": "assets/images/gaming/influencer-tile-new-content.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "Чемпионами становятся с Intel.",
                "tr_subtitle": "После победы в чемпионате американской лиги по Rainbow Six Siege* в 2021&nbsp;году члены команды Soniqs размышляют о своей игровой истории, будущем киберспорта и сотрудничестве с корпорацией Intel.",
                "tr_pretitle": "Представляем команду Soniqs",
                "videoUrl": "assets/videos/gaming/influencer-new-video.mp4",
                "videoPosterUrl": "assets/images/gaming/influencer-new-vdo-thumbnail.svg",
                "subtitleUrl": "assets/subtitles/gaming/intel_soniq_influencer/Intel_Soniq_Influencer_022822.[XX].vtt"
              }
            },
            {
              "tr_tileTitle": "Поддержка виртуальной реальности",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "Погружение в виртуальную реальность",
                "tr_subtitle": "Самое удивительное и реалистичное погружение в виртуальную реальность на компьютере. Благодаря новейшим процессорам Intel® Core™ вы можете быть кем угодно, перемещаться куда угодно и играть в другом измерении.",
                "videoUrl": "assets/videos/gaming/vr_video.mp4",
                "videoPosterUrl": "assets/images/gaming/vr-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "Xbox* Game Pass Ultimate",
              "tileUrlName": "xboxcontent",
              "tileBadgeUrl": "assets/images/gaming/xboxTile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "xbox-content-tile-panel",
                "tr_title": "Xbox* Game Pass Ultimate",
                "tr_subtitle": "Играйте в более чем 100 высококачественных консольных игр, таких как Sea of Thieves* и Psychonauts* 2, на ПК с Windows*, мобильном телефоне и планшете с подпиской Xbox* Game Pass Ultimate и совместимым контроллером.",
                "titleArray": [
                  {
                    "tr_title": "Играйте вместе на всех устройствах",
                    "tr_subtitle": "Присоединяйтесь к сообществу Xbox* с миллионами игроков, готовых к совместной игре. Подключайтесь и играйте с другими пользователями, используя общую библиотеку игр, независимо от того, где они находятся."
                  },
                  {
                    "tr_title": "Игры для пк под управлением Windows*",
                    "tr_subtitle": "Играйте в консольные игры из облака, используя приложение Xbox* для Windows* и совместимый контроллер."
                  },
                  {
                    "tr_title": "Выбирайте и играйте",
                    "tr_subtitle": "Наслаждайтесь великолепными играми для Xbox*, где бы вы ни были. Играйте в более чем 100 игр на своем ПК, мобильном телефоне или планшете, из любого места — из дома, когда телевизор занят, из кафе или другого места, где есть высокоскоростное подключение к Интернету."
                  },
                  {
                    "tr_title": "Развлечения без контроллера",
                    "tr_subtitle": "Игры с сенсорным управлением Xbox* открывают новые способы участия, обеспечивая привычные возможности и уровень игры, к которому вы привыкли с физическим контроллером."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD",
      "tilesDeviceTypes": [
        {
          "deviceType": "MTL_STD_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "Новости",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/standard/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Более 100 возможностей ИИ ",
                    "preTitle": "",
                    "detailPageName": "aiexperience",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_experience-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_experience.mp4"
                  },
                  {
                    "tr_title": "Больше контролируйте, меньше касайтесь",
                    "preTitle": "",
                    "detailPageName": "controlmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/controlmore-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/controlmore.mp4"
                  },
                  {
                    "tr_title": "Оставайтесь в кадре в любой среде",
                    "preTitle": "",
                    "detailPageName": "stayinframe",
                    "tileBadgeUrl": "assets/images/standard/redesign/stayinframe-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/stayinframe.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Творчество",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/standard/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Корректируйте освещение как профессионал",
                    "preTitle": "",
                    "detailPageName": "lighting",
                    "tileBadgeUrl": "assets/images/standard/redesign/lighting-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/lighting.mp4"
                  },
                  {
                    "tr_title": "С легкостью добавляйте необычные эффекты",
                    "preTitle": "",
                    "detailPageName": "effects",
                    "tileBadgeUrl": "assets/images/standard/redesign/effects-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/effects.mp4"
                  },
                  {
                    "tr_title": "Делайте ремикс песен с помощью ИИ",
                    "preTitle": "",
                    "detailPageName": "remix",
                    "tileBadgeUrl": "assets/images/standard/redesign/remix-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/remix.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивность",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Повысьте эффективность работы и конфиденциальность",
                    "preTitle": "",
                    "detailPageName": "boostyourproductivity",
                    "tileBadgeUrl": "assets/images/standard/redesign/boost-your-productivity-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/boost-your-productivity.mp4"
                  },
                  {
                    "tr_title": "Больше времени без розетки",
                    "preTitle": "",
                    "detailPageName": "spentmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spentmore-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/spentmore.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Развлечения",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Плавный стриминг даже без подключения к сети питания",
                    "preTitle": "",
                    "detailPageName": "smoothstreaming",
                    "tileBadgeUrl": "assets/images/standard/redesign/smooth-streaming-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/smooth-streaming.mp4"
                  },
                  {
                    "tr_title": "Быстро загружающиеся и захватывающие игры",
                    "preTitle": "",
                    "detailPageName": "fastimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastimmersive-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastimmersive.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "MTL_STD_REDESIGN_ULTRA_7_9",
          "tilesDetails": [
            {
              "tr_tileTitle": "Новости",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/standard/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Более 100 возможностей ИИ ",
                    "preTitle": "",
                    "detailPageName": "aiexperience",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_experience-tile7.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_experience7.mp4"
                  },
                  {
                    "tr_title": "Сделайте свои любимые песни по-настоящему вашими",
                    "preTitle": "",
                    "detailPageName": "favouritesongs",
                    "tileBadgeUrl": "assets/images/standard/redesign/remix-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/remix.mp4"
                  },
                  {
                    "tr_title": "Посмотрите, как ваше видение воплощается в реальном времени",
                    "preTitle": "",
                    "detailPageName": "realtime",
                    "tileBadgeUrl": "assets/images/standard/redesign/real-time-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/realtime.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Творчество",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/standard/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Самый быстрый способ получить окончательный вариант",
                    "preTitle": "",
                    "detailPageName": "fastestway",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastestway-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastestway.mp4"
                  },
                  {
                    "tr_title": "Сделайте каждую фотографию идеальной",
                    "preTitle": "",
                    "detailPageName": "effects",
                    "tileBadgeUrl": "assets/images/standard/redesign/pictureperfect-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/pictureperfect.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивность",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Повысьте эффективность работы и конфиденциальность",
                    "preTitle": "",
                    "detailPageName": "boostyourproductivity",
                    "tileBadgeUrl": "assets/images/standard/redesign/boost-your-productivity-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/boost-your-productivity.mp4"
                  },
                  {
                    "tr_title": "Больше эффективности. Больше свободы.",
                    "preTitle": "",
                    "detailPageName": "morefreedom",
                    "tileBadgeUrl": "assets/images/standard/redesign/morefreedom-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/morefreedom.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Развлечения",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Плавный стриминг HD даже без подключения к сети питания",
                    "preTitle": "",
                    "detailPageName": "smoothHDstreaming",
                    "tileBadgeUrl": "assets/images/standard/redesign/smoothHDstreaming-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/smoothHDstreaming.mp4"
                  },
                  {
                    "tr_title": "Игры с эффектом погружения где угодно",
                    "preTitle": "",
                    "detailPageName": "fastimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastimmersive-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastimmersive.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "LNL_STD_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "Больше творчества",
              "tileUrlName": "creative",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Редактировать фотографии стало проще",
                    "preTitle": "",
                    "detailPageName": "photoediting",
                    "tileBadgeUrl": "assets/images/standard/redesign/photo_editing_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/photo_editing.mp4"
                  },
                  {
                    "tr_title": "Создавайте фотографии, которые хочется поставить в рамку, за считанные секунды",
                    "preTitle": "",
                    "detailPageName": "createframe",
                    "tileBadgeUrl": "assets/images/standard/redesign/create_frame_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/create_frame.mp4"
                  },
                  {
                    "tr_title": "Вы описываете. ИИ создает.",
                    "preTitle": "",
                    "detailPageName": "youtypeit",
                    "tileBadgeUrl": "assets/images/standard/redesign/you_type_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/you_type.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Выше производительность",
              "tileUrlName": "performance",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Чит-код для более плавных игр",
                    "preTitle": "",
                    "detailPageName": "cheatcode",
                    "tileBadgeUrl": "assets/images/standard/redesign/cheat_code_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/cheat_code.mp4"
                  },
                  {
                    "tr_title": "Больше времени без розетки",
                    "preTitle": "",
                    "detailPageName": "spendmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spend_more_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/spend_more.svg"
                  },
                  {
                    "tr_title": "Ультрапогружение",
                    "preTitle": "",
                    "detailPageName": "ultraimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/ultra_immersive_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/ultra_immersive.svg"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Лучше продуктивность",
              "tileUrlName": "productive",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Ваш ежедневный ИИ&#8209;компаньон",
                    "preTitle": "",
                    "detailPageName": "aicompanion",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_companion_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_companion.mp4"
                  },
                  {
                    "tr_title": "Идеальные видеозвонки",
                    "preTitle": "",
                    "detailPageName": "videocall",
                    "tileBadgeUrl": "assets/images/standard/redesign/video_call_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/video_call.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Надежнее защита",
              "tileUrlName": "secure",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Встроенная защита для обеспечения большей безопасности и конфиденциальности данных",
                    "preTitle": "",
                    "detailPageName": "builtinprotection",
                    "tileBadgeUrl": "assets/images/standard/redesign/protection_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/protection.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "LNL_STD_REDESIGN_ULTRA_7",
          "tilesDetails": [
            {
              "tr_tileTitle": "Больше творчества",
              "tileUrlName": "creative",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Редактировать фотографии стало проще",
                    "preTitle": "",
                    "detailPageName": "photoediting",
                    "tileBadgeUrl": "assets/images/standard/redesign/photo_editing_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/photo_editing.mp4"
                  },
                  {
                    "tr_title": "Искусственный интеллект. Быстрый путь к финальному кадру.",
                    "preTitle": "",
                    "detailPageName": "aishortcut",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_shortcut_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_shortcut.mp4"
                  },
                  {
                    "tr_title": "Быстро расшифровывайте тексты любимых песен",
                    "preTitle": "",
                    "detailPageName": "favouritesong",
                    "tileBadgeUrl": "assets/images/standard/redesign/favourite_song_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/favourite_song.mp4"
                  },
                  {
                    "tr_title": "Экономьте часы монтажа благодаря ИИ",
                    "preTitle": "",
                    "detailPageName": "savehours",
                    "tileBadgeUrl": "assets/images/standard/redesign/save_hours_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/save_hours.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Выше производительность",
              "tileUrlName": "performance",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Чит-код для более плавных игр",
                    "preTitle": "",
                    "detailPageName": "cheatcode",
                    "tileBadgeUrl": "assets/images/standard/redesign/cheat_code_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/cheat_code.mp4"
                  },
                  {
                    "tr_title": "Больше времени без розетки",
                    "preTitle": "",
                    "detailPageName": "spendmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spend_more_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/spend_more.svg"
                  },
                  {
                    "tr_title": "Ультрапогружение",
                    "preTitle": "",
                    "detailPageName": "ultraimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/ultra_immersive_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/ultra_immersive.svg"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Лучше продуктивность",
              "tileUrlName": "productive",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Ваш ежедневный ИИ&#8209;компаньон",
                    "preTitle": "",
                    "detailPageName": "aicompanion",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_companion_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_companion.mp4"
                  },
                  {
                    "tr_title": "Идеальные видеозвонки",
                    "preTitle": "",
                    "detailPageName": "videocall",
                    "tileBadgeUrl": "assets/images/standard/redesign/video_call_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/video_call.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Надежнее защита",
              "tileUrlName": "secure",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Встроенная защита для обеспечения большей безопасности и конфиденциальности данных",
                    "preTitle": "",
                    "detailPageName": "builtinprotection",
                    "tileBadgeUrl": "assets/images/standard/redesign/protection_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/protection.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Все ваши развлечения. В&nbsp;одном&nbsp;ПК.",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "На ПК, который может использоваться в качестве развлекательного центра, требуется достаточно места для хранения всех ваших любимых песен, видео и игр, а также правильное сочетание процессора и дисплея для создания реалистичных визуальных эффектов. В этом ПК есть все три компонента. ",
                "titleArray": [
                  {
                    "tr_title": "Поддержка графики нового поколения",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Создайте свою цифровую библиотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Ваш пропуск в мир развлечений",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Игры и трансляции нон-стоп",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Создайте свою цифровую библиотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Ваш пропуск в мир развлечений",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Работайте еще эффективнее. Где&nbsp;угодно.",
              "tr_tileTitle1": "Успевайте больше",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Этот ПК обладает идеальным балансом мощности и портативности. Помимо процессора, предназначенного для тонких и легких устройств, этот ПК также оснащен технологией Wi-Fi, которая позволяет оставаться на связи, и батареей, которая обеспечивает необходимую длительность работы в автономном режиме.",
                "tr_subtitle1": "Этот ПК обладает идеальным балансом мощности и производительности, чтобы вы могли успевать больше за меньшее время. Сочетание надежного процессора, большого объема памяти и высокоскоростного Wi-Fi поможет оптимизировать выполнение повседневных задач.",
                "tr_subtitle2": "Этот ПК обладает идеальным балансом мощности и портативности. Помимо процессора, предназначенного для тонких и легких устройств, этот ПК также оснащен технологией Wi‑Fi, которая позволяет оставаться на связи, и памятью, которая обеспечит необходимую многозадачность.",
                "titleArray": [
                  {
                    "tr_title": "Создан для большего",
                    "tr_title1": "Интеллектуальная производительность для важных задач",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Новый уровень связи",
                    "tr_title1": "Надежный доступ к важной информации",
                    "tr_title2": "Прорыв в технологии Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "Обходитесь без розеток еще дольше",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "Управляйте программами, как профессионал",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Свобода творчества",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/standard/content-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Создание контента — одна из самых ресурсоемких задач для вашего ПК. К счастью, перечисленные компоненты позволяют оптимизировать творческий процесс.",
                "titleArray": [
                  {
                    "tr_title": "Интеллектуальный инструмент для творчества",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Воплотите творческие замыслы в жизнь ",
                    "tr_title1": "Творите",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "Память для многозадачности",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Внутри этого ПК",
              "tileUrlName": "lookinside",
              "tileBadgeUrl": "assets/images/standard/lookinside-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "При выборе нового ПК следует учитывать три основных компонента. Принимая решение о том, как вы собираетесь использовать свой новый ПК, вы должны решить, насколько вам нужны эти три компонента. Вот эти компоненты:",
                "titleArray": [
                  {
                    "tr_title": "Производительность для игр и стриминга",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Хранилище данных",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Память",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "UWP",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/standard/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "Все ваши развлечения. В&nbsp;одном&nbsp;ПК.",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "На ПК, который может использоваться в качестве развлекательного центра, требуется достаточно места для хранения всех ваших любимых песен, видео и игр, а также правильное сочетание процессора и дисплея для создания реалистичных визуальных эффектов. В этом ПК есть все три компонента. ",
                "titleArray": [
                  {
                    "tr_title": "Поддержка графики нового поколения",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Создайте свою цифровую библиотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Ваш пропуск в мир развлечений",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Игры и трансляции нон-стоп",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Создайте свою цифровую библиотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Ваш пропуск в мир развлечений",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Память",
              "tileUrlName": "memory",
              "tileBadgeUrl": "assets/images/standard/memory-tile.svg"
            },
            {
              "tr_tileTitle": "Дисплей",
              "tileUrlName": "display",
              "tileBadgeUrl": "assets/images/standard/display-tile.svg"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I5",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "Высокоскоростная многозадачность",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВЫСОКОСКОРОСТНАЯ МНОГОЗАДАЧНОСТЬ",
                "tr_subtitle": "Делайте больше без потери производительности",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для многозадачности. ",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может одновременно выполнять несколько программ."
                  },
                  {
                    "tr_title": "Быстрый, сильный и надежный сигнал Wi‑Fi. "
                  },
                  {
                    "tr_title": "Память, которая позволяет беспрепятственно переключаться между приложениями."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Видеочаты",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВИДЕОЧАТЫ",
                "tr_subtitle": "Кристально чистые подключения",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для видеочатов.",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который одновременно может записывать и передавать изображения."
                  },
                  {
                    "tr_title": "Быстрый, сильный и надежный сигнал Wi‑Fi. "
                  },
                  {
                    "tr_title": "Веб-камера, которая поможет вам передавать кристально чистое изображение."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Поддержка виртуальной реальности",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "Погружение в виртуальную реальность",
                "tr_subtitle": "Что необходимо для создания полностью виртуального мира? На ПК вам потребуется координация между процессором, графическим адаптером и памятью.",
                "titleArray": [
                  {
                    "tr_title": "Погружение в виртуальные миры",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Реальность в деталях",
                    "tr_title1": "Ощутите погружение",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I7",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "Монтаж видео",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "МОНТАЖ ВИДЕО",
                "tr_subtitle": "Создавайте магию кино",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для монтажа видео.",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может обрабатывать большие файлы."
                  },
                  {
                    "tr_title": "Память, которая обеспечивает быстродействие монтажного программного обеспечения."
                  },
                  {
                    "tr_title": "Графика, которая сократит время рендеринга."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Высокоскоростная многозадачность",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВЫСОКОСКОРОСТНАЯ МНОГОЗАДАЧНОСТЬ",
                "tr_subtitle": "Делайте больше без потери производительности",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для многозадачности. ",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может одновременно выполнять несколько программ."
                  },
                  {
                    "tr_title": "Быстрый, сильный и надежный сигнал Wi‑Fi. "
                  },
                  {
                    "tr_title": "Память, которая позволяет беспрепятственно переключаться между приложениями."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Поддержка виртуальной реальности",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "Погружение в виртуальную реальность",
                "tr_subtitle": "Что необходимо для создания полностью виртуального мира? На ПК вам потребуется координация между процессором, графическим адаптером и памятью.",
                "titleArray": [
                  {
                    "tr_title": "Погружение в виртуальные миры",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Реальность в деталях",
                    "tr_title1": "Ощутите погружение",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I9",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "3D-моделирование",
              "tileUrlName": "threedmodeling",
              "tileBadgeUrl": "assets/images/standard/rebuild/threedmodeling.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_threedmodeling.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "3D-МОДЕЛИРОВАНИЕ",
                "tr_subtitle": "Творчество нового уровня",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для 3D-моделирования.",
                "tileBG": "#00285A",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может работать с передовым ПО для создания контента."
                  },
                  {
                    "tr_title": "Память, которая может быстро загружать большие файлы."
                  },
                  {
                    "tr_title": "Графика для широких возможностей создания и редактирования изображений."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Совместная работа в реальном времени",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "СОВМЕСТНАЯ РАБОТА В РЕАЛЬНОМ ВРЕМЕНИ",
                "tr_subtitle": "Включайтесь в работу откуда угодно",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для совместной работы онлайн.",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "Процессор для работы офисного программного обеспечения."
                  },
                  {
                    "tr_title": "Wi‑Fi, на который можно положиться."
                  },
                  {
                    "tr_title": "Веб-камера, которая записывает в великолепном HD-качестве."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Поддержка виртуальной реальности",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "Погружение в виртуальную реальность",
                "tr_subtitle": "Что необходимо для создания полностью виртуального мира? На ПК вам потребуется координация между процессором, графическим адаптером и памятью.",
                "titleArray": [
                  {
                    "tr_title": "Погружение в виртуальные миры",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Реальность в деталях",
                    "tr_title1": "Ощутите погружение",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "EVO",
      "tilesDeviceTypes": [
        {
          "deviceType": "11GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Невероятно мощные ноутбуки в тонком и легком корпусе",
                "tr_subtitle": "Ноутбуки Intel® Evo™, созданные для мобильной производительности, отличаются высокой скоростью работы, качественной графикой, длительным временем автономной работы, а также невероятно тонким и легким корпусом.",
                "titleArray": [
                  {
                    "tr_title": "Ноутбук сегодня важен, как никогда ранее, поэтому теперь он может больше, чем когда&#8209;либо.",
                    "tr_subtitle": "Для просмотра, вращения и увеличения используйте сенсорный экран."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Мгновенное пробуждение",
                    "tr_subtitle": "Функция мгновенного&nbsp;пробуждения выводит&nbsp;ПК&nbsp;из&nbsp;спящего&nbsp;режима менее&nbsp;чем&nbsp;за&nbsp;секунду."
                  },
                  {
                    "tr_title": "Эффект погружения при просмотре",
                    "tr_subtitle": "Яркий дисплей с высокой детализацией и&nbsp;насыщенной цветопередачей."
                  },
                  {
                    "tr_title": "Меньше времени на&nbsp;выполнение задач",
                    "tr_subtitle": "Сверхвысокая производительность процессоров Intel® Core™ 11&#8209;го&nbsp;поколения."
                  },
                  {
                    "tr_title": "Длительная автономная работа",
                    "tr_subtitle": "Возможность быстрой зарядки и&nbsp;увеличенное время автономной работы позволяют обходиться без&nbsp;розеток еще дольше."
                  },
                  {
                    "tr_title": "Подключение по универсальному кабелю",
                    "tr_subtitle": "Технология Thunderbolt™&nbsp;4 для&nbsp;простого,&nbsp;быстрого и&nbsp;безопасного&nbsp;подключение других&nbsp;устройств к&nbsp;вашему ПК.<sup>10</sup>"
                  },
                  {
                    "tr_title": "Быстрое и надежное подключение",
                    "tr_subtitle": "Общение в видеочате&nbsp;или обмен&nbsp;файлами в Интернете с&nbsp;помощью&nbsp;надежной&nbsp;технологии Intel®&nbsp;Wi&#8209;Fi&nbsp;6&nbsp;(Gig+).<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "12GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Все, что вам нужно, и даже больше в тонком и легком ноутбуке.",
                "tr_subtitle": "Ноутбуки Intel® Evo™ созданы для мобильной производительности и предназначены для обеспечения наилучшего качества работы<sup>2</sup>, чем бы вы ни занимались.",
                "titleArray": [
                  {
                    "tr_title": "Ноутбук сегодня важен, как никогда ранее, поэтому теперь он может больше, чем когда&#8209;либо.",
                    "tr_subtitle": "Для просмотра, вращения и увеличения используйте сенсорный экран."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Мгновенное пробуждение",
                    "tr_subtitle": "Функция мгновенного&nbsp;пробуждения выводит&nbsp;ПК&nbsp;из&nbsp;спящего&nbsp;режима менее&nbsp;чем&nbsp;за&nbsp;секунду."
                  },
                  {
                    "tr_title": "Эффект погружения при просмотре",
                    "tr_subtitle": "Яркий дисплей с высокой детализацией и&nbsp;насыщенной цветопередачей."
                  },
                  {
                    "tr_title": "Революционная производительность",
                    "tr_subtitle": "Получите дополнительную мощность там, где это больше всего необходимо, благодаря интеллектуальной производительности процессоров Intel®&nbsp;Core™ 12-го поколения."
                  },
                  {
                    "tr_title": "Длительная автономная работа",
                    "tr_subtitle": "Возможность быстрой зарядки и&nbsp;увеличенное время автономной работы позволяют обходиться без&nbsp;розеток еще дольше."
                  },
                  {
                    "tr_title": "Подключение по универсальному кабелю",
                    "tr_subtitle": "Технология Thunderbolt™&nbsp;4 для&nbsp;простого,&nbsp;быстрого и&nbsp;безопасного&nbsp;подключение других&nbsp;устройств к&nbsp;вашему ПК.<sup>10</sup>"
                  },
                  {
                    "tr_title": "Быстрое и надежное подключение",
                    "tr_subtitle": "Общение в видеочате или обмен файлами в Интернете с помощью надежной технологии Intel® Wi-Fi&nbsp;6E (Gig+)<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "11GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Невероятно мощные ноутбуки в тонком и легком корпусе",
                "tr_subtitle": "Ноутбуки Intel® Evo™, созданные для мобильной производительности, отличаются высокой скоростью работы, качественной графикой, длительным временем автономной работы, а также невероятно тонким и легким корпусом.",
                "titleArray": [
                  {
                    "tr_title": "Ноутбук сегодня важен, как никогда ранее, поэтому теперь он может больше, чем когда&#8209;либо.",
                    "tr_subtitle": "Для просмотра, вращения и увеличения используйте сенсорный экран."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Мгновенное пробуждение",
                    "tr_subtitle": "Функция мгновенного&nbsp;пробуждения выводит&nbsp;ПК&nbsp;из&nbsp;спящего&nbsp;режима менее&nbsp;чем&nbsp;за&nbsp;секунду."
                  },
                  {
                    "tr_title": "Эффект погружения при просмотре",
                    "tr_subtitle": "Яркий дисплей с высокой детализацией и&nbsp;насыщенной цветопередачей."
                  },
                  {
                    "tr_title": "Меньше времени на&nbsp;выполнение задач",
                    "tr_subtitle": "Сверхвысокая производительность процессоров Intel® Core™ 11&#8209;го&nbsp;поколения."
                  },
                  {
                    "tr_title": "Длительная автономная работа",
                    "tr_subtitle": "Возможность быстрой зарядки и&nbsp;увеличенное время автономной работы позволяют обходиться без&nbsp;розеток еще дольше."
                  },
                  {
                    "tr_title": "Подключение по универсальному кабелю",
                    "tr_subtitle": "Технология Thunderbolt™&nbsp;4 для&nbsp;простого,&nbsp;быстрого и&nbsp;безопасного&nbsp;подключение других&nbsp;устройств к&nbsp;вашему ПК.<sup>10</sup>"
                  },
                  {
                    "tr_title": "Быстрое и надежное подключение",
                    "tr_subtitle": "Общение в видеочате&nbsp;или обмен&nbsp;файлами в Интернете с&nbsp;помощью&nbsp;надежной&nbsp;технологии Intel®&nbsp;Wi&#8209;Fi&nbsp;6&nbsp;(Gig+).<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "12GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Все, что вам нужно, и даже больше в тонком и легком ноутбуке.",
                "tr_subtitle": "Ноутбуки Intel® Evo™ созданы для мобильной производительности и предназначены для обеспечения наилучшего качества работы<sup>2</sup>, чем бы вы ни занимались.",
                "titleArray": [
                  {
                    "tr_title": "Ноутбук сегодня важен, как никогда ранее, поэтому теперь он может больше, чем когда&#8209;либо.",
                    "tr_subtitle": "Для просмотра, вращения и увеличения используйте сенсорный экран."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Мгновенное пробуждение",
                    "tr_subtitle": "Функция мгновенного&nbsp;пробуждения выводит&nbsp;ПК&nbsp;из&nbsp;спящего&nbsp;режима менее&nbsp;чем&nbsp;за&nbsp;секунду."
                  },
                  {
                    "tr_title": "Эффект погружения при просмотре",
                    "tr_subtitle": "Яркий дисплей с высокой детализацией и&nbsp;насыщенной цветопередачей."
                  },
                  {
                    "tr_title": "Революционная производительность",
                    "tr_subtitle": "Получите дополнительную мощность там, где это больше всего необходимо, благодаря интеллектуальной производительности процессоров Intel®&nbsp;Core™ 12-го поколения."
                  },
                  {
                    "tr_title": "Длительная автономная работа",
                    "tr_subtitle": "Возможность быстрой зарядки и&nbsp;увеличенное время автономной работы позволяют обходиться без&nbsp;розеток еще дольше."
                  },
                  {
                    "tr_title": "Подключение по универсальному кабелю",
                    "tr_subtitle": "Технология Thunderbolt™&nbsp;4 для&nbsp;простого,&nbsp;быстрого и&nbsp;безопасного&nbsp;подключение других&nbsp;устройств к&nbsp;вашему ПК.<sup>10</sup>"
                  },
                  {
                    "tr_title": "Быстрое и надежное подключение",
                    "tr_subtitle": "Общение в видеочате или обмен файлами в Интернете с помощью надежной технологии Intel® Wi-Fi&nbsp;6E (Gig+)<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "13GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Все, что вам нужно, и даже больше в тонком и легком ноутбуке.",
                "tr_subtitle": "Ноутбуки Intel® Evo™ созданы для мобильной производительности и предназначены для обеспечения наилучшего качества работы<sup>2</sup>, чем бы вы ни занимались.",
                "titleArray": [
                  {
                    "tr_title": "Ноутбук сегодня важен, как никогда ранее, поэтому теперь он может больше, чем когда&#8209;либо.",
                    "tr_subtitle": "Для просмотра, вращения и увеличения используйте сенсорный экран."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Мгновенное пробуждение",
                    "tr_subtitle": "Функция мгновенного&nbsp;пробуждения выводит&nbsp;ПК&nbsp;из&nbsp;спящего&nbsp;режима менее&nbsp;чем&nbsp;за&nbsp;секунду."
                  },
                  {
                    "tr_title": "Эффект погружения при просмотре",
                    "tr_subtitle": "Яркий дисплей с высокой детализацией и&nbsp;насыщенной цветопередачей."
                  },
                  {
                    "tr_title": "Революционная производительность",
                    "tr_subtitle": "Получите дополнительную мощность там, где это больше всего необходимо, благодаря интеллектуальной производительности процессоров Intel®&nbsp;Core™ 13-го поколения."
                  },
                  {
                    "tr_title": "Длительная автономная работа",
                    "tr_subtitle": "Возможность быстрой зарядки и&nbsp;увеличенное время автономной работы позволяют обходиться без&nbsp;розеток еще дольше."
                  },
                  {
                    "tr_title": "Подключение по универсальному кабелю",
                    "tr_subtitle": "Технология Thunderbolt™&nbsp;4 для&nbsp;простого,&nbsp;быстрого и&nbsp;безопасного&nbsp;подключение других&nbsp;устройств к&nbsp;вашему ПК.<sup>10</sup>"
                  },
                  {
                    "tr_title": "Быстрое и надежное подключение",
                    "tr_subtitle": "Общение в видеочате или обмен файлами в Интернете с помощью надежной технологии Intel® Wi-Fi&nbsp;6E (Gig+)<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "13GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Все, что вам нужно, и даже больше в тонком и легком ноутбуке.",
                "tr_subtitle": "Ноутбуки Intel® Evo™ созданы для мобильной производительности и предназначены для обеспечения наилучшего качества работы<sup>2</sup>, чем бы вы ни занимались.",
                "titleArray": [
                  {
                    "tr_title": "Ноутбук сегодня важен, как никогда ранее, поэтому теперь он может больше, чем когда&#8209;либо.",
                    "tr_subtitle": "Для просмотра, вращения и увеличения используйте сенсорный экран."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Мгновенное пробуждение",
                    "tr_subtitle": "Функция мгновенного&nbsp;пробуждения выводит&nbsp;ПК&nbsp;из&nbsp;спящего&nbsp;режима менее&nbsp;чем&nbsp;за&nbsp;секунду."
                  },
                  {
                    "tr_title": "Эффект погружения при просмотре",
                    "tr_subtitle": "Яркий дисплей с высокой детализацией и&nbsp;насыщенной цветопередачей."
                  },
                  {
                    "tr_title": "Революционная производительность",
                    "tr_subtitle": "Получите дополнительную мощность там, где это больше всего необходимо, благодаря интеллектуальной производительности процессоров Intel®&nbsp;Core™ 13-го поколения."
                  },
                  {
                    "tr_title": "Длительная автономная работа",
                    "tr_subtitle": "Возможность быстрой зарядки и&nbsp;увеличенное время автономной работы позволяют обходиться без&nbsp;розеток еще дольше."
                  },
                  {
                    "tr_title": "Подключение по универсальному кабелю",
                    "tr_subtitle": "Технология Thunderbolt™&nbsp;4 для&nbsp;простого,&nbsp;быстрого и&nbsp;безопасного&nbsp;подключение других&nbsp;устройств к&nbsp;вашему ПК.<sup>10</sup>"
                  },
                  {
                    "tr_title": "Быстрое и надежное подключение",
                    "tr_subtitle": "Общение в видеочате или обмен файлами в Интернете с помощью надежной технологии Intel® Wi-Fi&nbsp;6E (Gig+)<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "EVO_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "Новости",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/evo/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Что такое Версия Intel®&nbsp;Evo™&nbsp;Edition?",
                    "preTitle": "",
                    "detailPageName": "whatIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whatIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whatIntelEvo.mp4"
                  },
                  {
                    "tr_title": "Преимущества Intel®&nbsp;Evo™&nbsp;Edition",
                    "preTitle": "",
                    "detailPageName": "whyIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whyIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whyIntelEvo.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Творчество",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/evo/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Больше творческих возможностей где угодно",
                    "preTitle": "",
                    "detailPageName": "morecreative",
                    "tileBadgeUrl": "assets/images/evo/redesign/morecreative-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/morecreative.mp4"
                  },
                  {
                    "tr_title": "Редактирование фотографий на полной скорости",
                    "preTitle": "",
                    "detailPageName": "photoeditng",
                    "tileBadgeUrl": "assets/images/evo/redesign/photoeditng-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/photoeditng.mp4"
                  },
                  {
                    "tr_title": "Создавайте оригинальные работы сразу на месте",
                    "preTitle": "",
                    "detailPageName": "originalArt",
                    "tileBadgeUrl": "assets/images/evo/redesign/originalArt-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/originalArt.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивность",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/evo/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Максимально повысьте продуктивность с помощью Rewind AI",
                    "preTitle": "",
                    "detailPageName": "rewind-ai",
                    "tileBadgeUrl": "assets/images/evo/redesign/rewind-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/rewind-ai.mp4"
                  },
                  {
                    "tr_title": "Выявляйте дипфейки благодаря ИИ, прежде чем поделиться контентом",
                    "preTitle": "",
                    "detailPageName": "deepfakes",
                    "tileBadgeUrl": "assets/images/evo/redesign/deepfakes-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/deepfakes.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Портативность",
              "tileUrlName": "mobility",
              "tileBadgeUrl": "assets/images/evo/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Встречайте управление жестами",
                    "preTitle": "gesturecontrol",
                    "detailPageName": "virtuallyanywhere",
                    "tileBadgeUrl": "assets/images/evo/redesign/gesturecontrol-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/gesturecontrol.mp4"
                  },
                  {
                    "tr_title": "Бескомпромиссное время автономной работы",
                    "preTitle": "",
                    "detailPageName": "batteryLife-entertainment",
                    "tileBadgeUrl": "assets/images/evo/redesign/batteryLife-entertainment-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/batteryLife-entertainment.mp4"
                  },
                  {
                    "tr_title": "Автоматическая поддержка подключения",
                    "preTitle": "",
                    "detailPageName": "automaticallyConnected",
                    "tileBadgeUrl": "assets/images/evo/redesign/automaticallyConnected-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/automaticallyConnected.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "EVO_REDESIGN_ULTRA_7",
          "tilesDetails": [
            {
              "tr_tileTitle": "Новости",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/evo/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Что такое Версия Intel®&nbsp;Evo™&nbsp;Edition?",
                    "preTitle": "",
                    "detailPageName": "whatIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whatIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whatIntelEvo.mp4"
                  },
                  {
                    "tr_title": "Преимущества Intel®&nbsp;Evo™&nbsp;Edition",
                    "preTitle": "",
                    "detailPageName": "whyIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whyIntelEvo7-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whyIntelEvo7.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Творчество",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/evo/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Быстрое и плавное воспроизведение видео",
                    "preTitle": "",
                    "detailPageName": "videoplayback",
                    "tileBadgeUrl": "assets/images/evo/redesign/videoplayback-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/videoplayback.mp4"
                  },
                  {
                    "tr_title": "Создавайте хиты с помощью ИИ",
                    "preTitle": "",
                    "detailPageName": "powerAI",
                    "tileBadgeUrl": "assets/images/evo/redesign/power-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/power-ai.mp4"
                  },
                  {
                    "tr_title": "Самый быстрый способ получить окончательный вариант",
                    "preTitle": "",
                    "detailPageName": "fastestway",
                    "tileBadgeUrl": "assets/images/evo/redesign/fastestway-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/fastestway.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивность",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/evo/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Максимально повысьте продуктивность с помощью Rewind AI",
                    "preTitle": "",
                    "detailPageName": "rewind-ai",
                    "tileBadgeUrl": "assets/images/evo/redesign/rewind-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/rewind-ai.mp4"
                  },
                  {
                    "tr_title": "Выявляйте дипфейки благодаря ИИ, прежде чем поделиться контентом",
                    "preTitle": "",
                    "detailPageName": "deepfakes",
                    "tileBadgeUrl": "assets/images/evo/redesign/deepfakes-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/deepfakes.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Портативность",
              "tileUrlName": "mobility",
              "tileBadgeUrl": "assets/images/evo/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Совместная работа практически из любого места",
                    "preTitle": "",
                    "detailPageName": "virtuallyanywhere",
                    "tileBadgeUrl": "assets/images/evo/redesign/virtuallyanywhere7-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/virtuallyanywhere7.mp4"
                  },
                  {
                    "tr_title": "Бескомпромиссное время автономной работы",
                    "preTitle": "",
                    "detailPageName": "batteryLife-entertainment",
                    "tileBadgeUrl": "assets/images/evo/redesign/batteryLife-entertainment-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/batteryLife-entertainment.mp4"
                  },
                  {
                    "tr_title": "Автоматическая поддержка подключения",
                    "preTitle": "",
                    "detailPageName": "automaticallyConnected",
                    "tileBadgeUrl": "assets/images/evo/redesign/automaticallyConnected-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/automaticallyConnected.mp4"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_11",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Все ваши развлечения. В&nbsp;одном&nbsp;ПК.",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "На ПК, который может использоваться в качестве развлекательного центра, требуется достаточно места для хранения всех ваших любимых песен, видео и игр, а также правильное сочетание процессора и дисплея для создания реалистичных визуальных эффектов. В этом ПК есть все три компонента. ",
                "titleArray": [
                  {
                    "tr_title": "Захватывающие игры и трансляции",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Создайте свою цифровую библиотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Ваш пропуск в мир развлечений",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Игры и трансляции нон-стоп",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Создайте свою цифровую библиотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Ваш пропуск в мир развлечений",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Работайте еще эффективнее. Где&nbsp;угодно.",
              "tr_tileTitle1": "Успевайте больше",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Этот ПК обладает идеальным балансом мощности и портативности. Помимо процессора, предназначенного для тонких и легких устройств, этот ПК также оснащен технологией Wi-Fi, которая позволяет оставаться на связи, и батареей, которая обеспечивает необходимую длительность работы в автономном режиме.",
                "tr_subtitle1": "Этот ПК обладает идеальным балансом мощности и производительности, чтобы вы могли успевать больше за меньшее время. Сочетание надежного процессора, большого объема памяти и высокоскоростного Wi-Fi поможет оптимизировать выполнение повседневных задач.",
                "tr_subtitle2": "Этот ПК обладает идеальным балансом мощности и портативности. Помимо процессора, предназначенного для тонких и легких устройств, этот ПК также оснащен технологией Wi‑Fi, которая позволяет оставаться на связи, и памятью, которая обеспечит необходимую многозадачность.",
                "titleArray": [
                  {
                    "tr_title": "Интеллектуальная производительность для важных задач",
                    "tr_title1": "Интеллектуальное увеличение производительности",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Новый уровень связи",
                    "tr_title1": "Надежный доступ к важной информации",
                    "tr_title2": "Прорыв в технологии Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "Обходитесь без розеток еще дольше",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "Управляйте программами, как профессионал",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Свобода творчества",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/standard/content-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Создание контента — одна из самых ресурсоемких задач для вашего ПК. К счастью, перечисленные компоненты позволяют оптимизировать творческий процесс.",
                "titleArray": [
                  {
                    "tr_title": "Творчество со скоростью мысли",
                    "tr_title1": "Творите со скоростью вашей фантазии",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Новые горизонты творчества",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "Память для многозадачности",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Внутри этого ПК",
              "tileUrlName": "lookinside",
              "tileBadgeUrl": "assets/images/standard/lookinside-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "При выборе нового ПК следует учитывать три основных компонента. Принимая решение о том, как вы собираетесь использовать свой новый ПК, вы должны решить, насколько вам нужны эти три компонента. Вот эти компоненты:",
                "titleArray": [
                  {
                    "tr_title": "Процессор",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Хранилище данных",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Память",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_12",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "Свобода творчества",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/creator/freedom_new.png",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Создание контента — одна из самых ресурсоемких задач для вашего ПК. К счастью, перечисленные компоненты позволяют оптимизировать творческий процесс.",
                "titleArray": [
                  {
                    "tr_title": "Интеллектуальный инструмент для творчества",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Воплотите творческие замыслы в жизнь ",
                    "tr_title1": "Творите",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "Память для многозадачности",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Работайте еще эффективнее. Где&nbsp;угодно.",
              "tr_tileTitle1": "Успевайте больше",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Этот ПК обладает идеальным балансом мощности и портативности. Помимо процессора, предназначенного для тонких и легких устройств, этот ПК также оснащен технологией Wi-Fi, которая позволяет оставаться на связи, и батареей, которая обеспечивает необходимую длительность работы в автономном режиме.",
                "tr_subtitle1": "Этот ПК обладает идеальным балансом мощности и производительности, чтобы вы могли успевать больше за меньшее время. Сочетание надежного процессора, большого объема памяти и высокоскоростного Wi-Fi поможет оптимизировать выполнение повседневных задач.",
                "tr_subtitle2": "Этот ПК обладает идеальным балансом мощности и портативности. Помимо процессора, предназначенного для тонких и легких устройств, этот ПК также оснащен технологией Wi‑Fi, которая позволяет оставаться на связи, и памятью, которая обеспечит необходимую многозадачность.",
                "titleArray": [
                  {
                    "tr_title": "Создан для большего",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Новый уровень связи",
                    "tr_title1": "Надежный доступ к важной информации",
                    "tr_title2": "Прорыв в технологии Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "Обходитесь без розеток еще дольше",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "Управляйте программами, как профессионал",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Поддержка виртуальной реальности",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/creator/new_vr_gen12_creator.png",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "Погружение в виртуальную реальность",
                "tr_subtitle": "Что необходимо для создания полностью виртуального мира? На ПК вам потребуется координация между процессором, графическим адаптером и памятью.",
                "titleArray": [
                  {
                    "tr_title": "Погружение в виртуальные миры",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Реальность в деталях",
                    "tr_title1": "Ощутите погружение",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "PANTHER_LAKE",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Аккумулятор, который не отстает от вас.",
              "tileUrlName": "ptl-battery",
              "tileBadgeUrl": "assets/images/battery_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Работайте и играйте до&nbsp;победного – без подзарядки.",
                "tr_subtitle": "Ваш ПК поможет вам независимо от количества задач. Выполняйте любые задачи без подключения к розетке и замедления работы.",
                "detailBGUrl": "assets/images/battery_ptl_bg.png",
                "titleArray": [
                  {
                    "tr_title": "Сохраняйте продуктивность без&nbsp;подключения к&nbsp;розетке."
                  },
                  {
                    "tr_title": "Оцените производительность, которая&nbsp;так&nbsp;же мобильна, как&nbsp;и&nbsp;вы."
                  },
                  {
                    "tr_title": "Запускайте игры и приложения, недоступные для других."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Производительность, которая&nbsp;вам&nbsp;нужна.",
              "tileUrlName": "ptl-performance",
              "tileBadgeUrl": "assets/images/performance_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Производительность, которая&nbsp;вам&nbsp;нужна.",
                "tr_subtitle": "47 открытых вкладок, 3 запущенных приложения и совещание, которое начнется через 30 секунд. В такие моменты нужна более высокая скорость, низкое тепловыделение и полный контроль.",
                "detailBGUrl": "assets/images/performance_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "Реалистичные&nbsp;игры.<br/>Максимальная производительность.",
              "tileUrlName": "ptl-gaming",
              "tileBadgeUrl": "assets/images/gaming_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Реалистичные&nbsp;игры.<br/>Максимальная производительность.",
                "tr_subtitle": "Оцените тысячи игр AAA&#8209;класса и&nbsp;инди&#8209;игр на быстром игровом ноутбуке. Без&nbsp;задержек, заминок и компромиссов.",
                "detailBGUrl": "assets/images/gaming_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "ИИ, созданный специально&nbsp;для&nbsp;вас.",
              "tileUrlName": "ptl-aiexperience",
              "tileBadgeUrl": "assets/images/ai_experience_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "assets/images/aiExperience_ptl_bg.png",
                "tr_title": "ИИ, созданный специально&nbsp;для&nbsp;вас.",
                "tr_subtitle": "От обобщения документов до управления расписанием и улучшения качества видеозвонков в реальном времени — вы&nbsp;получаете больше ИИ&#8209;инструментов, которые&nbsp;помогают решать сложные задачи и&nbsp;экономят&nbsp;время.",
                "titleArray": [
                  {
                    "tr_title": "Оцените возможности Copilot+."
                  },
                  {
                    "tr_title": "Совместимость с большинством ИИ&#8209;инструментов и приложений."
                  },
                  {
                    "tr_title": "Будьте готовы к возможностям ИИ&nbsp;будущего."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Графика, воплощающая ваши идеи в&nbsp;жизнь.",
              "tileUrlName": "ptl-graphics",
              "tileBadgeUrl": "assets/images/graphics_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Графика, воплощающая ваши идеи в&nbsp;жизнь.",
                "tr_subtitle": "Быстро создавайте и&nbsp;редактируйте изображения в&nbsp;высоком разрешении с&nbsp;мощной встроенной графикой. Четкие линии, насыщенные цвета и&nbsp;плавная работа делают каждую работу безупречной.",
                "detailBGUrl": "assets/images/graphics_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "Запуск игр и приложений, недоступных другим.",
              "tileUrlName": "ptl-compatibility",
              "tileBadgeUrl": "assets/images/compatibility_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Запуск игр и приложений, недоступных другим.",
                "tr_subtitle": "Основные приложения? Работают как надо. Любимые игры? Плавный геймплей и без лишних настроек. Мы сотрудничаем с ведущими разработчиками, чтобы ваш цифровой мир работал быстрее и эффективнее — и сразу после запуска.<br/><span class='ptl_compatibility_subtitle_text'>Будь то дизайн, монтаж или новая игра — все нужные инструменты работают стабильно и плавно. Без задержек, сбоев и лишних сложностей.</span>",
                "detailBGUrl": "assets/images/compatibility_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "Дизайн, который&nbsp;отражает ваш стиль.",
              "tileUrlName": "ptl-design",
              "tileBadgeUrl": "assets/images/design_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Дизайн, который&nbsp;отражает ваш стиль.",
                "tr_subtitle": "Ваш ПК должен выглядеть и работать так, как вы хотите. Благодаря широкому диапазону цветов и размеров, наличию сенсорного экрана и моделей 2 в 1 ваш ПК станет идеальным компаньоном с самого первого дня.",
                "detailBGUrl": "assets/images/design_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "Лучшие возможности при работе с ноутбуком<sup>1</sup>.",
              "tileUrlName": "ptl-evo",
              "tileBadgeUrl": "assets/images/evo_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Лучшие возможности при работе с ноутбуком<sup>1</sup>.",
                "tr_subtitle": "Каждый тонкий и легкий ноутбук Intel® Evo™ Edition сертифицирован и готов к любым вызовам.",
                "detailBGUrl": "assets/images/evo_ptl_bg.svg",
                "titleArray": [
                  {
                    "tr_title": "Мобильная производительность."
                  },
                  {
                    "tr_title": "Длительная автономная работа в реальных условиях."
                  },
                  {
                    "tr_title": "Быстрая зарядка."
                  },
                  {
                    "tr_title": "Мгновенный выход из спящего режима."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Станьте быстрее и&nbsp;эффективнее.",
              "tileUrlName": "ptl-processor",
              "tileBadgeUrl": "assets/images/processor_ptl_tile.png"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "PANTHER_LAKE_12XE",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Для больших идей больше не нужны большие ПК.",
              "tileUrlName": "ptl-performance",
              "tileBadgeUrl": "assets/images/performance_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Производительность графики, в которую невозможно поверить.",
                "tr_subtitle": "",
                "detailBGUrl": "assets/images/performance_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "Графика студийного уровня в сверхэлегантном корпусе."
                  },
                  {
                    "tr_title": "Скорость, тишина и готовность в момент вдохновения."
                  },
                  {
                    "tr_title": "Аккумулятор, достойный ваших идей."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Аккумулятор, который не мешает вам творить.",
              "tileUrlName": "ptl-battery",
              "tileBadgeUrl": "assets/images/battery_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Аккумулятор, который не мешает вам творить.",
                "tr_subtitle": "",
                "detailBGUrl": "assets/images/battery_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "Студийная графика в любом месте."
                  },
                  {
                    "tr_title": "Создавайте контент и играйте в течение всего дня."
                  },
                  {
                    "tr_title": "Тонкая и легкая конструкция без компромиссов."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Получите доступ  к Battlefield* 6, Everwind* и другим играм.",
              "tileUrlName": "ptl-softwarebundle",
              "tileBadgeUrl": "assets/images/software_bundle_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "ptl-tile1-panel",
                "tr_title": "Творите днем,<br/>играйте ночью.",
                "tr_title1": "<span class='processor_bold'>Процессор Intel® Core™ Ultra [XX]</span> со встроенной <span class='processor_bold'>графикой Intel® Arc™</span>",
                "tr_subtitle": "Получите доступ к Battlefield* 6, Everwind* и предложению от Adobe* при покупке соответствующих устройств на базе процессоров Intel® Core™ Ultra [XX].",
                "detailBGUrl": "assets/images/software_bundle_ptl12xe_bg.png",
                "badgeUrl1": "assets/images/arc-badge.svg",
                "badgeUrl": "assets/images/badges/intel_core_ultra_[XX].svg",
                "tr_subtitle1": "Выберите одну 6-месячную подписку:",
                "titleArray": [
                  {
                    "tr_title": "План Adobe Creative Cloud Photography",
                    "imgUrl": "assets/images/ptl_adobe_cloud.svg"
                  },
                  {
                    "tr_title": "Adobe Premiere Pro",
                    "imgUrl": "assets/images/ptl_adobe_premiere.svg"
                  }
                ],
                "tr_subtitle2": "2025 Electronic Arts Inc. Battlefield* является товарным знаком Electronic Arts Inc. © 2025 BOHEMIA INTERACTIVE a.s. © 2025 Adobe. Все права защищены. © Корпорация Intel. Предложение действует до 15 июля 2026 года. Применяются условия."
              }
            },
            {
              "tr_tileTitle": "Творите днем, играйте&nbsp;ночью.",
              "tileUrlName": "ptl-gaming",
              "tileBadgeUrl": "assets/images/gaming_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Творите днем, играйте&nbsp;ночью.",
                "tr_subtitle": "",
                "detailBGUrl": "assets/images/gaming_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "Игровая графика и сверхтонкий корпус."
                  },
                  {
                    "tr_title": "Запускайте любимые приложения и игры."
                  },
                  {
                    "tr_title": "Играйте где угодно."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ИИ, созданный специально&nbsp;для&nbsp;вас.",
              "tileUrlName": "ptl-aiexperience",
              "tileBadgeUrl": "assets/images/ai_experience_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "ИИ, созданный специально&nbsp;для&nbsp;вас.",
                "tr_subtitle": "От обобщения документов до управления расписанием и улучшения качества видеозвонков в реальном времени — вы&nbsp;получаете больше ИИ&#8209;инструментов, которые&nbsp;помогают решать сложные задачи и&nbsp;экономят&nbsp;время.",
                "detailBGUrl": "assets/images/aiExperience_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "Система, на которую можно положиться."
                  },
                  {
                    "tr_title": "Все работает прямо из коробки."
                  },
                  {
                    "tr_title": "Защита, о которой не нужно думать."
                  },
                  {
                    "tr_title": "Безопасность, опережающая угрозы."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Встроенная&nbsp;графика, превосходящая ожидания.",
              "tileUrlName": "ptl-graphics",
              "tileBadgeUrl": "assets/images/graphics_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Встроенная&nbsp;графика, превосходящая ожидания.",
                "tr_subtitle": "Не стоит недооценивать интегрированную графику. Благодаря 50-процентному приросту количества ядер Intel® Arc™ X<sup>e</sup> вы получаете быстродействие для игр, редактирования, рендеринга и стриминга — без затрат, лишнего веса или разрядки аккумулятора при использовании специального ГП. Встроенная графика обеспечивает все, что нужно большинству создателей контента и геймеров.",
                "detailBGUrl": "assets/images/graphics_ptl12xe_bg.png"
              }
            },
            {
              "tr_tileTitle": "Запуск игр и приложений, недоступных другим.",
              "tileUrlName": "ptl-compatibility",
              "tileBadgeUrl": "assets/images/compatibility_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Запуск игр и приложений, недоступных другим.",
                "tr_subtitle": "Основные приложения? Работают как надо. Любимые игры? Плавный геймплей и без лишних настроек. Мы сотрудничаем с ведущими разработчиками, чтобы ваш цифровой мир работал быстрее и эффективнее — и сразу после запуска.<br/><span class='ptl_compatibility_subtitle_text'>Будь то дизайн, монтаж или новая игра — все нужные инструменты работают стабильно и плавно. Без задержек, сбоев и лишних сложностей.</span>",
                "detailBGUrl": "assets/images/compatibility_ptl12xe_bg.png"
              }
            },
            {
              "tr_tileTitle": "Дизайн, который&nbsp;отражает ваш стиль.",
              "tileUrlName": "ptl-design",
              "tileBadgeUrl": "assets/images/design_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "Дизайн, который&nbsp;отражает ваш стиль.",
                "tr_subtitle": "Ваш ПК должен выглядеть и работать так, как вы хотите. Благодаря широкому диапазону цветов и размеров, наличию сенсорного экрана и моделей 2 в 1 ваш ПК станет идеальным компаньоном с самого первого дня.",
                "detailBGUrl": "assets/images/design_ptl12xe_bg.png"
              }
            },
            {
              "tr_tileTitle": "Для больших идей больше не нужны большие ПК.",
              "tileUrlName": "ptl-processor",
              "tileBadgeUrl": "assets/images/processor_ptl12xe_tile.png"
            }
          ]
        }
      ]
    }
  ],
  "samsungOled": [
    {
      "panelType": "oled_first_panel",
      "badgeUrl": "assets/images/oled/OLED_logo.svg"
    },
    {
      "panelType": "oled_second_panel",
      "tr_header": "Samsung OLED:<br/>Бальзам для усталых глаз",
      "tr_sub_header": "Синий спектр света может вызывать визуальный дискомфорт и нарушать цикл сна. Дисплей OLED компании Samsung, протестированный SGS Eye Care, работает не путем изменения цвета, а с помощью сокращения длины волны потенциально вредного синего спектра света, что обеспечивает комфорт для глаз и снижает их утомление.",
      "badgeUrl": "assets/images/oled/oled-graph.svg",
      "tr_title1": "Менее вредный синий спектр света"
    },
    {
      "panelType": "oled_third_panel",
      "tr_header": "Ультра во всех отношениях",
      "tr_sub_header": "Ультралегкая, ультратонкая конструкция OLED максимально повышает качество изображения при минимальном весе."
    },
    {
      "panelType": "oled_fourth_panel",
      "tr_header": "Истинный черный",
      "tr_sub_header": "0,0005 нит"
    },
    {
      "panelType": "oled_fifth_panel",
      "tr_header": "74 %<br/><span class='conventional_text'>Обычный</span>",
      "tr_sub_header": "120 %<br/><span class='samsungoled_text'>Samsung OLED</span>"
    }
  ],
  "rebuildUsageModel": [
    {
      "tilesType": "STANDARD_REBUILD_I3",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Потоковая трансляция",
              "tileUrlName": "streaming",
              "tileBadgeUrl": "assets/images/standard/rebuild/streaming.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_streaming.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ПОТОКОВАЯ ТРАНСЛЯЦИЯ",
                "tr_subtitle": "Бесконечные развлечения",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для просмотра онлайн.",
                "tileBG": "#794584",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может обрабатывать трансляцию в HD-качестве."
                  },
                  {
                    "tr_title": "Дисплей для ярких и красивых изображений."
                  },
                  {
                    "tr_title": "Wi‑Fi с меньшим временем буферизации и загрузки."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Просмотр веб-страниц",
              "tileUrlName": "webbrowsing",
              "tileBadgeUrl": "assets/images/standard/rebuild/webbrowsing.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_webbrowsing.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ПРОСМОТР ВЕБ-СТРАНИЦ",
                "tr_subtitle": "Доступ в Интернет стал проще",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для просмотра веб-страниц.",
                "tileBG": "#87A944",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может быстро загружать страницы с большим объемом мультимедиа."
                  },
                  {
                    "tr_title": "Быстрый и надежный Wi‑Fi."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Видеочаты",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВИДЕОЧАТЫ",
                "tr_subtitle": "Кристально чистые подключения",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для видеочатов.",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который одновременно может записывать и передавать изображения."
                  },
                  {
                    "tr_title": "Быстрый, сильный и надежный сигнал Wi‑Fi. "
                  },
                  {
                    "tr_title": "Веб-камера, которая поможет вам передавать кристально чистое изображение."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I5",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Высокоскоростная многозадачность",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВЫСОКОСКОРОСТНАЯ МНОГОЗАДАЧНОСТЬ",
                "tr_subtitle": "Делайте больше без потери производительности",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для многозадачности. ",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может одновременно выполнять несколько программ."
                  },
                  {
                    "tr_title": "Быстрый, сильный и надежный сигнал Wi‑Fi. "
                  },
                  {
                    "tr_title": "Память, которая позволяет беспрепятственно переключаться между приложениями."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Видеочаты",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВИДЕОЧАТЫ",
                "tr_subtitle": "Кристально чистые подключения",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для видеочатов.",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который одновременно может записывать и передавать изображения."
                  },
                  {
                    "tr_title": "Быстрый, сильный и надежный сигнал Wi‑Fi. "
                  },
                  {
                    "tr_title": "Веб-камера, которая поможет вам передавать кристально чистое изображение."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Простые игры",
              "tileUrlName": "casualgaming",
              "tileBadgeUrl": "assets/images/standard/rebuild/casualgaming.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_casualgaming.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ПРОСТЫЕ ИГРЫ",
                "tr_subtitle": "Время играть",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для легких игр.",
                "tileBG": "#000000",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который обеспечивает плавный игровой процесс."
                  },
                  {
                    "tr_title": "Память, которая позволяет одновременно вести голосовые чаты и трансляцию."
                  },
                  {
                    "tr_title": "Графика, которая обеспечивает потрясающее изображение."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Редактирование фото",
              "tileUrlName": "photoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/photoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_photoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "РЕДАКТИРОВАНИЕ ФОТО",
                "tr_subtitle": "Идеальные фото — до последнего пикселя",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для редактирования фотографий.",
                "tileBG": "#659FBA",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который способен редактировать большие группы изображений."
                  },
                  {
                    "tr_title": "Память, которая ускоряет программное обеспечение для редактирования."
                  },
                  {
                    "tr_title": "Технология Thunderbolt™&nbsp;4, которая позволяет быстро передавать файлы."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I7",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Высокоскоростная многозадачность",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВЫСОКОСКОРОСТНАЯ МНОГОЗАДАЧНОСТЬ",
                "tr_subtitle": "Делайте больше без потери производительности",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для многозадачности. ",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может одновременно выполнять несколько программ."
                  },
                  {
                    "tr_title": "Быстрый, сильный и надежный сигнал Wi‑Fi. "
                  },
                  {
                    "tr_title": "Память, которая позволяет беспрепятственно переключаться между приложениями."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Совместная работа в реальном времени",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "СОВМЕСТНАЯ РАБОТА В РЕАЛЬНОМ ВРЕМЕНИ",
                "tr_subtitle": "Включайтесь в работу откуда угодно",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для совместной работы онлайн.",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "Процессор для работы офисного программного обеспечения."
                  },
                  {
                    "tr_title": "Wi‑Fi, на который можно положиться."
                  },
                  {
                    "tr_title": "Веб-камера, которая записывает в великолепном HD-качестве."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Монтаж видео",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "МОНТАЖ ВИДЕО",
                "tr_subtitle": "Создавайте магию кино",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для монтажа видео.",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может обрабатывать большие файлы."
                  },
                  {
                    "tr_title": "Память, которая обеспечивает быстродействие монтажного программного обеспечения."
                  },
                  {
                    "tr_title": "Графика, которая сократит время рендеринга."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Редактирование фото",
              "tileUrlName": "photoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/photoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_photoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "РЕДАКТИРОВАНИЕ ФОТО",
                "tr_subtitle": "Идеальные фото — до последнего пикселя",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для редактирования фотографий.",
                "tileBG": "#659FBA",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который способен редактировать большие группы изображений."
                  },
                  {
                    "tr_title": "Память, которая ускоряет программное обеспечение для редактирования."
                  },
                  {
                    "tr_title": "Технология Thunderbolt™&nbsp;4, которая позволяет быстро передавать файлы."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I9",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Монтаж видео",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "МОНТАЖ ВИДЕО",
                "tr_subtitle": "Создавайте магию кино",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для монтажа видео.",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может обрабатывать большие файлы."
                  },
                  {
                    "tr_title": "Память, которая обеспечивает быстродействие монтажного программного обеспечения."
                  },
                  {
                    "tr_title": "Графика, которая сократит время рендеринга."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "3D-моделирование",
              "tileUrlName": "threedmodeling",
              "tileBadgeUrl": "assets/images/standard/rebuild/threedmodeling.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_threedmodeling.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "3D-МОДЕЛИРОВАНИЕ",
                "tr_subtitle": "Творчество нового уровня",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для 3D-моделирования.",
                "tileBG": "#00285A",
                "titleArray": [
                  {
                    "tr_title": "Процессор, который может работать с передовым ПО для создания контента."
                  },
                  {
                    "tr_title": "Память, которая может быстро загружать большие файлы."
                  },
                  {
                    "tr_title": "Графика для широких возможностей создания и редактирования изображений."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Совместная работа в реальном времени",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "СОВМЕСТНАЯ РАБОТА В РЕАЛЬНОМ ВРЕМЕНИ",
                "tr_subtitle": "Включайтесь в работу откуда угодно",
                "tr_subtitle1": "Вот что мы обнаружили в этом ПК, который отлично подходит для совместной работы онлайн.",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "Процессор для работы офисного программного обеспечения."
                  },
                  {
                    "tr_title": "Wi‑Fi, на который можно положиться."
                  },
                  {
                    "tr_title": "Веб-камера, которая записывает в великолепном HD-качестве."
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "unison": {
    "panelType1": "gaming-tile-panel",
    "panelType2": "unison-panel",
    "tr_tileTitle": "Приложение Intel® Unison™",
    "tr_title": "Откройте мир подключенных устройств",
    "tr_subtitle": "Простая передача файлов и фотографий при одновременном управлении уведомлениями телефона, звонками и текстовыми сообщениями с вашего ПК. <sup>18</sup>",
    "detailBGUrl": "assets/images/unison/unison_panel1_img.png",
    "tileBG": "assets/images/unison/unison_hometile_img.png",
    "titleArray": [
      {
        "tr_title": "ПЕРЕДАВАЙТЕ ФАЙЛЫ И ФОТОГРАФИИ",
        "imgUrl": "assets/images/unison/unison_img1.png"
      },
      {
        "tr_title": "СОВЕРШАЙТЕ И ПРИНИМАЙТЕ ЗВОНКИ",
        "imgUrl": "assets/images/unison/unison_img2.png"
      },
      {
        "tr_title": "ОТПРАВЛЯЙТЕ И ПОЛУЧАЙТЕ СООБЩЕНИЯ",
        "imgUrl": "assets/images/unison/unison_img3.png"
      },
      {
        "tr_title": "УПРАВЛЯЙТЕ УВЕДОМЛЕНИЯМИ ТЕЛЕФОНА",
        "imgUrl": "assets/images/unison/unison_img4.png"
      },
      {
        "tr_title": "ОТКРОЙТЕ МИР ПОДКЛЮЧЕННЫХ УСТРОЙСТВ",
        "imgUrl": "assets/images/unison/unison_img5.png"
      }
    ]
  },
  "copilot": {
    "panelType1": "gaming-tile-panel",
    "panelType2": "copilot-panel",
    "tr_tileTitle": "Больше возможностей с Copilot+",
    "tr_title": "<strong><span class ='copilot_highlight'>Получите больше</span> от ПК с Copilot+</strong> благодаря процессору [cpu_display] [cpuModel]",
    "badgeUrl": "assets/images/copilot_badge.png",
    "tileBG": "assets/images/copilot_hometile_img.png",
    "videoUrl": "assets/lang/[XX]/redesign/copilot_panel4.mp4",
    "detailBGUrl": "",
    "tr_pretitle": "Copilot+",
    "badgeIcons": [
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
        "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;5 (Серия&nbsp;2)",
        "tr_badgeSubTitle": ""
      },
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
        "tr_badgeIconTile": "Процессор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серия&nbsp;2)",
        "tr_badgeSubTitle": ""
      },
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
        "tr_badgeIconTile": "Процессор Intel® Core™ Ultra 9 (Серия 2)",
        "tr_badgeSubTitle": ""
      }
    ],
    "titleArray": [
      {
        "tr_title": "Живые субтитры",
        "tr_subtitle": "Переводите с 44 языков на английский. <span class ='copilot_subhighlight'>Проще.</span>",
        "imgUrl": "assets/images/copilot_panel1.png"
      },
      {
        "tr_title": "Соавтор",
        "tr_subtitle": "Вы создаете проект. ИИ делает его идеальным. <span class ='copilot_subhighlight'>Быстрее.</span>",
        "imgUrl": "assets/images/copilot_panel2.png"
      },
      {
        "tr_title": "Windows* Studio Effects",
        "tr_subtitle": "Представьте себя с лучшей стороны. <span class ='copilot_subhighlight'>Легко.</span>",
        "imgUrl": "assets/images/copilot_panel3.png"
      }
    ]
  },
  "deviceReview": {
    "panelType1": "evo-mtl-video-panel",
    "tr_tileTitle": "Смотреть обзор [XX]",
    "tileBG": "assets/images/device_review_hometile.svg",
    "videoUrl": "assets/lang/[XX]/redesign/device_review_video.mp4"
  }
}